export const tlingitvideoarchivesubtitles = {
    "1": {
        "1": {
            "startTime": 0.44,
            "endTime": 2.08,
            "tli": [
                [
                    "Tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "xáanaa",
                    [
                        {
                            "tlingit": "xáanaa",
                            "url": "xáanaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "evening",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "One evening"
        },
        "2": {
            "startTime": 3.58,
            "endTime": 6.47,
            "tli": [
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲áa",
                    [
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "jóoni",
                    [],
                    []
                ],
                [
                    "tóox'",
                    [
                        {
                            "tlingit": "a tóox'",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "in it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóox' at dult'ix' át",
                            "url": "a tóo at dult'ix'x̲i át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "freezer",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was in the man's dream,"
        },
        "3": {
            "startTime": 9.44,
            "endTime": 11.81,
            "tli": [
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "jóoni",
                    [],
                    []
                ],
                [
                    "tóox'",
                    [
                        {
                            "tlingit": "a tóox'",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "in it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóox' at dult'ix' át",
                            "url": "a tóo at dult'ix'x̲i át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "freezer",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "awé,",
                    [],
                    []
                ]
            ],
            "eng": "it was in his dream,"
        },
        "4": {
            "startTime": 13.6,
            "endTime": 16.75,
            "tli": [
                [
                    "dáx̲-",
                    [],
                    []
                ],
                [
                    "dáx̲",
                    [],
                    []
                ],
                [
                    "yateeyi",
                    [
                        {
                            "tlingit": "yéi yateeyi aa",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "_3Sg__"
                            ],
                            "english": "the one who is that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲áa",
                    [
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was two men"
        },
        "5": {
            "startTime": 18.33,
            "endTime": 19.93,
            "tli": [
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "one"
        },
        "6": {
            "startTime": 20.22,
            "endTime": 22.94,
            "tli": [
                [
                    "du een yaa nagút.",
                    [
                        {
                            "tlingit": "du een yaa sh kanalxúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is trying to dominate him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "aadé yaa nagút",
                            "url": "aadé woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa nagút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gánde yaa nagút",
                            "url": "gánde woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he is going to the bathroom",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a nák̲ yaa nagút",
                            "url": "a nák̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "s/he is leaving it behind",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak yaa nagút",
                            "url": "daak uwagút",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is walking into the open",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a ítx̲ yaa nagút",
                            "url": "a ítx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg__3_"
                            ],
                            "english": "he/she/it is following it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ yaa nagút",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is leaving there",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "is walking along with him."
        },
        "7": {
            "startTime": 22.96,
            "endTime": 25.99,
            "tli": [
                [
                    "Yaa has na.át.",
                    [
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yaa (ha)s ayanda.át",
                            "url": "has ayawdi.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are turning back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s ashuna.át",
                            "url": "has ashoowa.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he is leading them",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nalnétl",
                            "url": "wudlinétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting fat",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yaa (ha)s na.át",
                            "url": "áx̲ yaa (ha)s na.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking along there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s x̲'anal.át",
                            "url": "has x̲'awli.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are speaking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nadaxwétl",
                            "url": "wudixwétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting tired",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "They are walking along."
        },
        "8": {
            "startTime": 25.99,
            "endTime": 29.82,
            "tli": [
                [
                    "Neech",
                    [
                        {
                            "tlingit": "neech",
                            "url": "neech",
                            "tags": [
                                "Noun"
                            ],
                            "english": "shoreline; beach",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "káx'",
                    [
                        {
                            "tlingit": "a káx'",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "on it",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "On the shoreline"
        },
        "9": {
            "startTime": 29.82,
            "endTime": 32.94,
            "tli": [
                [
                    "yaa has na.át.",
                    [
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yaa (ha)s ayanda.át",
                            "url": "has ayawdi.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are turning back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s ashuna.át",
                            "url": "has ashoowa.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he is leading them",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nalnétl",
                            "url": "wudlinétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting fat",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yaa (ha)s na.át",
                            "url": "áx̲ yaa (ha)s na.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking along there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s x̲'anal.át",
                            "url": "has x̲'awli.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are speaking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nadaxwétl",
                            "url": "wudixwétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting tired",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "they're walking along."
        },
        "10": {
            "startTime": 32.94,
            "endTime": 38.07,
            "tli": [
                [
                    "Du-",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "du",
                    [],
                    []
                ],
                [
                    "jóoni",
                    [],
                    []
                ],
                [
                    "tóox'",
                    [
                        {
                            "tlingit": "a tóox'",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "in it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóox' at dult'ix' át",
                            "url": "a tóo at dult'ix'x̲i át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "freezer",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áyá.",
                    [
                        {
                            "tlingit": "áyá",
                            "url": "áyá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "this (right here) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "This is in his dream."
        },
        "11": {
            "startTime": 38.09,
            "endTime": 42.08,
            "tli": [
                [
                    "K̲ux̲",
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ayawulg̲einí",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When he looked back,"
        },
        "12": {
            "startTime": 42.08,
            "endTime": 44.5,
            "tli": [
                [
                    "déix̲",
                    [
                        {
                            "tlingit": "déix̲",
                            "url": "déix̲",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "two",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awsiteen",
                    [
                        {
                            "tlingit": "awsiteen",
                            "url": "awsiteen",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he sees him/her/it; s/he saw him/her/it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "he saw two"
        },
        "13": {
            "startTime": 44.52,
            "endTime": 48.46,
            "tli": [
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲'us.eetí,",
                    [
                        {
                            "tlingit": "a x̲'us.eetí",
                            "url": "a x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "its tracks",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'us.eetí",
                            "url": "du x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her footprint",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lk̲'ayáak'w x̲'us.eetí",
                            "url": "lk̲'ayáak'w x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Milky Way",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "sets of footprints,"
        },
        "14": {
            "startTime": 48.46,
            "endTime": 51.65,
            "tli": [
                [
                    "yaa has na.át,",
                    [
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yaa (ha)s ayanda.át",
                            "url": "has ayawdi.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are turning back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s ashuna.át",
                            "url": "has ashoowa.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he is leading them",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nalnétl",
                            "url": "wudlinétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting fat",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yaa (ha)s na.át",
                            "url": "áx̲ yaa (ha)s na.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking along there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s x̲'anal.át",
                            "url": "has x̲'awli.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are speaking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nadaxwétl",
                            "url": "wudixwétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting tired",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "they're walking along,"
        },
        "15": {
            "startTime": 51.65,
            "endTime": 55.69,
            "tli": [
                [
                    "ayatéen",
                    [
                        {
                            "tlingit": "ayatéen",
                            "url": "ayatéen",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he can see it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲'us.eetí.",
                    [
                        {
                            "tlingit": "a x̲'us.eetí",
                            "url": "a x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "its tracks",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'us.eetí",
                            "url": "du x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her footprint",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lk̲'ayáak'w x̲'us.eetí",
                            "url": "lk̲'ayáak'w x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Milky Way",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "he sees the footprints."
        },
        "16": {
            "startTime": 55.69,
            "endTime": 60.01,
            "tli": [
                [
                    "Wáa",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yatéex'",
                    [],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "k̲ux̲",
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "alg̲énji,",
                    [],
                    []
                ]
            ],
            "eng": "Sometimes when he looks back,"
        },
        "17": {
            "startTime": 60.03,
            "endTime": 63.82,
            "tli": [
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "nateech.",
                    [
                        {
                            "tlingit": "yéi nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ nateech",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ nateech",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needs it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi nateech",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg__"
                            ],
                            "english": "he/she/it become still (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at nateech",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he feeds him/her/it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi nateech",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stays with him/her (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du wak̲shiyeex' yéi nateech",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it appears before him/her (every time)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "there's just one."
        },
        "18": {
            "startTime": 63.82,
            "endTime": 68.46,
            "tli": [
                [
                    "Dikée Aank̲áawu",
                    [
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikáank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikée aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "aank̲áawu",
                            "url": "aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "rich man; man of wealth; chief",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Aank̲áawu",
                            "url": "Aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God, Lord",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "du een yaa",
                    [
                        {
                            "tlingit": "du een yaa sh kanalxúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is trying to dominate him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du een aa",
                            "url": "du een aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her kinsman, moiety mate",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een dak̲áan",
                            "url": "du een wudik̲án",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is quarreling with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(du een) k̲ulagaaw",
                            "url": "(du een) k̲uwligaaw",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is fighting (him/her)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kag̲alxúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3Sg_"
                            ],
                            "english": "let him/her try to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een woosh x̲'adaxéet",
                            "url": "du een woosh x̲'awdixéet",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is arguing with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "na.át.",
                    [
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yei (ha)s na.át",
                            "url": "áx̲ has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yaa (ha)s na.át",
                            "url": "áx̲ yaa (ha)s na.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking along there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei (ha)s na.át",
                            "url": "k̲ut has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa (ha)s na.át",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa (ha)s na.át",
                            "url": "át has uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are going there",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "It's God walking along with him."
        },
        "19": {
            "startTime": 68.46,
            "endTime": 73.9,
            "tli": [
                [
                    "Yaa has na.át.",
                    [
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yaa (ha)s ayanda.át",
                            "url": "has ayawdi.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are turning back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s ashuna.át",
                            "url": "has ashoowa.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he is leading them",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nalnétl",
                            "url": "wudlinétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting fat",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yaa (ha)s na.át",
                            "url": "áx̲ yaa (ha)s na.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking along there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s x̲'anal.át",
                            "url": "has x̲'awli.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are speaking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s nadaxwétl",
                            "url": "wudixwétl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting tired",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "They're walking along."
        },
        "20": {
            "startTime": 73.9,
            "endTime": 78.39,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awusteení",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲'eiwawóos',",
                    [
                        {
                            "tlingit": "ax̲'eiwawóos'",
                            "url": "ax̲'eiwawóos'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he asked him/her",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So when he saw (just) one, he asked Him,"
        },
        "21": {
            "startTime": 78.39,
            "endTime": 80.9,
            "tli": [
                [
                    "\"Wáanáx̲",
                    [],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ]
            ],
            "eng": "\"Why is it,"
        },
        "22": {
            "startTime": 80.9,
            "endTime": 84.54,
            "tli": [
                [
                    "Dikée Aank̲áawu,",
                    [
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikáank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikée aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "aank̲áawu",
                            "url": "aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "rich man; man of wealth; chief",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Aank̲áawu",
                            "url": "Aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God, Lord",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "wáanáx̲",
                    [],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ]
            ],
            "eng": "God, why"
        },
        "23": {
            "startTime": 84.55,
            "endTime": 89.26,
            "tli": [
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲'us.eetí",
                    [
                        {
                            "tlingit": "a x̲'us.eetí",
                            "url": "a x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "its tracks",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'us.eetí",
                            "url": "du x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her footprint",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lk̲'ayáak'w x̲'us.eetí",
                            "url": "lk̲'ayáak'w x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Milky Way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲aatéen?",
                    [
                        {
                            "tlingit": "x̲aatéen",
                            "url": "ayatéen",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "1Sg_3__"
                            ],
                            "english": "I can see it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "do I only see one set of footprints?"
        },
        "24": {
            "startTime": 89.26,
            "endTime": 93.97,
            "tli": [
                [
                    "Wáanáx̲",
                    [],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "nák̲",
                    [
                        {
                            "tlingit": "a nák̲",
                            "url": "a nák̲",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "(going, taking something) away from it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has nák̲",
                            "url": "has nák̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are standing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A nák̲ nagú!",
                            "url": "a nák̲ woogoot",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Leave it behind!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has nák̲ nooch",
                            "url": "has wudinaak̲",
                            "tags": [
                                "Verb",
                                "imperfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they always stand up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a nák̲ ayawdihaan",
                            "url": "a nák̲ ayawdihaan",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he fled from it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a nák̲ haa wdikéil'",
                            "url": "a nák̲ has wudikéil'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl_3_"
                            ],
                            "english": "we fled from it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a nák̲ woogoot",
                            "url": "a nák̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he left it behind",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yigoot?",
                    [
                        {
                            "tlingit": "tlél át yigoot",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___3"
                            ],
                            "english": "you didn't arrive there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél kei yigoot",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___"
                            ],
                            "english": "you didn't go up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél áx̲ yigoot",
                            "url": "áx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___3"
                            ],
                            "english": "you didn't walk down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél k̲ut yigoot",
                            "url": "k̲ut woogoot",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___"
                            ],
                            "english": "you didn't get lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél aadé yigoot",
                            "url": "aadé woogoot",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___3"
                            ],
                            "english": "you didn't go there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél gági yigoot",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg___"
                            ],
                            "english": "you didn't come out",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "Why is it you left me?"
        },
        "25": {
            "startTime": 93.98,
            "endTime": 100.48,
            "tli": [
                [
                    "Ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléináx̲",
                    [
                        {
                            "tlingit": "tléináx̲",
                            "url": "tléináx̲",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one (person)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaa nx̲agút.\"",
                    [
                        {
                            "tlingit": "aadé yaa nx̲agút",
                            "url": "aadé woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___3"
                            ],
                            "english": "I am going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa nx̲agút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___3"
                            ],
                            "english": "I am going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gági yaa nx̲agút",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___"
                            ],
                            "english": "I am coming out",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "kei nx̲agút",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___"
                            ],
                            "english": "I am going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yei nx̲agút",
                            "url": "áx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___3"
                            ],
                            "english": "I am walking down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei nx̲agút",
                            "url": "k̲ut woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___"
                            ],
                            "english": "I am getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "I'm just walking alone.\""
        },
        "26": {
            "startTime": 100.48,
            "endTime": 106.25,
            "tli": [
                [
                    "Dikée Aank̲áawu",
                    [
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikáank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Dikée aank̲áawu",
                            "url": "Dikée aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "aank̲áawu",
                            "url": "aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "rich man; man of wealth; chief",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Aank̲áawu",
                            "url": "Aank̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "God, Lord",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "God"
        },
        "27": {
            "startTime": 106.25,
            "endTime": 112.01,
            "tli": [
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yawsik̲aa,",
                    [],
                    []
                ]
            ],
            "eng": "said,"
        },
        "28": {
            "startTime": 112.02,
            "endTime": 115.95,
            "tli": [
                [
                    "\"Ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "eeteení",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "\"When you just see one"
        },
        "29": {
            "startTime": 115.95,
            "endTime": 120.7,
            "tli": [
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲'us.eetí,",
                    [
                        {
                            "tlingit": "a x̲'us.eetí",
                            "url": "a x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "its tracks",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'us.eetí",
                            "url": "du x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her footprint",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lk̲'ayáak'w x̲'us.eetí",
                            "url": "lk̲'ayáak'w x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Milky Way",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "set of footprints,"
        },
        "30": {
            "startTime": 126.37,
            "endTime": 129.88,
            "tli": [
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ayawsik̲aa,",
                    [
                        {
                            "tlingit": "ayawsik̲aa",
                            "url": "ayawsik̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he charged for it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "He said to him again,"
        },
        "31": {
            "startTime": 129.88,
            "endTime": 136.46,
            "tli": [
                [
                    "\"Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲'alitseeni,",
                    [],
                    []
                ],
                [
                    "x̲'alitseeni",
                    [],
                    []
                ],
                [
                    "yátk'u",
                    [
                        {
                            "tlingit": "du yátk'u",
                            "url": "atk'átsk'u",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its child",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "\"My precious, precious child,"
        },
        "32": {
            "startTime": 136.47,
            "endTime": 142.68,
            "tli": [
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléináx̲",
                    [
                        {
                            "tlingit": "tléináx̲",
                            "url": "tléináx̲",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one (person)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "eeteení",
                    [],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲'us.eetí,",
                    [
                        {
                            "tlingit": "a x̲'us.eetí",
                            "url": "a x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "its tracks",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'us.eetí",
                            "url": "du x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her footprint",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lk̲'ayáak'w x̲'us.eetí",
                            "url": "lk̲'ayáak'w x̲'us.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Milky Way",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "when you see just one set of footprints,"
        },
        "33": {
            "startTime": 142.68,
            "endTime": 145.6,
            "tli": [
                [
                    "toowúnéekw",
                    [],
                    []
                ],
                [
                    "gaaw,",
                    [
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "time",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bell",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw3",
                            "tags": [
                                "Noun"
                            ],
                            "english": "drum",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw4",
                            "tags": [
                                "Noun"
                            ],
                            "english": "clock",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "sorrowful times,"
        },
        "34": {
            "startTime": 145.6,
            "endTime": 148.38,
            "tli": [
                [
                    "tle",
                    [
                        {
                            "tlingit": "tle",
                            "url": "tle",
                            "tags": [
                                "Particle"
                            ],
                            "english": "just, simply; just then",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kaxéel'",
                    [
                        {
                            "tlingit": "kaxéel'",
                            "url": "kaxéel'",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trouble; conflict",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gaaw,",
                    [
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "time",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bell",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw3",
                            "tags": [
                                "Noun"
                            ],
                            "english": "drum",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw4",
                            "tags": [
                                "Noun"
                            ],
                            "english": "clock",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "troubled times,"
        },
        "35": {
            "startTime": 148.38,
            "endTime": 154.53,
            "tli": [
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "neegúdi",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléix'",
                    [
                        {
                            "tlingit": "tléix'",
                            "url": "tléix'",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "iyatéen,",
                    [
                        {
                            "tlingit": "iyatéen",
                            "url": "ayatéen",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "2Sg_3__"
                            ],
                            "english": "you can see it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "you're going (throug̲), and you only see one,"
        },
        "36": {
            "startTime": 154.53,
            "endTime": 162.79,
            "tli": [
                [
                    "aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áa yaa",
                    [
                        {
                            "tlingit": "áa yaa sh nalx̲án",
                            "url": "áa sh wudlix̲án",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___3"
                            ],
                            "english": "he/she/it is beginning to take a liking to him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(áa) yaa analxách",
                            "url": "(áa) awlixaach",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___3"
                            ],
                            "english": "s/he's giving up hope (on it)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "áa",
                            "url": ".áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sits; s/he is sitting",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "áa",
                            "url": "áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "lake",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "inax̲sanuk",
                    [],
                    []
                ],
                [
                    "yé",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.\"",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "that's where I am picking you up and carrying you.\""
        },
        "37": {
            "startTime": 162.8,
            "endTime": 166.48,
            "tli": [
                [
                    "Aak'é,",
                    [],
                    []
                ]
            ],
            "eng": "A good one,"
        },
        "38": {
            "startTime": 166.48,
            "endTime": 170.35,
            "tli": [
                [
                    "aak'é",
                    [
                        {
                            "tlingit": "wook'éi",
                            "url": "wook'éi",
                            "tags": [
                                "Verb"
                            ],
                            "english": "he/she/it was good; he/she/it got better; he/she/it was fine; he/she/it was pretty",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sh daa yoo",
                    [
                        {
                            "tlingit": "sh daa adalóox'",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he pees himself/herself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh daa aydil'íl'",
                            "url": "sh daa awdil'íl'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg___"
                            ],
                            "english": "you pooped yourself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A daa yoo tutánk!",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3_"
                            ],
                            "english": "Think about it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa yoo tuyli.átk",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "2Pl__3_"
                            ],
                            "english": "you all think about it (regularly); you all are thinking about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daa yoo ayadák̲k",
                            "url": "du daa aawadaak̲",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he sobers up (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh daa eedalóox'",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "2Sg___"
                            ],
                            "english": "you pee yourself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh daa aydilúx'",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg___"
                            ],
                            "english": "you peed yourself",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "sh dagwáal",
                            "url": "sh wudigwál",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg"
                            ],
                            "english": "it's ringing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh istáan",
                            "url": "sh istáan",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is lying down",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh wudlixoon",
                            "url": "sh wudlixoon",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he lost weight",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kalnik nooch",
                            "url": "sh kawdlineek",
                            "tags": [
                                "Verb",
                                "imperfective_habitual",
                                "3Sg___"
                            ],
                            "english": "s/he always tells stories",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kawdlishoo",
                            "url": "sh kawdlishoo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went crazy",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "tudatánk",
                    [],
                    []
                ],
                [
                    "áyá",
                    [
                        {
                            "tlingit": "áyá",
                            "url": "áyá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "this (right here) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "this is a good thoug̲t about oneself"
        },
        "39": {
            "startTime": 170.35,
            "endTime": 175.67,
            "tli": [
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléináx̲",
                    [
                        {
                            "tlingit": "tléináx̲",
                            "url": "tléináx̲",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "one (person)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "i toowú",
                    [
                        {
                            "tlingit": "I toowú ksagóo!",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperative",
                                "__2Sg_"
                            ],
                            "english": "Be happy!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "I toowú kaklag̲éi!",
                            "url": "du toowú kawlig̲éi",
                            "tags": [
                                "Verb",
                                "imperative",
                                "__2Sg_"
                            ],
                            "english": "Be proud!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl i toowú ult'úchx̲ik̲!",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective_prohibitive",
                                "__2Sg_"
                            ],
                            "english": "Don't be disappointed!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl i toowú koowál'x̲ik̲!",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective_prohibitive",
                                "__2Sg_"
                            ],
                            "english": "Don't be disappointed!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú néekw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú nóok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú klag̲é",
                            "url": "toowú klag̲é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "pride; self-esteem, feeling good about oneself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú latseen",
                            "url": "toowú latseen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "strength of mind or heart; courage; resolve",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú yak'éi",
                            "url": "du toowú wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "wuteeyí,",
                    [],
                    []
                ]
            ],
            "eng": "when you feel alone,"
        },
        "40": {
            "startTime": 175.67,
            "endTime": 180.46,
            "tli": [
                [
                    "toowúnéekw",
                    [],
                    []
                ],
                [
                    "gaaw",
                    [
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "time",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bell",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw3",
                            "tags": [
                                "Noun"
                            ],
                            "english": "drum",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw4",
                            "tags": [
                                "Noun"
                            ],
                            "english": "clock",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch'a",
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kaxéel'",
                    [
                        {
                            "tlingit": "kaxéel'",
                            "url": "kaxéel'",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trouble; conflict",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gaaw",
                    [
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "time",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bell",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw3",
                            "tags": [
                                "Noun"
                            ],
                            "english": "drum",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw4",
                            "tags": [
                                "Noun"
                            ],
                            "english": "clock",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "times of sorrow and times of trouble"
        },
        "41": {
            "startTime": 180.46,
            "endTime": 184.62,
            "tli": [
                [
                    "a tóonáx̲ yaa",
                    [
                        {
                            "tlingit": "a tóonáx̲ yaa nak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "s/he is driving through it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yaa k̲úx̲ch",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "s/he drives through it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl a tóonáx̲ yaa eek̲úx̲juk̲!",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "prohibitive",
                                "2Sg"
                            ],
                            "english": "Don't drive through it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl a tóonáx̲ yaa yeek̲úx̲juk̲!",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "prohibitive",
                                "2Pl"
                            ],
                            "english": "Don't you all drive through it!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a tóonáx̲",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "perlative"
                            ],
                            "english": "through the inside of it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tóonáx̲ k̲aateen",
                            "url": "tóonáx̲ k̲aateen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "mirror",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a tóonáx̲ yaawak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he drove through it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yakg̲wak̲óox̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "future",
                                "3"
                            ],
                            "english": "s/he will drive through it",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "neegúdi,",
                    [],
                    []
                ]
            ],
            "eng": "when you're going throug̲ it,"
        },
        "42": {
            "startTime": 184.62,
            "endTime": 187.9,
            "tli": [
                [
                    "a káa daak",
                    [
                        {
                            "tlingit": "a káa daak asawliháa",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "s/he reminded him/her about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa daak sax̲wliháa",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3Sg_3_"
                            ],
                            "english": "I reminded him/her about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa daak asax̲laháa",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "let him/her remind him/her about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa daak asalahéini",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "if/when s/he reminds him/her about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa daak asalahéich",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "s/he reminds him/her about it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A káa daak salaháa!",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3Sg_3_"
                            ],
                            "english": "Remind him/her about it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa daak aseelháaych",
                            "url": "a káa daak asawliháa",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "s/he reminds him/her about it (every time)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a káa",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "on it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "káa",
                            "url": "káa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "car, automobile",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "daak",
                            "url": "daak",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "out to sea; out into the open; (falling) down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "isax̲lahéich.",
                    [],
                    []
                ]
            ],
            "eng": "I always remind you about it."
        },
        "43": {
            "startTime": 187.91,
            "endTime": 193.15,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲ toowú",
                    [
                        {
                            "tlingit": "ax̲ toowú sigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I am happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú wlit'úch",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I'm disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú kaawawál'",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I'm disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú wsigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I became happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú gax̲sagóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__1Sg_"
                            ],
                            "english": "let me be happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú ksagwéich",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__1Sg_"
                            ],
                            "english": "I get happy (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél ax̲ toowú wushgóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "__1Sg_"
                            ],
                            "english": "I wasn't happy",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú néekw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú nóok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa toowú lat'aa",
                            "url": "k̲aa toowú lat'aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "comfort",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú klag̲é",
                            "url": "toowú klag̲é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "pride; self-esteem, feeling good about oneself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú latseen",
                            "url": "toowú latseen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "strength of mind or heart; courage; resolve",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "wootee",
                    [
                        {
                            "tlingit": "yéi wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it was that way; he/she/it became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ wootee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi wootee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stayed with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du wak̲shiyeex' yéi wootee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it appeared before him/her",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tatgé.",
                    [
                        {
                            "tlingit": "tatgé",
                            "url": "tatgé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "yesterday",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That's how I felt yesterday."
        },
        "44": {
            "startTime": 193.15,
            "endTime": 200.11,
            "tli": [
                [
                    "X'oonínáx̲",
                    [],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "jeedáx̲",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kawdixéel'",
                    [],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dachx̲ánx'iyán.",
                    [],
                    []
                ]
            ],
            "eng": "How many were they, we lost them, my grandchildren."
        },
        "45": {
            "startTime": 200.12,
            "endTime": 205.95,
            "tli": [
                [
                    "Nás'gináx̲",
                    [
                        {
                            "tlingit": "nás'gináx̲",
                            "url": "nás'gináx̲",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "three (people)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲ut",
                    [
                        {
                            "tlingit": "k̲ut",
                            "url": "k̲ut",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "astray, getting lost",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wutuwag̲éex'",
                    [],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was three people we lost"
        },
        "46": {
            "startTime": 205.95,
            "endTime": 211.05,
            "tli": [
                [
                    "nás'k",
                    [
                        {
                            "tlingit": "nás'k",
                            "url": "nás'k",
                            "tags": [
                                "Numeral"
                            ],
                            "english": "three",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "táakw",
                    [
                        {
                            "tlingit": "táakw",
                            "url": "táakw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "winter; year",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tóonáx̲",
                    [
                        {
                            "tlingit": "a tóonáx̲",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "perlative"
                            ],
                            "english": "through the inside of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóonáx̲ k̲aateen",
                            "url": "tóonáx̲ k̲aateen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "mirror",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A tóonáx̲ yuk̲úx̲!",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Drive through it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ wuk̲úx̲ch",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "s/he drives through it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A tóonáx̲ yeeyk̲úx̲!",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Pl"
                            ],
                            "english": "You all drive through it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yaawak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he drove through it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yaa nak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "s/he is driving through it",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "throug̲ three years"
        },
        "47": {
            "startTime": 211.05,
            "endTime": 215.11,
            "tli": [
                [
                    "a tóonáx̲",
                    [
                        {
                            "tlingit": "a tóonáx̲",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "perlative"
                            ],
                            "english": "through the inside of it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "tóonáx̲ k̲aateen",
                            "url": "tóonáx̲ k̲aateen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "mirror",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ wuk̲úx̲ch",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "s/he drives through it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a tóonáx̲ yaawak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he drove through it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A tóonáx̲ yuk̲úx̲!",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Drive through it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yaa nak̲úx̲",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "s/he is driving through it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóonáx̲ yaa k̲úx̲ch",
                            "url": "a tóonáx̲ yaawak̲úx̲",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "s/he drives through it (regularly)",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yawtuwa.át.",
                    [
                        {
                            "tlingit": "du jikaadáx̲ yawtuwa.át",
                            "url": "du jikaadáx̲ has yaawa.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Pl__3Sg_"
                            ],
                            "english": "we got out of his/her way",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "we went throug̲ that."
        },
        "48": {
            "startTime": 219.42,
            "endTime": 222.14,
            "tli": [
                [
                    "Dei",
                    [
                        {
                            "tlingit": "dei",
                            "url": "de",
                            "tags": [
                                "Particle"
                            ],
                            "english": "already, (by) now",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dei",
                            "url": "dei",
                            "tags": [
                                "Noun"
                            ],
                            "english": "path, trail; road, street",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch'áakw",
                    [
                        {
                            "tlingit": "ch'áakw",
                            "url": "ch'áakw",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "long ago; back then; in the old days",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ch'áakw",
                            "url": "ch'ákw",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "long ago; back then; in the old days",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áyá",
                    [
                        {
                            "tlingit": "áyá",
                            "url": "áyá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "this (right here) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was a long time ago now"
        },
        "49": {
            "startTime": 222.14,
            "endTime": 226.29,
            "tli": [
                [
                    "kax̲wshixít",
                    [
                        {
                            "tlingit": "kax̲wshixít",
                            "url": "akawshixít",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I wrote it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shkalneek.",
                    [
                        {
                            "tlingit": "shkalneek",
                            "url": "shkalneek",
                            "tags": [
                                "Noun"
                            ],
                            "english": "story",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I wrote this story down."
        },
        "50": {
            "startTime": 226.3,
            "endTime": 231.04,
            "tli": [
                [
                    "Wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": ""
        },
        "51": {
            "startTime": 231.06,
            "endTime": 237.59,
            "tli": [
                [
                    "funeral",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gax̲dusneiyí",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When they were going to have the funeral,"
        },
        "52": {
            "startTime": 237.59,
            "endTime": 244.36,
            "tli": [
                [
                    "wé ax̲",
                    [
                        {
                            "tlingit": "wé ax̲ éex̲ dashee aa",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg__1Sg_"
                            ],
                            "english": "the one who helps me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wé ax̲ x̲'éit yawdzi.aayi aa",
                            "url": "ax̲ x̲'éit yawdzi.áa",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg__1Sg_"
                            ],
                            "english": "the one who kissed me",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x̲ooní",
                    [
                        {
                            "tlingit": "a x̲ooní",
                            "url": "a x̲ooní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "one that matches it; an amount that matches it; equivalent to it; one like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ooní",
                            "url": "du x̲ooní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her relative, friend; his/her tribesman",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲ánt",
                    [
                        {
                            "tlingit": "du x̲ánt",
                            "url": "du x̲án",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "next to him/her",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "uwagút.",
                    [
                        {
                            "tlingit": "át uwagút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he arrived there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei uwagút",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak uwagút",
                            "url": "daak uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it walked into the open",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gági uwagút",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he came out",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "my relative came to me."
        },
        "53": {
            "startTime": 244.38,
            "endTime": 253.98,
            "tli": [
                [
                    "\"Téew",
                    [],
                    []
                ],
                [
                    "x'wán",
                    [
                        {
                            "tlingit": "x'wán",
                            "url": "x'wán",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boot(s)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "x'wán",
                            "url": "x'wán2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "be sure to",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kayshidi",
                    [],
                    []
                ],
                [
                    "aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shkalneek.\"",
                    [
                        {
                            "tlingit": "shkalneek",
                            "url": "shkalneek",
                            "tags": [
                                "Noun"
                            ],
                            "english": "story",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "\"Be sure to read the story you wrote down.\""
        },
        "54": {
            "startTime": 253.98,
            "endTime": 261.98,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has du een",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du een aa",
                            "url": "du een aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her kinsman, moiety mate",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een dak̲áan",
                            "url": "du een wudik̲án",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is quarreling with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(du een) k̲ulagaaw",
                            "url": "(du een) k̲uwligaaw",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is fighting (him/her)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kalxútsni",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg__3Sg_"
                            ],
                            "english": "if/when s/he tries to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) du een woosh x̲'anax̲daxéet",
                            "url": "du een woosh x̲'awdixéet",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3Sg_"
                            ],
                            "english": "(just) let him/her argue with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du een k̲unáax̲ daak̲ kaneek!",
                            "url": "du een k̲unáax̲ daak̲ akaawaník",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Explain it to him/her!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x̲waatéew.",
                    [],
                    []
                ],
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yeedát",
                    [
                        {
                            "tlingit": "yeedát",
                            "url": "yeedát",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "now",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So I read it to them. Now"
        },
        "55": {
            "startTime": 261.98,
            "endTime": 267.56,
            "tli": [
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "goodé",
                    [],
                    []
                ],
                [
                    "sá",
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲ut",
                    [
                        {
                            "tlingit": "k̲ut",
                            "url": "k̲ut",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "astray, getting lost",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wooxeex,",
                    [
                        {
                            "tlingit": "(k'eeljáa) wooxeex",
                            "url": "(k'eeljáa) wooxeex",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg"
                            ],
                            "english": "it blew",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I don't know where it got off to,"
        },
        "56": {
            "startTime": 267.56,
            "endTime": 273.25,
            "tli": [
                [
                    "we",
                    [],
                    []
                ],
                [
                    "kax̲wshixidi",
                    [],
                    []
                ],
                [
                    "shkalneek.",
                    [
                        {
                            "tlingit": "shkalneek",
                            "url": "shkalneek",
                            "tags": [
                                "Noun"
                            ],
                            "english": "story",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the story I wrote down."
        },
        "57": {
            "startTime": 273.26,
            "endTime": 276.73,
            "tli": [
                [
                    "Wutoot'eiyí",
                    [],
                    []
                ],
                [
                    "gwál",
                    [
                        {
                            "tlingit": "gwál",
                            "url": "gwál",
                            "tags": [
                                "Particle"
                            ],
                            "english": "perhaps",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "If we find it maybe"
        },
        "58": {
            "startTime": 276.73,
            "endTime": 284.06,
            "tli": [
                [
                    "Facepod-i",
                    [],
                    []
                ],
                [
                    "yéi gax̲tusanéi.",
                    [
                        {
                            "tlingit": "yéi gax̲tusanéi",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "future",
                                "1Pl_3__"
                            ],
                            "english": "we will fix it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "we'll do a Facepod."
        },
        "59": {
            "startTime": 284.06,
            "endTime": 287.67,
            "tli": [
                [
                    "Uh,",
                    [],
                    []
                ]
            ],
            "eng": ""
        },
        "60": {
            "startTime": 287.68,
            "endTime": 289.81,
            "tli": [
                [
                    "",
                    [],
                    []
                ]
            ],
            "eng": ""
        },
        "61": {
            "startTime": 289.82,
            "endTime": 292.87,
            "tli": [
                [
                    "a yáanáx̲",
                    [
                        {
                            "tlingit": "a yáanáx̲",
                            "url": "a yá",
                            "tags": [
                                "RelationalNoun",
                                "perlative"
                            ],
                            "english": "through the face of it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a yáanáx̲",
                            "url": "a yáanáx̲",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "beyond it, more than it; too much; excessively",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yáanáx̲",
                            "url": "yá",
                            "tags": [
                                "Demonstrative",
                                "perlative"
                            ],
                            "english": "through here",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yak'éi",
                    [
                        {
                            "tlingit": "yak'éi",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is good",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it's better than the"
        },
        "62": {
            "startTime": 292.87,
            "endTime": 297.0,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲'éidáx̲",
                    [
                        {
                            "tlingit": "a x̲'éidáx̲",
                            "url": "a x̲'é",
                            "tags": [
                                "RelationalNoun",
                                "ablative"
                            ],
                            "english": "from its mouth",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'éidáx̲ kashxeedí",
                            "url": "k̲aa x̲'éidáx̲ kashxeedí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "secretary (stenographer)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲'éidáx̲ shuyawjix̲ín",
                            "url": "a x̲'éidáx̲ shuyawjix̲ín",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3_"
                            ],
                            "english": "it opened",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲'éidáx̲ shuwushx̲ínni",
                            "url": "a x̲'éidáx̲ shuyawjix̲ín",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3_"
                            ],
                            "english": "if/when it opens",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲'éidáx̲ shuwug̲ashx̲een",
                            "url": "a x̲'éidáx̲ shuyawjix̲ín",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__3_"
                            ],
                            "english": "let it open",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲'éidáx̲ shuwooshx̲ínch",
                            "url": "a x̲'éidáx̲ shuyawjix̲ín",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3_"
                            ],
                            "english": "it opens (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲'éidáx̲ yaa shushx̲ínch",
                            "url": "a x̲'éidáx̲ shuyawjix̲ín",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3_"
                            ],
                            "english": "it opens (regularly)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "shkalneek,",
                    [
                        {
                            "tlingit": "shkalneek",
                            "url": "shkalneek",
                            "tags": [
                                "Noun"
                            ],
                            "english": "story",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kax̲wshixidi",
                    [],
                    []
                ],
                [
                    "aa.",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "story I told, the one I wrote down."
        },
        "63": {
            "startTime": 297.01,
            "endTime": 302.56,
            "tli": [
                [
                    "Ch'a a",
                    [
                        {
                            "tlingit": "(ch'a) a káx̲ akax̲laneek",
                            "url": "a káx̲ akawliník",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3Sg_3_"
                            ],
                            "english": "(just) let him/her defraud him/her of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) a káa yan yag̲adaa",
                            "url": "a káa yan yaawadáa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3_"
                            ],
                            "english": "(just) let him/her keep an eye on him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) a nák̲ ayanax̲dahaan",
                            "url": "a nák̲ ayawdihaan",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3_"
                            ],
                            "english": "(just) let him/her flee from it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) a daatx̲ k̲ux̲ tux̲dataan",
                            "url": "a daatx̲ k̲ux̲ tuwditán",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3_"
                            ],
                            "english": "(just) let him/her change his/her mind about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) a daatx̲ k̲ux̲ has tug̲al.aat",
                            "url": "a daatx̲ k̲ux̲ has tuwdli.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl__3_"
                            ],
                            "english": "(just) let them change their minds about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) a nák̲ has nax̲dakéil' (de)",
                            "url": "a nák̲ has wudikéil'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Pl_3_"
                            ],
                            "english": "(just) let them flee from it (now)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "ch'a",
                            "url": "ch'a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "the very, just",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "shóok'",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yee",
                    [
                        {
                            "tlingit": "yee",
                            "url": "yee",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (plural) [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yee",
                            "url": "yee2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "you (plural) [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kax̲waaneek",
                    [
                        {
                            "tlingit": "kax̲waaneek",
                            "url": "akaawaneek",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I told about it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yeedát.",
                    [
                        {
                            "tlingit": "yeedát",
                            "url": "yeedát",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "now",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I just told you all the ending of it now."
        },
        "64": {
            "startTime": 302.56,
            "endTime": 307.3,
            "tli": [
                [
                    "Aáa",
                    [],
                    []
                ],
                [
                    "yak'éi",
                    [
                        {
                            "tlingit": "yak'éi",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is good",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yoo x̲'atánk",
                    [
                        {
                            "tlingit": "yoo x̲'atánk",
                            "url": "yoo x̲'atánk",
                            "tags": [
                                "Noun"
                            ],
                            "english": "speech, talk; language; word, phrase, sentence, or discourse",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "kashóok' yoo x̲'atánk",
                            "url": "kashóok' yoo x̲'atánk",
                            "tags": [
                                "Noun"
                            ],
                            "english": "email",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa k̲ududziteeyi yoo x̲'atánk",
                            "url": "a káa k̲ududziteeyi yoo x̲'atánk",
                            "tags": [
                                "Noun"
                            ],
                            "english": "law, words one lives by",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yoo",
                            "url": "yoo",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "back and forth; to and fro; up and down",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "k̲ú",
                    [],
                    []
                ],
                [
                    "áyá,",
                    [
                        {
                            "tlingit": "áyá",
                            "url": "áyá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "this (right here) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes, these are good words thoug̲,"
        },
        "65": {
            "startTime": 307.31,
            "endTime": 310.86,
            "tli": [
                [
                    "I toowú",
                    [
                        {
                            "tlingit": "I toowú ksagóo!",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperative",
                                "__2Sg_"
                            ],
                            "english": "Be happy!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "I toowú kaklag̲éi!",
                            "url": "du toowú kawlig̲éi",
                            "tags": [
                                "Verb",
                                "imperative",
                                "__2Sg_"
                            ],
                            "english": "Be proud!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl i toowú ult'úchx̲ik̲!",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective_prohibitive",
                                "__2Sg_"
                            ],
                            "english": "Don't be disappointed!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl i toowú koowál'x̲ik̲!",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective_prohibitive",
                                "__2Sg_"
                            ],
                            "english": "Don't be disappointed!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú néekw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú nóok",
                            "url": "toowú nóok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "sorrow; sadness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú klag̲é",
                            "url": "toowú klag̲é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "pride; self-esteem, feeling good about oneself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú latseen",
                            "url": "toowú latseen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "strength of mind or heart; courage; resolve",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú yak'éi",
                            "url": "du toowú wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "kaxéel'",
                    [
                        {
                            "tlingit": "kaxéel'",
                            "url": "kaxéel'",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trouble; conflict",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "for your troubled mind and"
        },
        "66": {
            "startTime": 310.86,
            "endTime": 315.21,
            "tli": [
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "toowúnéegu",
                    [],
                    []
                ],
                [
                    "yís.",
                    [
                        {
                            "tlingit": "a yís",
                            "url": "a yís",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "for it; to that end",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "for your sadness."
        },
        "67": {
            "startTime": 315.21,
            "endTime": 318.34,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That's it."
        }
    },
    "2": {
        "1": {
            "startTime": 0.64,
            "endTime": 2.331,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "2": {
            "startTime": 2.331,
            "endTime": 6.009,
            "tli": [
                [
                    "1912 áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [],
                    []
                ]
            ],
            "eng": "In 1912"
        },
        "3": {
            "startTime": 6.009,
            "endTime": 9.755,
            "tli": [
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yáx̲",
                    [
                        {
                            "tlingit": "a yáx̲",
                            "url": "a yá",
                            "tags": [
                                "RelationalNoun",
                                "pertingent"
                            ],
                            "english": "along the face of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲",
                            "url": "a yáx̲",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "like it, in accordance with it, as much as it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gaaw yáx̲",
                            "url": "gaaw yáx̲",
                            "tags": [
                                "Noun"
                            ],
                            "english": "on time; in time",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ yatee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ kaaxát",
                            "url": "a yáx̲ kaaxát",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3_"
                            ],
                            "english": "it looks like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du yáx̲ taawa.ás",
                            "url": "du yáx̲ taawa.ás",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he misses him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Wooch yáx̲ nasné!",
                            "url": "wooch yáx̲ awsinei",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Straighten it out!",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲ugax̲dustee,",
                    [],
                    []
                ]
            ],
            "eng": "they were going to live like white people,"
        },
        "4": {
            "startTime": 9.755,
            "endTime": 10.63,
            "tli": [
                [
                    "K̲éix̲’,",
                    [],
                    []
                ]
            ],
            "eng": "Kake,"
        },
        "5": {
            "startTime": 10.63,
            "endTime": 14.368,
            "tli": [
                [
                    "K̲éix̲’",
                    [],
                    []
                ],
                [
                    "K̲wáan.",
                    [
                        {
                            "tlingit": "a k̲wáan",
                            "url": "a k̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person or people from that place",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Áak'w K̲wáan",
                            "url": "Áak'w K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "people of Auke Bay, southern Lynn Canal, Juneau area, and northern Admiralty Island",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Kooya K̲wáan",
                            "url": "Kooya K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Kuiu Island people",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Hinyaa K̲wáan",
                            "url": "Hinyaa K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "people of Klawock",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Sanyaa K̲wáan",
                            "url": "Sanyaa K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "people of Cape Fox, Saxman",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Kwaashk'i K̲wáan",
                            "url": "Kwaashk'i K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Kwaashk'i K̲wáan, locally called \"Humpback Salmon\"; a clan of the Raven moiety whose principal crest is the Humpback Salmon",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Sheet'ká K̲wáan",
                            "url": "Shee At'iká K̲wáan",
                            "tags": [
                                "Noun"
                            ],
                            "english": "people of Sitka",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "the Kake people."
        },
        "6": {
            "startTime": 14.368,
            "endTime": 15.7,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "7": {
            "startTime": 15.7,
            "endTime": 19.33,
            "tli": [
                [
                    "kootéeyaax’",
                    [],
                    []
                ]
            ],
            "eng": "they burned"
        },
        "8": {
            "startTime": 19.33,
            "endTime": 22.383,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "9": {
            "startTime": 22.383,
            "endTime": 26.344,
            "tli": [
                [
                    "kei",
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wdudzigán.",
                    [],
                    []
                ]
            ],
            "eng": "the totem poles."
        },
        "10": {
            "startTime": 26.344,
            "endTime": 29.502,
            "tli": [
                [
                    "Daak̲w",
                    [],
                    []
                ],
                [
                    "aa sá",
                    [
                        {
                            "tlingit": "ch'a aa sá",
                            "url": "ch'a aa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a aa sá",
                            "url": "ch'a aadóo sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "Some"
        },
        "11": {
            "startTime": 29.502,
            "endTime": 32.127,
            "tli": [
                [
                    "k̲usg̲áax̲",
                    [],
                    []
                ],
                [
                    "yéi wdudzinei.",
                    [
                        {
                            "tlingit": "yéi wdudzinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "4H_3__"
                            ],
                            "english": "it was fixed",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "cried over it."
        },
        "12": {
            "startTime": 32.127,
            "endTime": 33.762,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲waa.áx̲",
                    [
                        {
                            "tlingit": "x̲waa.áx̲",
                            "url": "aawa.áx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I heard it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what I heard"
        },
        "13": {
            "startTime": 33.762,
            "endTime": 37.697,
            "tli": [
                [
                    "a daat.",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "about it."
        },
        "14": {
            "startTime": 37.697,
            "endTime": 40.378,
            "tli": [
                [
                    "Ldakát",
                    [
                        {
                            "tlingit": "ldakát",
                            "url": "ldakát",
                            "tags": [
                                "Quantifier"
                            ],
                            "english": "all; every",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kei",
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wdudzigán.",
                    [],
                    []
                ]
            ],
            "eng": "They burned all of them."
        },
        "15": {
            "startTime": 40.378,
            "endTime": 42.419,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "16": {
            "startTime": 45.697,
            "endTime": 48.716,
            "tli": [
                [
                    "Yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yeedéi",
                    [],
                    []
                ],
                [
                    "gax̲dusnei",
                    [
                        {
                            "tlingit": "tlél yéi gax̲dusnei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "4H_3__"
                            ],
                            "english": "it won't be fixed",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "When they were going to finish,"
        },
        "17": {
            "startTime": 52.512,
            "endTime": 56.734,
            "tli": [
                [
                    "k̲u.éex’",
                    [],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi gax̲dusnei",
                    [
                        {
                            "tlingit": "tlél yéi gax̲dusnei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "4H_3__"
                            ],
                            "english": "it won't be fixed",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yóo",
                    [
                        {
                            "tlingit": "yóo",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yóo",
                            "url": "yú",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (distant), yonder",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they were going to stop having the k̲u.éex’,"
        },
        "18": {
            "startTime": 56.734,
            "endTime": 58.814,
            "tli": [
                [
                    "yáa",
                    [
                        {
                            "tlingit": "yáa",
                            "url": "yá",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "this (right here)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲áa.",
                    [
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the people."
        },
        "19": {
            "startTime": 58.814,
            "endTime": 59.878,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "20": {
            "startTime": 59.878,
            "endTime": 61.39,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what"
        },
        "21": {
            "startTime": 61.39,
            "endTime": 65.955,
            "tli": [
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aan",
                    [
                        {
                            "tlingit": "aan",
                            "url": "aan",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "with it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aan",
                            "url": "aan2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "town; village; settlement; inhabited or owned land",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kei haa",
                    [
                        {
                            "tlingit": "kei haa nasátk",
                            "url": "woosátk",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting faster",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa wdzigít",
                            "url": "kei wdzigít",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we woke up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nak'éin",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting better",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're getting sick",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nalchán",
                            "url": "wulichán",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are starting to stink",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa naltseen",
                            "url": "wulitseen",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are becoming strong",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nalnáalx̲",
                            "url": "wulináalx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting rich",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "woowáat.",
                    [],
                    []
                ]
            ],
            "eng": "we weren’t raised with it."
        },
        "22": {
            "startTime": 65.955,
            "endTime": 68.176,
            "tli": [
                [
                    "K̲údáx̲",
                    [],
                    []
                ],
                [
                    "dáanaa,",
                    [
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "silver",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "money, coin, dollar",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Too much money,"
        },
        "23": {
            "startTime": 68.176,
            "endTime": 69.87,
            "tli": [
                [
                    "dáanaa,",
                    [
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "silver",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "money, coin, dollar",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "money,"
        },
        "24": {
            "startTime": 69.87,
            "endTime": 73.168,
            "tli": [
                [
                    "dáanax̲",
                    [],
                    []
                ],
                [
                    "sitee",
                    [
                        {
                            "tlingit": "(noun)-x̲ sitee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__3"
                            ],
                            "english": "s/he is a (noun)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "there is money with the k̲u.éex’."
        },
        "25": {
            "startTime": 73.168,
            "endTime": 74.923,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "26": {
            "startTime": 74.923,
            "endTime": 77.364,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aaní",
                    [
                        {
                            "tlingit": "du aaní",
                            "url": "aan2",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its town; village; settlement; inhabited or owned land",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lingít aaní",
                            "url": "lingit'aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "world",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lingít aaní",
                            "url": "lingít aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "world",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Anóoshi aaní",
                            "url": "Anóoshi aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Russia",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Our town,"
        },
        "27": {
            "startTime": 77.364,
            "endTime": 79.488,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yátx’i,",
                    [],
                    []
                ]
            ],
            "eng": "our children,"
        },
        "28": {
            "startTime": 79.488,
            "endTime": 81.595,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yátx’i,",
                    [],
                    []
                ]
            ],
            "eng": "their children,"
        },
        "29": {
            "startTime": 83.847,
            "endTime": 86.297,
            "tli": [
                [
                    "school",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "school,"
        },
        "30": {
            "startTime": 89.047,
            "endTime": 91.73,
            "tli": [
                [
                    "shux’wáanáx̲",
                    [],
                    []
                ]
            ],
            "eng": "in the beginning,"
        },
        "31": {
            "startTime": 95.209,
            "endTime": 99.14,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "toowúch,",
                    [],
                    []
                ]
            ],
            "eng": "their feeling was"
        },
        "32": {
            "startTime": 99.14,
            "endTime": 102.217,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yátx’i,",
                    [],
                    []
                ]
            ],
            "eng": "that their children"
        },
        "33": {
            "startTime": 102.217,
            "endTime": 105.927,
            "tli": [
                [
                    "aan",
                    [
                        {
                            "tlingit": "aan",
                            "url": "aan",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "with it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aan",
                            "url": "aan2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "town; village; settlement; inhabited or owned land",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kei has",
                    [
                        {
                            "tlingit": "kei has nasátk",
                            "url": "woosátk",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting faster",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has u.aatch",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go up (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nak'éin",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting better",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're getting sick",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nalchán",
                            "url": "wulichán",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are starting to stink",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has anashk'án",
                            "url": "awshik'aan",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they are beginning to hate him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nalts'éin",
                            "url": "wulits'áa",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are starting to smell good",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "woowáat",
                    [],
                    []
                ]
            ],
            "eng": "were raised with it,"
        },
        "34": {
            "startTime": 105.927,
            "endTime": 108.525,
            "tli": [
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yinaadé.",
                    [
                        {
                            "tlingit": "a yinaadé",
                            "url": "a niyaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yinaadé",
                            "url": "a yinaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "on the white people’s side."
        },
        "35": {
            "startTime": 108.525,
            "endTime": 110.554,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "36": {
            "startTime": 113.114,
            "endTime": 115.341,
            "tli": [
                [
                    "Tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Also they didn’t"
        },
        "37": {
            "startTime": 115.341,
            "endTime": 117.473,
            "tli": [
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shukaadé.",
                    [],
                    []
                ]
            ],
            "eng": "go to camps."
        },
        "38": {
            "startTime": 121.406,
            "endTime": 125.648,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "school",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They were only"
        },
        "39": {
            "startTime": 125.648,
            "endTime": 128.581,
            "tli": [
                [
                    "gax̲duxeech.",
                    [],
                    []
                ]
            ],
            "eng": "going to put eﬀort into school."
        },
        "40": {
            "startTime": 136.674,
            "endTime": 138.27,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Wrangell,",
                    [],
                    []
                ]
            ],
            "eng": "Wrangell,"
        },
        "41": {
            "startTime": 138.273,
            "endTime": 141.153,
            "tli": [
                [
                    "K̲aachx̲an.áak’wdei",
                    [],
                    []
                ],
                [
                    "gíwé",
                    [],
                    []
                ]
            ],
            "eng": "they boated"
        },
        "42": {
            "startTime": 141.153,
            "endTime": 143.677,
            "tli": [
                [
                    "has uwak̲úx̲.",
                    [
                        {
                            "tlingit": "át has uwak̲úx̲",
                            "url": "át uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___3"
                            ],
                            "english": "they drove to it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak has uwak̲úx̲",
                            "url": "daak uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they went out to sea",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi (ha)s uwak̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they started driving",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yan uwak̲úx̲",
                            "url": "yan uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he went ashore",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "át uwak̲úx̲",
                            "url": "át uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he drove to it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak uwak̲úx̲",
                            "url": "daak uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went out to sea",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi uwak̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he started driving",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "to K̲aachx̲an.áak’w."
        },
        "43": {
            "startTime": 143.677,
            "endTime": 147.18,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x’oonináx̲",
                    [],
                    []
                ],
                [
                    "sá.",
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I don’t know how many."
        },
        "44": {
            "startTime": 147.18,
            "endTime": 148.34,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaakw",
                    [
                        {
                            "tlingit": "yaakw",
                            "url": "yaakw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boat, canoe",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The boat"
        },
        "45": {
            "startTime": 148.34,
            "endTime": 150.946,
            "tli": [
                [
                    "Katie",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "duwasáakw.",
                    [
                        {
                            "tlingit": "yéi aawasáakw",
                            "url": "yéi aawasáakw",
                            "tags": [
                                "Verb"
                            ],
                            "english": "s/he called him/her/it that (name)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "was called “Katie.”"
        },
        "46": {
            "startTime": 153.557,
            "endTime": 156.834,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú –",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’as",
                    [],
                    []
                ],
                [
                    "know",
                    [],
                    []
                ],
                [
                    "– áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasikóo",
                    [
                        {
                            "tlingit": "x̲wasikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I know it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I don’t know – I only know – I know"
        },
        "47": {
            "startTime": 156.834,
            "endTime": 159.5,
            "tli": [
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "last",
                    [],
                    []
                ],
                [
                    "name-i.",
                    [],
                    []
                ]
            ],
            "eng": "her last name."
        },
        "48": {
            "startTime": 162.155,
            "endTime": 165.648,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "law",
                    [],
                    []
                ],
                [
                    "daat has agux̲sakóo.",
                    [
                        {
                            "tlingit": "has agux̲sakóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "future",
                                "3Pl_3__"
                            ],
                            "english": "they will know",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat has yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Pl_3Sg_"
                            ],
                            "english": "they are taking care of him/her; they took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat has yoostaak̲ch",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Pl_3Sg_"
                            ],
                            "english": "they take care of him/her (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du daat has yawustaak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "_3Pl_3Sg_"
                            ],
                            "english": "they aren't taking care of him/her; they didn't take care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du daat has yoostaak̲ch",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "_3Pl_3Sg_"
                            ],
                            "english": "they haven't taken care of him/her yet",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat át k̲ug̲aag̲astee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__3Sg_"
                            ],
                            "english": "let him/her be busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat haa yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Pl_3Sg_"
                            ],
                            "english": "let us take care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat haa yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl_3Sg_"
                            ],
                            "english": "we are taking care of him/her; we took care of him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "They were going to know about the law."
        },
        "49": {
            "startTime": 168.969,
            "endTime": 171.44,
            "tli": [
                [
                    "Wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "That is how"
        },
        "50": {
            "startTime": 171.44,
            "endTime": 174.075,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "51": {
            "startTime": 174.075,
            "endTime": 178.054,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ée",
                    [
                        {
                            "tlingit": "Ée!",
                            "url": "Ée!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "Yuck!; Eeeew!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gax̲dultéew",
                    [],
                    []
                ],
                [
                    "k̲ux̲ has",
                    [
                        {
                            "tlingit": "k̲ux̲ has wudi.át",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they went back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daatx̲ k̲ux̲ has tul.átni",
                            "url": "a daatx̲ k̲ux̲ has tuwdli.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl__3_"
                            ],
                            "english": "if/when they change their minds about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ux̲ has da.átni",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___"
                            ],
                            "english": "if/when they go back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ux̲ has da.átch",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they go back (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ux̲ has uda.aatch",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go back (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ux̲ has ux̲da.aadín",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Pl___"
                            ],
                            "english": "they would have gone back",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél k̲ux̲ has wuda.aat",
                            "url": "k̲ux̲ has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "3Pl___"
                            ],
                            "english": "they didn't go back",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "wuk̲oox̲ú.",
                    [
                        {
                            "tlingit": "wé át wuk̲oox̲u aa",
                            "url": "át uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg___3"
                            ],
                            "english": "the one who drove to it",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "they were going to teach us when they boated back."
        },
        "52": {
            "startTime": 179.808,
            "endTime": 181.649,
            "tli": [
                [
                    "Áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "53": {
            "startTime": 183.608,
            "endTime": 184.716,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was"
        },
        "54": {
            "startTime": 184.716,
            "endTime": 187.624,
            "tli": [
                [
                    "1912",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shukát",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "before 1912"
        },
        "55": {
            "startTime": 187.624,
            "endTime": 190.676,
            "tli": [
                [
                    "yéi at wootee.",
                    [
                        {
                            "tlingit": "yéi at woonei",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg"
                            ],
                            "english": "that's what happened",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Líl a yanáax̲ yéi at yitánjik̲!",
                            "url": "a yanáax̲ at wootaan",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective_prohibitive",
                                "2Pl___"
                            ],
                            "english": "Don't you all cover it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at yaneik",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg"
                            ],
                            "english": "that's what happens (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneich",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg"
                            ],
                            "english": "that's what happens (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at nag̲anei",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg"
                            ],
                            "english": "let it happen",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneiní",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg"
                            ],
                            "english": "if/when that happens",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi x̲at wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Sg__"
                            ],
                            "english": "I was that way; I became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yáa at wooné",
                            "url": "yáa at wooné",
                            "tags": [
                                "Noun"
                            ],
                            "english": "respect",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél at wutooshee",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Pl___"
                            ],
                            "english": "we didn't sing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yoo at koojeek",
                            "url": "yoo at koojeek",
                            "tags": [
                                "Noun"
                            ],
                            "english": "curiosity",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yei at uchoox̲ch",
                            "url": "at woochoox̲",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he freeloads (regularly)",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "when it happened."
        },
        "56": {
            "startTime": 192.278,
            "endTime": 198.448,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yande",
                    [],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ndusnein",
                    [],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aaní",
                    [
                        {
                            "tlingit": "du aaní",
                            "url": "aan2",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its town; village; settlement; inhabited or owned land",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lingít aaní",
                            "url": "lingit'aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "world",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "lingít aaní",
                            "url": "lingít aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "world",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Anóoshi aaní",
                            "url": "Anóoshi aaní",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Russia",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "So they are finishing our town,"
        },
        "57": {
            "startTime": 198.448,
            "endTime": 200.149,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "that"
        },
        "58": {
            "startTime": 205.665,
            "endTime": 208.797,
            "tli": [
                [
                    "1912 áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲waa.áx̲",
                    [
                        {
                            "tlingit": "x̲waa.áx̲",
                            "url": "aawa.áx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I heard it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "in 1912 I heard"
        },
        "59": {
            "startTime": 208.797,
            "endTime": 211.054,
            "tli": [
                [
                    "boardwalk",
                    [],
                    []
                ]
            ],
            "eng": "they made"
        },
        "60": {
            "startTime": 211.054,
            "endTime": 213.031,
            "tli": [
                [
                    "dulyeix̲.",
                    [],
                    []
                ]
            ],
            "eng": "the boardwalk."
        },
        "61": {
            "startTime": 213.031,
            "endTime": 214.516,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "62": {
            "startTime": 214.516,
            "endTime": 216.365,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "63": {
            "startTime": 219.468,
            "endTime": 222.397,
            "tli": [
                [
                    "K̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "And"
        },
        "64": {
            "startTime": 222.397,
            "endTime": 225.601,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the"
        },
        "65": {
            "startTime": 225.601,
            "endTime": 229.041,
            "tli": [
                [
                    "celebration",
                    [],
                    []
                ],
                [
                    "yakg̲waxeex",
                    [
                        {
                            "tlingit": "tlél yakg̲waxeex",
                            "url": "yaawaxeex",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg"
                            ],
                            "english": "it won't happen",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "celebration was going to occur"
        },
        "66": {
            "startTime": 231.357,
            "endTime": 234.677,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hóoch’in",
                    [],
                    []
                ],
                [
                    "yís",
                    [
                        {
                            "tlingit": "a yís",
                            "url": "a yís",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "for it; to that end",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "for the last"
        },
        "67": {
            "startTime": 234.677,
            "endTime": 236.919,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "boardwalk,",
                    [],
                    []
                ]
            ],
            "eng": "boardwalk,"
        },
        "68": {
            "startTime": 240.105,
            "endTime": 242.378,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "t’áa",
                    [],
                    []
                ]
            ],
            "eng": "the board,"
        },
        "69": {
            "startTime": 245.945,
            "endTime": 251.074,
            "tli": [
                [
                    "yande",
                    [],
                    []
                ],
                [
                    "gax̲dusx’oowú",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "when they finished nailing it."
        },
        "70": {
            "startTime": 251.074,
            "endTime": 255.653,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aan",
                    [
                        {
                            "tlingit": "aan",
                            "url": "aan",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "with it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aan",
                            "url": "aan2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "town; village; settlement; inhabited or owned land",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "s’aatí",
                    [],
                    []
                ],
                [
                    "sakw",
                    [],
                    []
                ]
            ],
            "eng": "The future mayor"
        },
        "71": {
            "startTime": 255.653,
            "endTime": 260.742,
            "tli": [
                [
                    "dáanaa",
                    [
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "silver",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dáanaa",
                            "url": "dáanaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "money, coin, dollar",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "akaawadíx’.",
                    [],
                    []
                ]
            ],
            "eng": "plugged it with a silver dollar."
        },
        "72": {
            "startTime": 260.742,
            "endTime": 265.462,
            "tli": [
                [
                    "Hóoch’i",
                    [],
                    []
                ],
                [
                    "aayí",
                    [
                        {
                            "tlingit": "taat aayí adéli",
                            "url": "taat aayí adéli",
                            "tags": [
                                "Noun"
                            ],
                            "english": "night watchman",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tuháayi",
                    [
                        {
                            "tlingit": "tuháayi",
                            "url": "tuháayi",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nail",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The last nail"
        },
        "73": {
            "startTime": 265.462,
            "endTime": 269.261,
            "tli": [
                [
                    "k̲ugax̲dusx’oowú.",
                    [],
                    []
                ]
            ],
            "eng": "was going to be nailed."
        },
        "74": {
            "startTime": 269.261,
            "endTime": 272.874,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "75": {
            "startTime": 272.874,
            "endTime": 274.528,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "76": {
            "startTime": 274.528,
            "endTime": 275.919,
            "tli": [
                [
                    "tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "a woman"
        },
        "77": {
            "startTime": 280.37,
            "endTime": 284.487,
            "tli": [
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "kínde",
                    [
                        {
                            "tlingit": "kínde",
                            "url": "kíndei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "upward",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shaawát",
                    [
                        {
                            "tlingit": "shaawát",
                            "url": "shaawát",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woman",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dulshát",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "was held up very hig̲."
        },
        "78": {
            "startTime": 286.474,
            "endTime": 288.021,
            "tli": [
                [
                    "Hóoch",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was she"
        },
        "79": {
            "startTime": 288.021,
            "endTime": 290.936,
            "tli": [
                [
                    "a ká",
                    [
                        {
                            "tlingit": "a ká",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "the (horizontal) surface of it; on it; on top of it; in it (a dish; a path)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan ká",
                            "url": "gaan ká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "smokehole",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "t'áa ká",
                            "url": "t'áa ká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "floor",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaash ká",
                            "url": "yaash ká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "smokehouse shelf",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hít ká",
                            "url": "hít ká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "roof",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du eetí ká",
                            "url": "du eetí ká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(in) his/her room, bedroom",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du eetí ká",
                            "url": "eet",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its room",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "t'aa ká axít'kw",
                            "url": "t'aa ká aawaxéet'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he is sweeping the floor; s/he sweeps the floor",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "gux̲lax’oow",
                    [],
                    []
                ]
            ],
            "eng": "who was going to nail"
        },
        "80": {
            "startTime": 290.936,
            "endTime": 293.37,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hóoch’i",
                    [],
                    []
                ],
                [
                    "aayí",
                    [
                        {
                            "tlingit": "taat aayí adéli",
                            "url": "taat aayí adéli",
                            "tags": [
                                "Noun"
                            ],
                            "english": "night watchman",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "board,",
                    [],
                    []
                ]
            ],
            "eng": "on the last board,"
        },
        "81": {
            "startTime": 293.37,
            "endTime": 295.259,
            "tli": [
                [
                    "boardwalk",
                    [],
                    []
                ],
                [
                    "yís.",
                    [
                        {
                            "tlingit": "a yís",
                            "url": "a yís",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "for it; to that end",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "for the boardwalk."
        },
        "82": {
            "startTime": 296.796,
            "endTime": 300.068,
            "tli": [
                [
                    "Wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "gax̲dusaa",
                    [],
                    []
                ],
                [
                    "boardwalk?",
                    [],
                    []
                ]
            ],
            "eng": "What will a boardwalk be called?"
        },
        "83": {
            "startTime": 302.609,
            "endTime": 304.718,
            "tli": [
                [
                    "T’áa?",
                    [],
                    []
                ],
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kwshé?",
                    [
                        {
                            "tlingit": "kwshé",
                            "url": "kwshé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "Eh?; I wonder",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "kwshé",
                            "url": "kwshéi",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "maybe; I'm not sure; [expression of uncertainly]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "T’áa? Is that it?"
        },
        "84": {
            "startTime": 304.718,
            "endTime": 306.834,
            "tli": [
                [
                    "T’áadeiyí.",
                    [],
                    []
                ]
            ],
            "eng": "T’áadeiyí."
        },
        "85": {
            "startTime": 306.834,
            "endTime": 309.717,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "gax̲dusaa.",
                    [],
                    []
                ]
            ],
            "eng": "I don’t know what it will be called."
        },
        "86": {
            "startTime": 309.717,
            "endTime": 312.073,
            "tli": [
                [
                    "T’aadeiyí.",
                    [],
                    []
                ]
            ],
            "eng": "T’aadeiyí."
        },
        "87": {
            "startTime": 312.073,
            "endTime": 313.256,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "88": {
            "startTime": 313.256,
            "endTime": 315.705,
            "tli": [
                [
                    "Yeah.",
                    [],
                    []
                ]
            ],
            "eng": "Yeah."
        },
        "89": {
            "startTime": 315.705,
            "endTime": 318.75,
            "tli": [
                [
                    "Wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shaawát",
                    [
                        {
                            "tlingit": "shaawát",
                            "url": "shaawát",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woman",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "A woman"
        },
        "90": {
            "startTime": 318.75,
            "endTime": 320.494,
            "tli": [
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tayeex’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "was going to"
        },
        "91": {
            "startTime": 320.494,
            "endTime": 322.419,
            "tli": [
                [
                    "yéi kg̲watee.",
                    [
                        {
                            "tlingit": "tlél yéi kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__"
                            ],
                            "english": "he/she/it won't be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél tleiyéi yéi kg̲watee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__"
                            ],
                            "english": "he/she/it won't be still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du x̲ánx' yéi kg̲watee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he won't stay with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du wak̲shiyeex' yéi kg̲watee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it won't appear before him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tlél yéi haa kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_1Pl__"
                            ],
                            "english": "we won't be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi yee kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_2Pl__"
                            ],
                            "english": "you all won't be that way",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "put it under."
        },
        "92": {
            "startTime": 326.499,
            "endTime": 328.58,
            "tli": [
                [
                    "Yáadu",
                    [
                        {
                            "tlingit": "yáadu",
                            "url": "yá",
                            "tags": [
                                "Demonstrative",
                                "locativepr"
                            ],
                            "english": "here is; here are",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲át.",
                    [
                        {
                            "tlingit": "x̲át",
                            "url": "x̲át",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "I [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I am here."
        },
        "93": {
            "startTime": 328.58,
            "endTime": 331.878,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Gunalchéesh,",
                    [
                        {
                            "tlingit": "Gunalchéesh!",
                            "url": "Gunalchéesh!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "Thank you!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Géis’.",
                    [],
                    []
                ]
            ],
            "eng": "Yes. Thank you, Géis’."
        },
        "94": {
            "startTime": 334.92,
            "endTime": 336.033,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "95": {
            "startTime": 336.033,
            "endTime": 340.57,
            "tli": [
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tayeex’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi kg̲watee",
                    [
                        {
                            "tlingit": "tlél yéi kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__"
                            ],
                            "english": "he/she/it won't be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél tleiyéi yéi kg̲watee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__"
                            ],
                            "english": "he/she/it won't be still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du x̲ánx' yéi kg̲watee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he won't stay with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du wak̲shiyeex' yéi kg̲watee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it won't appear before him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tlél yéi haa kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_1Pl__"
                            ],
                            "english": "we won't be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi yee kg̲watee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_2Pl__"
                            ],
                            "english": "you all won't be that way",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "she was going to put it under"
        },
        "96": {
            "startTime": 340.57,
            "endTime": 346.545,
            "tli": [
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "daa sá",
                    [
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tléil daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan daa",
                            "url": "gandaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "around the fire",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A daa yanees.á!",
                            "url": "a daa yawdzi.aa",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3_"
                            ],
                            "english": "Examine it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "around it; about it; concerning it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "A daa itunatí!",
                            "url": "a daa tuwatee",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3_"
                            ],
                            "english": "Care about it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ daa",
                            "url": "át uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it flows to it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh daa adalóox'",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he pees himself/herself",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yeedéi",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gax̲dusneiyí.",
                    [],
                    []
                ]
            ],
            "eng": "whatever they were going to put under it."
        },
        "97": {
            "startTime": 349.504,
            "endTime": 352.024,
            "tli": [
                [
                    "Yanshukaadéi",
                    [],
                    []
                ]
            ],
            "eng": "The camps"
        },
        "98": {
            "startTime": 352.024,
            "endTime": 353.848,
            "tli": [
                [
                    "Hóoch’x̲",
                    [],
                    []
                ],
                [
                    "gux̲satee.",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "were going to end"
        },
        "99": {
            "startTime": 353.848,
            "endTime": 356.317,
            "tli": [
                [
                    "school",
                    [],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yanaxíxi.",
                    [],
                    []
                ]
            ],
            "eng": "during school."
        },
        "100": {
            "startTime": 356.317,
            "endTime": 363.344,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "101": {
            "startTime": 363.344,
            "endTime": 365.568,
            "tli": [
                [
                    "Hóoch’x̲",
                    [],
                    []
                ],
                [
                    "gux̲satee.",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They were going to end."
        },
        "102": {
            "startTime": 365.568,
            "endTime": 368.046,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "103": {
            "startTime": 368.046,
            "endTime": 370.553,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "school",
                    [],
                    []
                ],
                [
                    "gax̲duxeech.",
                    [],
                    []
                ]
            ],
            "eng": "They were only going to put eﬀort into school."
        },
        "104": {
            "startTime": 378.191,
            "endTime": 380.935,
            "tli": [
                [
                    "Hóoch’x̲",
                    [],
                    []
                ],
                [
                    "gux̲satee",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "aa,",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "What was going to end,"
        },
        "105": {
            "startTime": 380.935,
            "endTime": 383.65,
            "tli": [
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it wasn’t rig̲t"
        },
        "106": {
            "startTime": 383.65,
            "endTime": 387.957,
            "tli": [
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ntusaxíxi",
                    [],
                    []
                ],
                [
                    "aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aan.",
                    [
                        {
                            "tlingit": "aan",
                            "url": "aan",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "with it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aan",
                            "url": "aan2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "town; village; settlement; inhabited or owned land",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "with how we celebrated it."
        },
        "107": {
            "startTime": 387.957,
            "endTime": 390.677,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yinaadéi",
                    [
                        {
                            "tlingit": "a yinaadéi",
                            "url": "a niyaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yinaadéi",
                            "url": "a yinaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is only on the side of white people"
        },
        "108": {
            "startTime": 390.677,
            "endTime": 392.027,
            "tli": [
                [
                    "yeedát.",
                    [
                        {
                            "tlingit": "yeedát",
                            "url": "yeedát",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "now",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "now."
        },
        "109": {
            "startTime": 394.091,
            "endTime": 395.85,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "gíwéi",
                    [],
                    []
                ]
            ],
            "eng": "That is maybe why"
        },
        "110": {
            "startTime": 395.85,
            "endTime": 400.893,
            "tli": [
                [
                    "hóoch’x̲",
                    [],
                    []
                ],
                [
                    "wusitee",
                    [
                        {
                            "tlingit": "(noun)-x̲ wusitee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__3"
                            ],
                            "english": "s/he became a (noun)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "the k̲u.éex’ had ended."
        },
        "111": {
            "startTime": 400.893,
            "endTime": 402.388,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "112": {
            "startTime": 402.388,
            "endTime": 405.06,
            "tli": [
                [
                    "A",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yináat",
                    [],
                    []
                ],
                [
                    "(?)",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kawdudzix’oo.",
                    [],
                    []
                ]
            ],
            "eng": "They covered it by nailing it."
        },
        "113": {
            "startTime": 409.777,
            "endTime": 412.103,
            "tli": [
                [
                    "K̲óok",
                    [
                        {
                            "tlingit": "k̲óok",
                            "url": "k̲óok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "box",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tóode",
                    [
                        {
                            "tlingit": "a tóode",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "allative"
                            ],
                            "english": "into it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóode yaa akanaldútl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he is calling him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóode yagux̲daxóon",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "future",
                                "__3Sg_"
                            ],
                            "english": "s/he will be possessed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Náakw du tóode kanaltsaak̲!",
                            "url": "náakw du tóode akawlitsaak̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Inject medicine into him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóode akagux̲ladóotl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "future",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he will call him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél tóode akagux̲ladootl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he won't call him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du tóode yagux̲daxoon",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "__3Sg_"
                            ],
                            "english": "s/he won't be possessed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aawachák.",
                    [],
                    []
                ]
            ],
            "eng": "They packed it into a box."
        },
        "114": {
            "startTime": 412.103,
            "endTime": 413.183,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "115": {
            "startTime": 413.183,
            "endTime": 421.107,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "K̲óok",
                    [
                        {
                            "tlingit": "k̲óok",
                            "url": "k̲óok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "box",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tóode",
                    [
                        {
                            "tlingit": "a tóode",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "allative"
                            ],
                            "english": "into it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóode yaa akanaldútl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he is calling him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóode yagux̲daxóon",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "future",
                                "__3Sg_"
                            ],
                            "english": "s/he will be possessed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Náakw du tóode kanaltsaak̲!",
                            "url": "náakw du tóode akawlitsaak̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Inject medicine into him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóode akagux̲ladóotl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "future",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he will call him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél tóode akagux̲ladootl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he won't call him/her/it over to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du tóode yagux̲daxoon",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "__3Sg_"
                            ],
                            "english": "s/he won't be possessed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "akaawachaki",
                    [],
                    []
                ],
                [
                    "yáx̲ wootee.",
                    [
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a yáx̲ yatee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it was that way; he/she/it became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ wootee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ kooxátch",
                            "url": "a yáx̲ kaaxát",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3_"
                            ],
                            "english": "it looks like it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi wootee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stayed with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "(Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wududzix’oo.)",
                    [],
                    []
                ]
            ],
            "eng": "It is like that. It is like they packed it into a box. (That was it with the nailing.)"
        },
        "116": {
            "startTime": 421.107,
            "endTime": 423.716,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "117": {
            "startTime": 426.412,
            "endTime": 429.613,
            "tli": [
                [
                    "Wutusx’oo",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When we nailed it,"
        },
        "118": {
            "startTime": 429.613,
            "endTime": 431.685,
            "tli": [
                [
                    "hóoch’x̲",
                    [],
                    []
                ],
                [
                    "gux̲satee.",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was going to end."
        },
        "119": {
            "startTime": 431.685,
            "endTime": 433.634,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "120": {
            "startTime": 439.097,
            "endTime": 440.829,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "121": {
            "startTime": 445.003,
            "endTime": 449.752,
            "tli": [
                [
                    "tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x’oon",
                    [],
                    []
                ],
                [
                    "táakw",
                    [
                        {
                            "tlingit": "táakw",
                            "url": "táakw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "winter; year",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sákwshé",
                    [],
                    []
                ],
                [
                    "a káa",
                    [
                        {
                            "tlingit": "a káa",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun",
                                "locative"
                            ],
                            "english": "on it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "káa",
                            "url": "káa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "car, automobile",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yéi wootee.",
                    [
                        {
                            "tlingit": "yéi wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it was that way; he/she/it became that way",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi haa wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we were that way; we became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi wootee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stayed with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ wootee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du wak̲shiyeex' yéi wootee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it appeared before him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "it was very many years ago."
        },
        "122": {
            "startTime": 452.616,
            "endTime": 457.141,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yoo",
                    [
                        {
                            "tlingit": "yoo",
                            "url": "yoo",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "back and forth; to and fro; up and down",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’atángi,",
                    [],
                    []
                ]
            ],
            "eng": "Our Tlingit language,"
        },
        "123": {
            "startTime": 457.141,
            "endTime": 458.887,
            "tli": [
                [
                    "ch’as",
                    [],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’éináx̲",
                    [],
                    []
                ]
            ],
            "eng": "we were raised"
        },
        "124": {
            "startTime": 458.887,
            "endTime": 460.821,
            "tli": [
                [
                    "yoo",
                    [
                        {
                            "tlingit": "yoo",
                            "url": "yoo",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "back and forth; to and fro; up and down",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’awtuli.át",
                    [],
                    []
                ]
            ],
            "eng": "only speaking"
        },
        "125": {
            "startTime": 460.821,
            "endTime": 464.568,
            "tli": [
                [
                    "kei haa",
                    [
                        {
                            "tlingit": "kei haa nasátk",
                            "url": "woosátk",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting faster",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa wdzigít",
                            "url": "kei wdzigít",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we woke up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nak'éin",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting better",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're getting sick",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nalchán",
                            "url": "wulichán",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are starting to stink",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa naltseen",
                            "url": "wulitseen",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are becoming strong",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei haa nalnáalx̲",
                            "url": "wulináalx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Pl__"
                            ],
                            "english": "we are getting rich",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "nawádi.",
                    [],
                    []
                ]
            ],
            "eng": "our Tlingit language."
        },
        "126": {
            "startTime": 467.487,
            "endTime": 469.114,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "127": {
            "startTime": 469.114,
            "endTime": 470.189,
            "tli": [
                [
                    "Aaa.",
                    [],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "128": {
            "startTime": 470.189,
            "endTime": 472.803,
            "tli": [
                [
                    "Dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "yinaadé",
                    [
                        {
                            "tlingit": "a yinaadé",
                            "url": "a niyaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yinaadé",
                            "url": "a yinaadé",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "in the direction or general area of it; (headed) toward it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is strong"
        },
        "129": {
            "startTime": 472.803,
            "endTime": 475.03,
            "tli": [
                [
                    "litseen.",
                    [
                        {
                            "tlingit": "litseen",
                            "url": "wulitseen",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "s/he's strong",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "on the white people’s side."
        },
        "130": {
            "startTime": 479.448,
            "endTime": 481.054,
            "tli": [
                [
                    "Hóoch’",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yanshuká.",
                    [
                        {
                            "tlingit": "yanshuká",
                            "url": "yanshuká",
                            "tags": [
                                "Noun"
                            ],
                            "english": "campsite; (out in) camp; (out in) the bush, wilderness",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The camps ended."
        },
        "131": {
            "startTime": 481.054,
            "endTime": 484.696,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "school",
                    [],
                    []
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shuwdataaní",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsáa",
                    [
                        {
                            "tlingit": "I sa.át' tsáa!",
                            "url": "seiwa.át'",
                            "tags": [
                                "Verb",
                                "admonishment",
                                "_2Sg__"
                            ],
                            "english": "See that you don't get cold!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "I yas.át' tsáa!",
                            "url": "yawdzi.át'",
                            "tags": [
                                "Verb",
                                "admonishment",
                                "_2Sg__"
                            ],
                            "english": "See that your face doesn't get cold!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Yee sa.át' tsáa!",
                            "url": "seiwa.át'",
                            "tags": [
                                "Verb",
                                "admonishment",
                                "_2Pl__"
                            ],
                            "english": "See that you all don't get cold!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Yee yas.át' tsáa!",
                            "url": "yawdzi.át'",
                            "tags": [
                                "Verb",
                                "admonishment",
                                "_2Pl__"
                            ],
                            "english": "See that your faces don't get cold!",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "We only went to camps"
        },
        "132": {
            "startTime": 484.696,
            "endTime": 487.124,
            "tli": [
                [
                    "yanshukaadé.",
                    [],
                    []
                ]
            ],
            "eng": "when school was out."
        },
        "133": {
            "startTime": 488.195,
            "endTime": 489.907,
            "tli": [
                [
                    "Hóoch’",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wusitee.",
                    [
                        {
                            "tlingit": "(noun)-x̲ wusitee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__3"
                            ],
                            "english": "s/he became a (noun)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It ended."
        },
        "134": {
            "startTime": 489.907,
            "endTime": 491.384,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "135": {
            "startTime": 494.382,
            "endTime": 500.051,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "school",
                    [],
                    []
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shuwataaní",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When school was out"
        },
        "136": {
            "startTime": 500.051,
            "endTime": 503.446,
            "tli": [
                [
                    "k̲uyanagwéich",
                    [],
                    []
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shukaadé.",
                    [],
                    []
                ]
            ],
            "eng": "people would travel to camps."
        },
        "137": {
            "startTime": 507.725,
            "endTime": 509.978,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "138": {
            "startTime": 520.859,
            "endTime": 522.196,
            "tli": [
                [
                    "Tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "How very much"
        },
        "139": {
            "startTime": 522.196,
            "endTime": 524.663,
            "tli": [
                [
                    "k̲aa toowú",
                    [
                        {
                            "tlingit": "k̲aa toowú lat'aa",
                            "url": "k̲aa toowú lat'aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "comfort",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa toowú let'aa",
                            "url": "k̲aa toowú lat'aa",
                            "tags": [
                                "Noun",
                                "C"
                            ],
                            "english": "comfort",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "k̲uwanéekw",
                    [],
                    []
                ]
            ],
            "eng": "people were sad"
        },
        "140": {
            "startTime": 524.663,
            "endTime": 526.445,
            "tli": [
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ítdáx̲.",
                    [],
                    []
                ]
            ],
            "eng": "after that."
        },
        "141": {
            "startTime": 528.526,
            "endTime": 531.649,
            "tli": [
                [
                    "G̲ooch",
                    [
                        {
                            "tlingit": "g̲ooch",
                            "url": "g̲ooch",
                            "tags": [
                                "Noun"
                            ],
                            "english": "wolf",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Éesh",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’ax̲waa.áx̲.",
                    [],
                    []
                ]
            ],
            "eng": "I heard G̲ooch Éesh."
        },
        "142": {
            "startTime": 531.649,
            "endTime": 533.822,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "He always"
        },
        "143": {
            "startTime": 533.822,
            "endTime": 536.034,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "x̲ánx’.",
                    [],
                    []
                ]
            ],
            "eng": "went by my grandmother."
        },
        "144": {
            "startTime": 536.034,
            "endTime": 539.699,
            "tli": [
                [
                    "Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tláax̲",
                    [],
                    []
                ],
                [
                    "wusitee",
                    [
                        {
                            "tlingit": "(noun)-x̲ wusitee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__3"
                            ],
                            "english": "s/he became a (noun)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "My grandmother was my mother"
        },
        "145": {
            "startTime": 539.699,
            "endTime": 541.93,
            "tli": [
                [
                    "kei x̲at",
                    [
                        {
                            "tlingit": "kei x̲at nawát",
                            "url": "kei uwawát",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm growing up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at nasátk",
                            "url": "woosátk",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm getting faster",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at g̲asgeet",
                            "url": "kei wdzigít",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Sg__"
                            ],
                            "english": "let me wake up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at nak'éin",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm getting better",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at nanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm getting sick",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at nalchán",
                            "url": "wulichán",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm starting to stink",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲at naltseen",
                            "url": "wulitseen",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_1Sg__"
                            ],
                            "english": "I am becoming strong",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "x̲at",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "nawádi",
                    [],
                    []
                ]
            ],
            "eng": "was how I was raised"
        },
        "146": {
            "startTime": 546.97,
            "endTime": 549.839,
            "tli": [
                [
                    "tóot",
                    [
                        {
                            "tlingit": "a tóot",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "in it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot wooxeex",
                            "url": "du tóot wooxeex",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he is worried about him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot wooxeex",
                            "url": "du tóot wooxeex2",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's worried about him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóot akawlidútl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he called him/her/it over to her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot yawdixún",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is possessed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot naxíxch",
                            "url": "du tóot wooxeex",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "s/he worries about him/her/it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot naxíxch",
                            "url": "du tóot wooxeex2",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "s/he worries about him/her/it (every time)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲at",
                    [
                        {
                            "tlingit": "x̲at",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "jeewataaních.",
                    [],
                    []
                ]
            ],
            "eng": "when I was given to them."
        },
        "147": {
            "startTime": 552.22,
            "endTime": 554.284,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "So"
        },
        "148": {
            "startTime": 554.284,
            "endTime": 556.353,
            "tli": [
                [
                    "G̲ooch",
                    [
                        {
                            "tlingit": "g̲ooch",
                            "url": "g̲ooch",
                            "tags": [
                                "Noun"
                            ],
                            "english": "wolf",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Éesh (?)",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "G̲ooch Éesh (?)"
        },
        "149": {
            "startTime": 556.353,
            "endTime": 560.565,
            "tli": [
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲ánx’",
                    [],
                    []
                ],
                [
                    "yanúkjin.",
                    [],
                    []
                ]
            ],
            "eng": "used to sit by me."
        },
        "150": {
            "startTime": 560.565,
            "endTime": 563.024,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲ánx’",
                    [],
                    []
                ],
                [
                    "goodí",
                    [],
                    []
                ]
            ],
            "eng": "When he went to us,"
        },
        "151": {
            "startTime": 563.024,
            "endTime": 566.278,
            "tli": [
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’ax̲waa.áx̲",
                    [],
                    []
                ]
            ],
            "eng": "I heard them,"
        },
        "152": {
            "startTime": 566.278,
            "endTime": 569.014,
            "tli": [
                [
                    "has du toowú",
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú sigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú yak'éi",
                            "url": "du toowú wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú klig̲éi",
                            "url": "du toowú kawlig̲éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is proud",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú alt'eix̲",
                            "url": "du toowú awlit'áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it is comforting him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú wlit'úch",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú kawál'ni",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3Sg_"
                            ],
                            "english": "if/when s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "néegu.",
                    [
                        {
                            "tlingit": "du néegu",
                            "url": "néekw",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its sickness; illness; disease",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éex̲ yéi nei",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he menstruates (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi g̲anei",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__3Sg_"
                            ],
                            "english": "let her get her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi néini",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3Sg_"
                            ],
                            "english": "if/when she gets her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi uwanéi",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "she got her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ dís néegu ax̲ éet yéi uwanéi",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I got my menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi oonéiych",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "she gets her menses (every month, e.g.)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "their sadness."
        },
        "153": {
            "startTime": 570.364,
            "endTime": 573.932,
            "tli": [
                [
                    "Tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "has du toowú",
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú sigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú yak'éi",
                            "url": "du toowú wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú klig̲éi",
                            "url": "du toowú kawlig̲éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is proud",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú alt'eix̲",
                            "url": "du toowú awlit'áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it is comforting him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú wlit'úch",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú kawál'ni",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3Sg_"
                            ],
                            "english": "if/when s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yanéekw",
                    [
                        {
                            "tlingit": "yanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "s/he's sick",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "How very sad they were"
        },
        "154": {
            "startTime": 575.557,
            "endTime": 579.284,
            "tli": [
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kootéeyaa",
                    [
                        {
                            "tlingit": "kootéeyaa",
                            "url": "kootéeyaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "totem pole",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daax’",
                    [],
                    []
                ],
                [
                    "yei",
                    [
                        {
                            "tlingit": "yei",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wteeyí.",
                    [],
                    []
                ]
            ],
            "eng": "that there weren’t totem poles around us."
        },
        "155": {
            "startTime": 580.752,
            "endTime": 584.324,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí",
                    [],
                    []
                ]
            ],
            "eng": "Our Tlingit way of life"
        },
        "156": {
            "startTime": 584.324,
            "endTime": 586.653,
            "tli": [
                [
                    "k̲ut kei naxíx.",
                    [
                        {
                            "tlingit": "k̲ut kei nashíx",
                            "url": "k̲ut wujixeex",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___"
                            ],
                            "english": "he/she/it is running away",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei anag̲íx'",
                            "url": "k̲ut aawag̲éex'",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he is losing it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei nak̲úx̲",
                            "url": "k̲ut wook̲oox̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he's getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei nagút",
                            "url": "k̲ut woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he is getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei nay.át",
                            "url": "k̲ut has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "2Pl___"
                            ],
                            "english": "you all are getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei atánch",
                            "url": "k̲ut aawataan",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "s/he loses it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei akag̲íx'ch",
                            "url": "k̲ut akaawag̲éex'",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he loses it (regularly)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "daak naxíx",
                            "url": "daak uwaxíx",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg"
                            ],
                            "english": "it's starting to come out",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yínde yaa naxíx",
                            "url": "yínde wooxeex",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg"
                            ],
                            "english": "it is setting",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(k'eeljáa) yaa naxíx",
                            "url": "(k'eeljáa) wooxeex",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg"
                            ],
                            "english": "it's starting to blow",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut",
                            "url": "k̲ut",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "astray, getting lost",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "is being lost."
        },
        "157": {
            "startTime": 586.653,
            "endTime": 589.455,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "158": {
            "startTime": 594.412,
            "endTime": 598.222,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "akaawa.aak̲w",
                    [
                        {
                            "tlingit": "akaawa.aak̲w",
                            "url": "akaawa.aak̲w",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he tried it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why they tried,"
        },
        "159": {
            "startTime": 598.222,
            "endTime": 603.627,
            "tli": [
                [
                    "has – a daa",
                    [
                        {
                            "tlingit": "a daa",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "around it; about it; concerning it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan daa",
                            "url": "gandaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "around the fire",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa yawdzi.aa",
                            "url": "a daa yawdzi.aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he examined it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ daa",
                            "url": "át uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it flows to it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daa aawadaak̲",
                            "url": "du daa aawadaak̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I sobered up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "shí du lóox̲ daa",
                            "url": "shí du lóot uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "his/her nose bleeds (regularly)",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yéi has jeewanei",
                    [
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi has jinaneich",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they work (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tuwdinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they felt that way",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "they – they worked on it"
        },
        "160": {
            "startTime": 603.627,
            "endTime": 605.505,
            "tli": [
                [
                    "yáax’",
                    [],
                    []
                ]
            ],
            "eng": "here,"
        },
        "161": {
            "startTime": 605.505,
            "endTime": 610.43,
            "tli": [
                [
                    "kei",
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wuyeeshí",
                    [],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "totem",
                    [],
                    []
                ],
                [
                    "pole",
                    [],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kootéeyaa.",
                    [
                        {
                            "tlingit": "kootéeyaa",
                            "url": "kootéeyaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "totem pole",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "raising a totem pole, a kootéeyaa."
        },
        "162": {
            "startTime": 614.638,
            "endTime": 616.827,
            "tli": [
                [
                    "Aadáx̲",
                    [
                        {
                            "tlingit": "aadáx̲ woogoot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it left there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ kawdiyaa",
                            "url": "aadáx̲ kawdiyaa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it disappeared from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ awsixáat'",
                            "url": "aadáx̲ awsixáat'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he dragged it away",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ nagútch",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "he/she/it leaves there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Aadáx̲ nagú!",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Leave there!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ yaa nagút",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is leaving there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ gug̲agóot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "future",
                                "3"
                            ],
                            "english": "he/she/it is going to leave there",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there,"
        },
        "163": {
            "startTime": 622.023,
            "endTime": 624.769,
            "tli": [
                [
                    "has du toowú",
                    [
                        {
                            "tlingit": "du toowú",
                            "url": "du toowú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her inner being; mind; soul; feelings; intention",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du toowú sigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú yak'éi",
                            "url": "du toowú wook'éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú klig̲éi",
                            "url": "du toowú kawlig̲éi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is proud",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú alt'eix̲",
                            "url": "du toowú awlit'áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it is comforting him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú wlit'úch",
                            "url": "du toowú wlit'úch",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du toowú kawál'ni",
                            "url": "du toowú kaawawál'",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3Sg_"
                            ],
                            "english": "if/when s/he is disappointed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "toowú k'é",
                            "url": "toowú k'é",
                            "tags": [
                                "Noun"
                            ],
                            "english": "good thoughts; felicity; happiness",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "néegu",
                    [
                        {
                            "tlingit": "du néegu",
                            "url": "néekw",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its sickness; illness; disease",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éex̲ yéi nei",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he menstruates (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi g̲anei",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__3Sg_"
                            ],
                            "english": "let her get her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi néini",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__3Sg_"
                            ],
                            "english": "if/when she gets her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi uwanéi",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "she got her menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ dís néegu ax̲ éet yéi uwanéi",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I got my menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du dís néegu du éet yéi oonéiych",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "she gets her menses (every month, e.g.)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "with their sadness,"
        },
        "164": {
            "startTime": 628.53,
            "endTime": 631.932,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "tóo daak",
                    [
                        {
                            "tlingit": "A tóo daak sagú!",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3Sg__"
                            ],
                            "english": "Appoint him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A tóo daak has sa.á!",
                            "url": "a tóo daak has awsi.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3Pl__"
                            ],
                            "english": "Appoint them!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo daak awsigút",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he appointed him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo daak asgútni",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg_3Sg__"
                            ],
                            "english": "if/when s/he appoints him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo daak asgútch",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he appoints him/her (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo daak ax̲sagoot",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3Sg__"
                            ],
                            "english": "let him/her appoint him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo daak oosgootch",
                            "url": "a tóo daak awsigút",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he appoints him/her (every time)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "tóo ashik̲eet",
                            "url": "tóo awshik̲eet",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "she's tired of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak",
                            "url": "daak",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "out to sea; out into the open; (falling) down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "sh tóo altóow",
                            "url": "sh tóo awdlitóow",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he is studying it; s/he studies it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tóo ashawdliháa",
                            "url": "sh tóo ashawdliháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he injured himself/herself",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tóo at x̲altóow",
                            "url": "sh tóo at wudlitóow",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "1Sg___"
                            ],
                            "english": "I study; I am studying",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a tóo at dult'ix' át",
                            "url": "a tóo at dult'ix'x̲i át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "freezer",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóo agashk̲eetch",
                            "url": "tóo awshik̲eet",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he gets tired of him/her (every time)",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "kei xíxch",
                    [
                        {
                            "tlingit": "kei xíxch",
                            "url": "kei uwaxíx",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg"
                            ],
                            "english": "it rises (regularly)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "a káa yei xíxch",
                            "url": "a káa wooxeex",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it falls on it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káa yei xíxch",
                            "url": "a káa wooxeex2",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg"
                            ],
                            "english": "it falls on it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "it was lingering on their minds,"
        },
        "165": {
            "startTime": 633.933,
            "endTime": 638.047,
            "tli": [
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "teeyí",
                    [],
                    []
                ],
                [
                    "yéeyi.",
                    [],
                    []
                ]
            ],
            "eng": "what had happened."
        },
        "166": {
            "startTime": 648.249,
            "endTime": 653.357,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "totem",
                    [],
                    []
                ],
                [
                    "pole",
                    [],
                    []
                ]
            ],
            "eng": "From there, in Haines"
        },
        "167": {
            "startTime": 653.357,
            "endTime": 657.227,
            "tli": [
                [
                    "deishóox’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they worked on"
        },
        "168": {
            "startTime": 657.227,
            "endTime": 659.14,
            "tli": [
                [
                    "a daa",
                    [
                        {
                            "tlingit": "a daa",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "around it; about it; concerning it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan daa",
                            "url": "gandaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "around the fire",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ daa",
                            "url": "át uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it flows to it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa tuwatee",
                            "url": "a daa tuwatee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "s/he cares about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa yas.éix̲",
                            "url": "a daa yawdzi.aa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he is examining it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daa aawadaak̲",
                            "url": "du daa aawadaak̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he sobered up",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yéi jiwduwanei.",
                    [
                        {
                            "tlingit": "yéi jiwduwanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "4H___"
                            ],
                            "english": "people worked",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "a totem pole."
        },
        "169": {
            "startTime": 659.14,
            "endTime": 662.102,
            "tli": [
                [
                    "Shux’wáanáx̲",
                    [],
                    []
                ],
                [
                    "k̲u.a",
                    [
                        {
                            "tlingit": "k̲u.a",
                            "url": "k̲u.aa",
                            "tags": [
                                "Particle"
                            ],
                            "english": "however",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kawduwa.aak̲w,",
                    [],
                    []
                ]
            ],
            "eng": "In the beginning, thoug̲ they tried,"
        },
        "170": {
            "startTime": 662.102,
            "endTime": 663.725,
            "tli": [
                [
                    "yáadáx̲",
                    [],
                    []
                ]
            ],
            "eng": "the trees"
        },
        "171": {
            "startTime": 663.725,
            "endTime": 665.646,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aas",
                    [
                        {
                            "tlingit": "aas",
                            "url": "aas",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tree (esp. conifer)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "from here"
        },
        "172": {
            "startTime": 670.33,
            "endTime": 673.534,
            "tli": [
                [
                    "k̲usteeyí",
                    [],
                    []
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲u.a",
                    [
                        {
                            "tlingit": "k̲u.a",
                            "url": "k̲u.aa",
                            "tags": [
                                "Particle"
                            ],
                            "english": "however",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wootí.",
                    [],
                    []
                ]
            ],
            "eng": "were not rig̲t."
        },
        "173": {
            "startTime": 677.446,
            "endTime": 680.286,
            "tli": [
                [
                    "Wudik̲ás’",
                    [],
                    []
                ],
                [
                    "wudulg̲eejí",
                    [],
                    []
                ]
            ],
            "eng": "It cracked when they felled"
        },
        "174": {
            "startTime": 681.655,
            "endTime": 683.604,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aas",
                    [
                        {
                            "tlingit": "aas",
                            "url": "aas",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tree (esp. conifer)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tlein.",
                    [
                        {
                            "tlingit": "tlein",
                            "url": "tlein",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "big",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "a large tree."
        },
        "175": {
            "startTime": 689.951,
            "endTime": 691.898,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "goodáx̲",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why, from where –"
        },
        "176": {
            "startTime": 691.898,
            "endTime": 694.894,
            "tli": [
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "goodáx̲",
                    [],
                    []
                ]
            ],
            "eng": "I don’t know from where"
        },
        "177": {
            "startTime": 694.894,
            "endTime": 696.492,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "178": {
            "startTime": 696.492,
            "endTime": 701.459,
            "tli": [
                [
                    "yawdudlaag̲í",
                    [],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aas.",
                    [
                        {
                            "tlingit": "aas",
                            "url": "aas",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tree (esp. conifer)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they secured a tree."
        },
        "179": {
            "startTime": 701.459,
            "endTime": 703.741,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "géi",
                    [
                        {
                            "tlingit": "géi nooch",
                            "url": "woogéi",
                            "tags": [
                                "Verb",
                                "imperfective_habitual",
                                "3Sg"
                            ],
                            "english": "there are always many",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yisakú?",
                    [
                        {
                            "tlingit": "tlél yisakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg_3__"
                            ],
                            "english": "you don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "Do you not know?"
        },
        "180": {
            "startTime": 703.741,
            "endTime": 707.606,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "181": {
            "startTime": 713.929,
            "endTime": 718.547,
            "tli": [
                [
                    "K̲udax̲gahaa,",
                    [],
                    []
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gé",
                    [
                        {
                            "tlingit": "gé",
                            "url": "gé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative marks yes-no questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yisakú",
                    [
                        {
                            "tlingit": "tlél yisakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg_3__"
                            ],
                            "english": "you don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "goodáx̲",
                    [],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "K̲udax̲gahaa, do you not know from where"
        },
        "182": {
            "startTime": 718.547,
            "endTime": 721.959,
            "tli": [
                [
                    "aas",
                    [
                        {
                            "tlingit": "aas",
                            "url": "aas",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tree (esp. conifer)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tlein,",
                    [
                        {
                            "tlingit": "tlein",
                            "url": "tlein",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "big",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "totem",
                    [],
                    []
                ],
                [
                    "pole",
                    [],
                    []
                ],
                [
                    "yís.",
                    [
                        {
                            "tlingit": "a yís",
                            "url": "a yís",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "for it; to that end",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "they found a large tree, for our totem pole?"
        },
        "183": {
            "startTime": 723.209,
            "endTime": 725.891,
            "tli": [
                [
                    "K̲éix̲’dáx̲",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From Kake."
        },
        "184": {
            "startTime": 733.969,
            "endTime": 737.027,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "Tongass",
                    [],
                    []
                ],
                [
                    "yú",
                    [
                        {
                            "tlingit": "yú",
                            "url": "yú",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (distant), yonder",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲waa.áx̲.",
                    [
                        {
                            "tlingit": "x̲waa.áx̲",
                            "url": "aawa.áx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I heard it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I only heard that it was Tongass."
        },
        "185": {
            "startTime": 748.009,
            "endTime": 751.852,
            "tli": [
                [
                    "K̲u.éex’",
                    [],
                    []
                ],
                [
                    "tlein",
                    [
                        {
                            "tlingit": "tlein",
                            "url": "tlein",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "big",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi wdudzinei.",
                    [
                        {
                            "tlingit": "yéi wdudzinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "4H_3__"
                            ],
                            "english": "it was fixed",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "They put on a major K̲u.éex’ ."
        },
        "186": {
            "startTime": 751.852,
            "endTime": 754.521,
            "tli": [
                [
                    "Haat",
                    [
                        {
                            "tlingit": "haat",
                            "url": "haat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "current, tide",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat",
                            "url": "haat~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat~",
                            "url": "haat~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲uyaawagoo",
                    [],
                    []
                ]
            ],
            "eng": "They traveled here"
        },
        "187": {
            "startTime": 757.649,
            "endTime": 760.027,
            "tli": [
                [
                    "yaakw",
                    [
                        {
                            "tlingit": "yaakw",
                            "url": "yaakw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boat, canoe",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yíkt",
                    [
                        {
                            "tlingit": "yíkt",
                            "url": "a yík",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "in it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "in boats"
        },
        "188": {
            "startTime": 761.742,
            "endTime": 763.987,
            "tli": [
                [
                    "airplane",
                    [],
                    []
                ],
                [
                    "kát.",
                    [
                        {
                            "tlingit": "a kát",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kát adatéen",
                            "url": "kát adatéen",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he is wearing it; s/he has it on",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "A kát woodá!",
                            "url": "a kát yaawadáa",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3_"
                            ],
                            "english": "Keep an eye on him/her/it!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kát dul.us'ku át",
                            "url": "a káa dul.us'ku át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "washboard",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kát dul.us'ku át",
                            "url": "kát dul.us'ku át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "washboard",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du kát shutí!",
                            "url": "du kát ashuwatée",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__3"
                            ],
                            "english": "Blame it on him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kát yadu.us'ku át",
                            "url": "kát yadu.us'ku át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "wash basin",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "and on airplanes."
        },
        "189": {
            "startTime": 767.373,
            "endTime": 771.707,
            "tli": [
                [
                    "Nas’k",
                    [],
                    []
                ],
                [
                    "yagiyee",
                    [
                        {
                            "tlingit": "yagiyee",
                            "url": "yagee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagiyee",
                            "url": "yagiyee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagiyee",
                            "url": "yakyee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’aaknáx̲",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaawaxeex",
                    [
                        {
                            "tlingit": "yaawaxeex",
                            "url": "yaawaxeex",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg"
                            ],
                            "english": "it happened",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It occurred over three days,"
        },
        "190": {
            "startTime": 771.707,
            "endTime": 775.351,
            "tli": [
                [
                    "k̲u.éex’",
                    [],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kootéeyaa",
                    [
                        {
                            "tlingit": "kootéeyaa",
                            "url": "kootéeyaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "totem pole",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kei",
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wduyeeshí.",
                    [],
                    []
                ]
            ],
            "eng": "the k̲u.éex’ for raising the totem pole."
        },
        "191": {
            "startTime": 777.596,
            "endTime": 780.122,
            "tli": [
                [
                    "Japan-dáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They towed it"
        },
        "192": {
            "startTime": 783.215,
            "endTime": 786.634,
            "tli": [
                [
                    "Skaw",
                    [],
                    []
                ],
                [
                    "yíkt",
                    [
                        {
                            "tlingit": "yíkt",
                            "url": "a yík",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "in it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "with the Skaw"
        },
        "193": {
            "startTime": 786.634,
            "endTime": 788.986,
            "tli": [
                [
                    "wuduwax̲ácht.",
                    [],
                    []
                ]
            ],
            "eng": "from Japan."
        },
        "194": {
            "startTime": 788.986,
            "endTime": 791.507,
            "tli": [
                [
                    "Haat",
                    [
                        {
                            "tlingit": "haat",
                            "url": "haat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "current, tide",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat",
                            "url": "haat~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat~",
                            "url": "haat~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wuduwax̲ách.",
                    [],
                    []
                ]
            ],
            "eng": "They towed it here."
        },
        "195": {
            "startTime": 799.51,
            "endTime": 801.561,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They"
        },
        "196": {
            "startTime": 810.428,
            "endTime": 812.305,
            "tli": [
                [
                    "aas",
                    [
                        {
                            "tlingit": "aas",
                            "url": "aas",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tree (esp. conifer)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daanéichi",
                    [],
                    []
                ]
            ],
            "eng": "worked on the tree,"
        },
        "197": {
            "startTime": 812.305,
            "endTime": 818.085,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "machine,",
                    [],
                    []
                ],
                [
                    "Sauterberg",
                    [],
                    []
                ],
                [
                    "(?)",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "company",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the machine, the Soderberg Company,"
        },
        "198": {
            "startTime": 818.085,
            "endTime": 820.672,
            "tli": [
                [
                    "Oregon-dáx̲.",
                    [],
                    []
                ]
            ],
            "eng": "from Oregon."
        },
        "199": {
            "startTime": 828.991,
            "endTime": 830.5,
            "tli": [
                [
                    "Hasch",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was they"
        },
        "200": {
            "startTime": 830.5,
            "endTime": 833.419,
            "tli": [
                [
                    "K̲éex̲’t",
                    [],
                    []
                ],
                [
                    "éet has",
                    [
                        {
                            "tlingit": "ax̲ éet has wudishée",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl__1Sg_"
                            ],
                            "english": "they are helping me; they helped me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa éet has jiwdi.át",
                            "url": "k̲aa éet has jiwdi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they attacked someone",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet has x̲'awli.át",
                            "url": "du éet has x̲'awli.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl__3Sg_"
                            ],
                            "english": "they spoke to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet has udashéeych",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl__1Sg_"
                            ],
                            "english": "they help me (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa éet has jix̲da.aat",
                            "url": "k̲aa éet has jiwdi.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl___"
                            ],
                            "english": "let them attack someone",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa éet has jida.átni",
                            "url": "k̲aa éet has jiwdi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___"
                            ],
                            "english": "if/when they attack people",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet has x̲'ax̲la.aat",
                            "url": "du éet has x̲'awli.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl__3Sg_"
                            ],
                            "english": "let them speak to him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "Du éet hís'!",
                            "url": "du éet aawahís'",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Lend it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "i éet k̲oowaháa",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__2Sg_"
                            ],
                            "english": "it's your turn",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du éet yaan g̲ahaa",
                            "url": "du éet yaan uwaháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__3Sg_"
                            ],
                            "english": "let him/her be hungry",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du éet x̲'atán!",
                            "url": "du éet x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3Sg_"
                            ],
                            "english": "Speak to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet yaan awsiháa",
                            "url": "du éet yaan awsiháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it made him/her hungry",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "wudishee.",
                    [],
                    []
                ]
            ],
            "eng": "who helped Kake."
        },
        "201": {
            "startTime": 834.432,
            "endTime": 835.552,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is it."
        },
        "202": {
            "startTime": 835.552,
            "endTime": 837.645,
            "tli": [
                [
                    "Yeah.",
                    [],
                    []
                ]
            ],
            "eng": "Yeah."
        },
        "203": {
            "startTime": 842.626,
            "endTime": 847.957,
            "tli": [
                [
                    "Machinery",
                    [],
                    []
                ],
                [
                    "tlénx’",
                    [],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa éet has",
                    [
                        {
                            "tlingit": "haa éet k̲ug̲ahaa",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__1Pl_"
                            ],
                            "english": "let us have a turn",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa éet has jiwdi.át",
                            "url": "k̲aa éet has jiwdi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they attacked someone",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet has wudishée",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl__1Sg_"
                            ],
                            "english": "they are helping me; they helped me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet has x̲'awli.át",
                            "url": "du éet has x̲'awli.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl__3Sg_"
                            ],
                            "english": "they spoke to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa éet k̲oowaháa",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Pl_"
                            ],
                            "english": "it's our turn",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa éet k̲ooháaych",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__1Pl_"
                            ],
                            "english": "we get a turn (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél haa éet k̲uwuhá",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "__1Pl_"
                            ],
                            "english": "we didn't get a turn",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "Du éet hís'!",
                            "url": "du éet aawahís'",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Lend it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet yaan g̲ahaa",
                            "url": "du éet yaan uwaháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__1Sg_"
                            ],
                            "english": "let me be hungry",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du éet x̲'atán!",
                            "url": "du éet x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3Sg_"
                            ],
                            "english": "Speak to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet yaan awsiháa",
                            "url": "du éet yaan awsiháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it made him/her hungry",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "wudishee.",
                    [],
                    []
                ]
            ],
            "eng": "They helped us with large machinery."
        },
        "204": {
            "startTime": 853.103,
            "endTime": 855.982,
            "tli": [
                [
                    "Hásch",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kei has",
                    [
                        {
                            "tlingit": "kei has nasátk",
                            "url": "woosátk",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting faster",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has u.aatch",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go up (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nak'éin",
                            "url": "wook'éi",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are getting better",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nanéekw",
                            "url": "woonéekw",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're getting sick",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nalchán",
                            "url": "wulichán",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are starting to stink",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has anashk'án",
                            "url": "awshik'aan",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they are beginning to hate him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei has nalts'éin",
                            "url": "wulits'áa",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Pl__"
                            ],
                            "english": "they are starting to smell good",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "kei",
                            "url": "kei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "up",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "aawayísh.",
                    [
                        {
                            "tlingit": "aax̲ kei aawayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he pulled it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kínde kei aawayísh",
                            "url": "kínde kei aawayísh",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he pulled it up",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was they who raised it."
        },
        "205": {
            "startTime": 860.551,
            "endTime": 863.272,
            "tli": [
                [
                    "1971.",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "1971."
        },
        "206": {
            "startTime": 866.858,
            "endTime": 868.755,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "207": {
            "startTime": 895.676,
            "endTime": 900.386,
            "tli": [
                [
                    "Japanese",
                    [],
                    []
                ],
                [
                    "World’s",
                    [],
                    []
                ],
                [
                    "Fair",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The Japanese World’s Fair,"
        },
        "208": {
            "startTime": 900.386,
            "endTime": 907.846,
            "tli": [
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aawax̲oox̲,",
                    [
                        {
                            "tlingit": "aawax̲oox̲",
                            "url": "aawax̲oox̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he called him/her",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kootéeyaa,",
                    [
                        {
                            "tlingit": "kootéeyaa",
                            "url": "kootéeyaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "totem pole",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they called for the totem pole"
        },
        "209": {
            "startTime": 907.846,
            "endTime": 910.141,
            "tli": [
                [
                    "Japan-de.",
                    [],
                    []
                ]
            ],
            "eng": "to be broug̲t to Japan."
        },
        "210": {
            "startTime": 910.141,
            "endTime": 913.168,
            "tli": [
                [
                    "Áx’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kawduwayísh,",
                    [],
                    []
                ]
            ],
            "eng": "They raised it there,"
        },
        "211": {
            "startTime": 916.303,
            "endTime": 918.938,
            "tli": [
                [
                    "Japanee.",
                    [],
                    []
                ]
            ],
            "eng": "the Japanese."
        },
        "212": {
            "startTime": 925.769,
            "endTime": 928.672,
            "tli": [
                [
                    "Aadáx̲",
                    [
                        {
                            "tlingit": "aadáx̲ woogoot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it left there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ kawdiyaa",
                            "url": "aadáx̲ kawdiyaa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it disappeared from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ awsixáat'",
                            "url": "aadáx̲ awsixáat'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he dragged it away",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ nagútch",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "he/she/it leaves there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Aadáx̲ nagú!",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Leave there!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ yaa nagút",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is leaving there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ gug̲agóot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "future",
                                "3"
                            ],
                            "english": "he/she/it is going to leave there",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haat",
                    [
                        {
                            "tlingit": "haat",
                            "url": "haat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "current, tide",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat",
                            "url": "haat~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat~",
                            "url": "haat~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wuduwax̲ách",
                    [],
                    []
                ]
            ],
            "eng": "From there, they towed it here."
        },
        "213": {
            "startTime": 928.672,
            "endTime": 930.783,
            "tli": [
                [
                    "Osaka,",
                    [],
                    []
                ],
                [
                    "Japan.",
                    [],
                    []
                ]
            ],
            "eng": "Osaka, Japan."
        },
        "214": {
            "startTime": 930.783,
            "endTime": 932.925,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "215": {
            "startTime": 934.636,
            "endTime": 936.626,
            "tli": [
                [
                    "World’s",
                    [],
                    []
                ],
                [
                    "Fair.",
                    [],
                    []
                ]
            ],
            "eng": "World’s Fair."
        },
        "216": {
            "startTime": 939.134,
            "endTime": 941.521,
            "tli": [
                [
                    "Uwak̲ás’",
                    [],
                    []
                ],
                [
                    "k̲u.aa.",
                    [
                        {
                            "tlingit": "k̲u.aa",
                            "url": "k̲u.aa",
                            "tags": [
                                "Particle"
                            ],
                            "english": "however",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It cracked, thoug̲."
        },
        "217": {
            "startTime": 944.055,
            "endTime": 948.46,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "goox’",
                    [],
                    []
                ],
                [
                    "sá",
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "uwak̲ás’",
                    [],
                    []
                ]
            ],
            "eng": "I don’t know where the wind"
        },
        "218": {
            "startTime": 951.487,
            "endTime": 953.69,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "óoxjaach.",
                    [],
                    []
                ]
            ],
            "eng": "cracked it."
        },
        "219": {
            "startTime": 956.598,
            "endTime": 959.704,
            "tli": [
                [
                    "Áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "a daat",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yéi has jeewanei",
                    [
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi has jinaneich",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they work (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tuwdinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they felt that way",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "So they worked on it"
        },
        "220": {
            "startTime": 962.197,
            "endTime": 963.54,
            "tli": [
                [
                    "yáax’",
                    [],
                    []
                ]
            ],
            "eng": "when"
        },
        "221": {
            "startTime": 963.54,
            "endTime": 965.363,
            "tli": [
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "teeyi",
                    [],
                    []
                ],
                [
                    "aa,",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was broug̲t here."
        },
        "222": {
            "startTime": 969.001,
            "endTime": 971.35,
            "tli": [
                [
                    "Norman",
                    [],
                    []
                ],
                [
                    "Jackson",
                    [],
                    []
                ],
                [
                    "hás.",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Norman Jackson and others."
        },
        "223": {
            "startTime": 976.922,
            "endTime": 978.454,
            "tli": [
                [
                    "Typhoon,",
                    [],
                    []
                ]
            ],
            "eng": "A typhoon,"
        },
        "224": {
            "startTime": 978.454,
            "endTime": 980.592,
            "tli": [
                [
                    "typhoonch",
                    [],
                    []
                ],
                [
                    "uwak̲ás’.",
                    [],
                    []
                ]
            ],
            "eng": "a typhoon cracked it."
        },
        "225": {
            "startTime": 983.673,
            "endTime": 985.442,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "226": {
            "startTime": 990.804,
            "endTime": 995.779,
            "tli": [
                [
                    "Nas’k",
                    [],
                    []
                ],
                [
                    "yagiyee",
                    [
                        {
                            "tlingit": "yagiyee",
                            "url": "yagee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagiyee",
                            "url": "yagiyee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagiyee",
                            "url": "yakyee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’aaknáx̲",
                    [],
                    []
                ]
            ],
            "eng": "They put on a celebration"
        },
        "227": {
            "startTime": 995.779,
            "endTime": 999.631,
            "tli": [
                [
                    "celebrate",
                    [],
                    []
                ],
                [
                    "yéi has awsinei,",
                    [
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tudinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they feel that way",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "for three days,"
        },
        "228": {
            "startTime": 999.631,
            "endTime": 1002.073,
            "tli": [
                [
                    "yéi wdudzinei.",
                    [
                        {
                            "tlingit": "yéi wdudzinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "4H_3__"
                            ],
                            "english": "it was fixed",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "they put it on."
        },
        "229": {
            "startTime": 1019.848,
            "endTime": 1025.495,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "230": {
            "startTime": 1025.495,
            "endTime": 1028.575,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "231": {
            "startTime": 1028.575,
            "endTime": 1030.389,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "232": {
            "startTime": 1039.202,
            "endTime": 1044.132,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "233": {
            "startTime": 1044.132,
            "endTime": 1051.173,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "234": {
            "startTime": 1062.431,
            "endTime": 1067.281,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "restaurant",
                    [],
                    []
                ],
                [
                    "k̲ustéeyin",
                    [],
                    []
                ],
                [
                    "yáax’.",
                    [],
                    []
                ]
            ],
            "eng": "We used to not have a restaurant."
        },
        "235": {
            "startTime": 1067.281,
            "endTime": 1070.93,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "g̲oot",
                    [],
                    []
                ],
                [
                    "help",
                    [],
                    []
                ],
                [
                    "k̲ustéeyin.",
                    [],
                    []
                ]
            ],
            "eng": "We also didn’t have help."
        },
        "236": {
            "startTime": 1080.968,
            "endTime": 1084.612,
            "tli": [
                [
                    "Neilx’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲uduwa.oo.",
                    [],
                    []
                ]
            ],
            "eng": "People assembled at the houses."
        },
        "237": {
            "startTime": 1088.385,
            "endTime": 1091.879,
            "tli": [
                [
                    "At",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "gadus.ée",
                    [],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They would cook"
        },
        "238": {
            "startTime": 1091.879,
            "endTime": 1095.696,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hallx’.",
                    [],
                    []
                ]
            ],
            "eng": "at the hall."
        },
        "239": {
            "startTime": 1095.696,
            "endTime": 1098.737,
            "tli": [
                [
                    "Áx’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "dux̲áa",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They ate there."
        },
        "240": {
            "startTime": 1114.581,
            "endTime": 1117.781,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "al’eix̲",
                    [],
                    []
                ],
                [
                    "át",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasakú",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gaaw,",
                    [
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw",
                            "tags": [
                                "Noun"
                            ],
                            "english": "time",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bell",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw3",
                            "tags": [
                                "Noun"
                            ],
                            "english": "drum",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "gaaw",
                            "url": "gaaw4",
                            "tags": [
                                "Noun"
                            ],
                            "english": "clock",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I didn’t know about dancing at the time,"
        },
        "241": {
            "startTime": 1117.781,
            "endTime": 1121.225,
            "tli": [
                [
                    "1971.",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "in 1971."
        },
        "242": {
            "startTime": 1121.225,
            "endTime": 1126.461,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yátx’i",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲waaxích.",
                    [
                        {
                            "tlingit": "x̲waaxích",
                            "url": "aawaxích",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I exerted my full strength on it; I am exerting my full strength on it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I only put eﬀort into my children."
        },
        "243": {
            "startTime": 1126.461,
            "endTime": 1129.355,
            "tli": [
                [
                    "Daax’oonáx̲",
                    [],
                    []
                ]
            ],
            "eng": "Four of them"
        },
        "244": {
            "startTime": 1129.355,
            "endTime": 1132.017,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "naa",
                    [
                        {
                            "tlingit": "naa",
                            "url": "naa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nation; moiety; clan; band of people",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sh",
                    [
                        {
                            "tlingit": "sh kalneek",
                            "url": "sh kawdlineek",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he is telling a story",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh istáan",
                            "url": "sh istáan",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is lying down",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kahaadí",
                            "url": "sh kahaadí",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "crazy; insane; disturbed; mentally unbalanced",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh dagwáal",
                            "url": "sh wudigwál",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg"
                            ],
                            "english": "it's ringing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tool.át",
                            "url": "has sh il.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "1Pl___3"
                            ],
                            "english": "we are lying down",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kalneegí",
                            "url": "sh kalneegí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "preacher",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kalyéiyi",
                            "url": "sh kalyéiyi",
                            "tags": [
                                "Noun"
                            ],
                            "english": "prostitute",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "akdlik̲éis’",
                    [],
                    []
                ],
                [
                    ",",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "sewed their clothing,"
        },
        "245": {
            "startTime": 1132.017,
            "endTime": 1135.513,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x’óowx’u,",
                    [],
                    []
                ]
            ],
            "eng": "their robes,"
        },
        "246": {
            "startTime": 1135.513,
            "endTime": 1138.224,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "goodás’i.",
                    [],
                    []
                ]
            ],
            "eng": "their tunics."
        },
        "247": {
            "startTime": 1145.14,
            "endTime": 1148.244,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "yeisú",
                    [
                        {
                            "tlingit": "yeisú",
                            "url": "yeisú",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "just now; just then; still; yet",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I had not yet"
        },
        "248": {
            "startTime": 1148.244,
            "endTime": 1152.284,
            "tli": [
                [
                    "k̲aa ée",
                    [
                        {
                            "tlingit": "áx' k̲aa ée at dultóow yé",
                            "url": "áx' k̲aa ée at dultóow yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "school",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa et óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun",
                                "C"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲latéewu",
                    [],
                    []
                ]
            ],
            "eng": "taug̲t people Tlingit"
        },
        "249": {
            "startTime": 1152.284,
            "endTime": 1154.818,
            "tli": [
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaawaxeex.",
                    [
                        {
                            "tlingit": "yaawaxeex",
                            "url": "yaawaxeex",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg"
                            ],
                            "english": "it happened",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "when it occurred."
        },
        "250": {
            "startTime": 1163.799,
            "endTime": 1169.665,
            "tli": [
                [
                    "Wé ax̲",
                    [
                        {
                            "tlingit": "wé ax̲ éex̲ dashee aa",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg__1Sg_"
                            ],
                            "english": "the one who helps me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wé ax̲ x̲'éit yawdzi.aayi aa",
                            "url": "ax̲ x̲'éit yawdzi.áa",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg__1Sg_"
                            ],
                            "english": "the one who kissed me",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "tláa",
                    [
                        {
                            "tlingit": "du tláa",
                            "url": "du tláa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her mother",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲ éet",
                    [
                        {
                            "tlingit": "ax̲ éet k̲ug̲ahaa",
                            "url": "du éet k̲uwaháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__1Sg_"
                            ],
                            "english": "let me have a turn",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet yidishée",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg__1Sg_"
                            ],
                            "english": "you are helping me; you helped me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet yaan g̲ahaa",
                            "url": "du éet yaan uwaháa",
                            "tags": [
                                "Verb",
                                "hortative",
                                "__1Sg_"
                            ],
                            "english": "let me be hungry",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ dís néegu ax̲ éet yéi uwanéi",
                            "url": "du dís néegu du éet yéi uwanéi",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I got my menses",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet wudishée",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__1Sg_"
                            ],
                            "english": "s/he is helping me; s/he helped me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet g̲adashee",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__1Sg_"
                            ],
                            "english": "let him/her help me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ éet dashéeni",
                            "url": "ax̲ éet wudishée",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg__1Sg_"
                            ],
                            "english": "if/when s/he helps me",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Du éet hís'!",
                            "url": "du éet aawahís'",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Lend it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "K̲aa éet jeeyda.á!",
                            "url": "k̲aa éet has jiwdi.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Pl___"
                            ],
                            "english": "You all attack someone!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du éet x̲'atán!",
                            "url": "du éet x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3Sg_"
                            ],
                            "english": "Speak to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du éet x̲'ayla.á!",
                            "url": "du éet has x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Pl__3Sg_"
                            ],
                            "english": "You all speak to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du éet yaan awsiháa",
                            "url": "du éet yaan awsiháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "he/she/it made him/her hungry",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "wudashéejin,",
                    [],
                    []
                ]
            ],
            "eng": "I used to help my mother,"
        },
        "251": {
            "startTime": 1169.665,
            "endTime": 1172.573,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yátx’i",
                    [],
                    []
                ],
                [
                    "jiyís,",
                    [],
                    []
                ]
            ],
            "eng": "for my children,"
        },
        "252": {
            "startTime": 1172.573,
            "endTime": 1173.595,
            "tli": [
                [
                    "al’eix̲,",
                    [],
                    []
                ]
            ],
            "eng": "dancing,"
        },
        "253": {
            "startTime": 1173.595,
            "endTime": 1178.079,
            "tli": [
                [
                    "al’eix̲",
                    [],
                    []
                ],
                [
                    "daat",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yís",
                    [
                        {
                            "tlingit": "a yís",
                            "url": "a yís",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "for it; to that end",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x’óow.",
                    [],
                    []
                ]
            ],
            "eng": "robes for dancing."
        },
        "254": {
            "startTime": 1182.248,
            "endTime": 1185.093,
            "tli": [
                [
                    "Daax’oonináx̲",
                    [],
                    []
                ],
                [
                    "has wootee",
                    [
                        {
                            "tlingit": "yéi has wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Pl__"
                            ],
                            "english": "they were that way; they became that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it was that way; he/she/it became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ wootee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi wootee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stayed with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du wak̲shiyeex' yéi wootee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it appeared before him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "Four of them"
        },
        "255": {
            "startTime": 1185.093,
            "endTime": 1187.128,
            "tli": [
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awul’eix̲í.",
                    [],
                    []
                ]
            ],
            "eng": "danced."
        },
        "256": {
            "startTime": 1187.128,
            "endTime": 1189.528,
            "tli": [
                [
                    "K’idéin",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "uxíchch.",
                    [],
                    []
                ]
            ],
            "eng": "They really put eﬀort into it."
        },
        "257": {
            "startTime": 1192.652,
            "endTime": 1196.208,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "al’eix̲",
                    [],
                    []
                ],
                [
                    "daat át",
                    [
                        {
                            "tlingit": "du daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲ug̲asteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "s/he gets busy (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲ug̲asteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__1Sg_"
                            ],
                            "english": "I get busy (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át yei k̲usteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is busy (regularly)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲wasakú.",
                    [
                        {
                            "tlingit": "tlél x̲wasakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Sg_3__"
                            ],
                            "english": "I don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "I didn’t know about dancing."
        },
        "258": {
            "startTime": 1216.883,
            "endTime": 1220.253,
            "tli": [
                [
                    "Aadáx̲",
                    [
                        {
                            "tlingit": "aadáx̲ woogoot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it left there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ kawdiyaa",
                            "url": "aadáx̲ kawdiyaa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it disappeared from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ awsixáat'",
                            "url": "aadáx̲ awsixáat'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he dragged it away",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ nagútch",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "he/she/it leaves there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Aadáx̲ nagú!",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Leave there!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ yaa nagút",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is leaving there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ gug̲agóot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "future",
                                "3"
                            ],
                            "english": "he/she/it is going to leave there",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "g̲unéi",
                    [
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unayéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "beginning",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "start, begin",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yaawaxíx.",
                    [],
                    []
                ]
            ],
            "eng": "From there the event began."
        },
        "259": {
            "startTime": 1225.666,
            "endTime": 1231.577,
            "tli": [
                [
                    "“Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí",
                    [],
                    []
                ],
                [
                    "k̲ux̲",
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yax̲tudlaak̲.",
                    [],
                    []
                ],
                [
                    "”",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Let’s bring back our Tlingit way of life.”"
        },
        "260": {
            "startTime": 1231.577,
            "endTime": 1234.143,
            "tli": [
                [
                    "“Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí",
                    [],
                    []
                ],
                [
                    "tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Let’s really bring back"
        },
        "261": {
            "startTime": 1234.143,
            "endTime": 1239.672,
            "tli": [
                [
                    "k̲ux̲",
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yax̲tudlaak̲,”",
                    [],
                    []
                ],
                [
                    "yéi has yaawak̲aa",
                    [
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "our Tlingit way of life,” my grandparents"
        },
        "262": {
            "startTime": 1239.672,
            "endTime": 1243.579,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hás.",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "said."
        },
        "263": {
            "startTime": 1243.579,
            "endTime": 1246.739,
            "tli": [
                [
                    "“Eeshandéin",
                    [
                        {
                            "tlingit": "eeshandéin yoo kasheix̲",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "_3Sg__"
                            ],
                            "english": "s/he suffers (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yoo akawlishóo",
                            "url": "eeshandéin yoo akawlishóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "he/she/it tormented him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yoo kag̲ashoo",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg__"
                            ],
                            "english": "let him/her suffer",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yoo kashéini",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg__"
                            ],
                            "english": "if/when s/he suffers",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yaa kanashéin",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3Sg__"
                            ],
                            "english": "s/he is starting to suffer",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yoo kaawashóo",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he suffered",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "eeshandéin yoo kooshóowch",
                            "url": "eeshandéin yoo kaawashóo",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_3Sg__"
                            ],
                            "english": "s/he suffers (every time)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "haa yatee.",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a yáx̲ yatee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ yatee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needs it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi yatee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is staying with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi yatee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "“We are grieving."
        },
        "264": {
            "startTime": 1246.739,
            "endTime": 1250.566,
            "tli": [
                [
                    "A",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "eetínáx̲",
                    [],
                    []
                ],
                [
                    "haa yatee.",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a yáx̲ yatee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ yatee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needs it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi yatee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is staying with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi yatee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it is still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "We need it."
        },
        "265": {
            "startTime": 1250.566,
            "endTime": 1253.557,
            "tli": [
                [
                    "K̲ux̲",
                    [
                        {
                            "tlingit": "k̲ux̲",
                            "url": "k̲ux̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "(returning) back",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yax̲tudlaak̲.",
                    [],
                    []
                ],
                [
                    "”",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Let’s bring it back.”"
        },
        "266": {
            "startTime": 1257.086,
            "endTime": 1260.499,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sax̲waa.áx̲.",
                    [
                        {
                            "tlingit": "sax̲waa.áx̲",
                            "url": "aseiwa.áx̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I heard a voice",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what I heard from them."
        },
        "267": {
            "startTime": 1266.446,
            "endTime": 1271.25,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲ tuwáa sigóo",
                    [
                        {
                            "tlingit": "ax̲ tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__1Sg_"
                            ],
                            "english": "I want it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "ax̲ tuwáa wsigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3__1Sg_"
                            ],
                            "english": "I wanted it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ toowú sigóo",
                            "url": "du toowú wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I am happy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tuwáa kasyéiyi",
                            "url": "sh tuwáa kasyéiyi",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tourist",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__1Pl_"
                            ],
                            "english": "we want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__4H_"
                            ],
                            "english": "he/she/it is liked",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "yáa",
                    [
                        {
                            "tlingit": "yáa",
                            "url": "yá",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "this (right here)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why I would like to"
        },
        "268": {
            "startTime": 1271.25,
            "endTime": 1273.167,
            "tli": [
                [
                    "k̲u.éex’",
                    [],
                    []
                ],
                [
                    "daat át,",
                    [
                        {
                            "tlingit": "du daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲ug̲asteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "s/he gets busy (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲ug̲asteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__1Sg_"
                            ],
                            "english": "I get busy (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át yei k̲usteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is busy (regularly)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "hear very well"
        },
        "269": {
            "startTime": 1273.167,
            "endTime": 1275.993,
            "tli": [
                [
                    "k’idéin",
                    [],
                    []
                ],
                [
                    "át,",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "about"
        },
        "270": {
            "startTime": 1275.993,
            "endTime": 1279.526,
            "tli": [
                [
                    "a daat át",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__1Sg_"
                            ],
                            "english": "I was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat át k̲uwdzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he was busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲ug̲asteech",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__1Sg_"
                            ],
                            "english": "I get busy (every time)",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲wa.áx̲ji.",
                    [],
                    []
                ]
            ],
            "eng": "the k̲u.éex’."
        },
        "271": {
            "startTime": 1279.526,
            "endTime": 1281.717,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is it."
        }
    },
    "3": {
        "1": {
            "startTime": 7.311,
            "endTime": 10.376,
            "tli": [
                [
                    "Aadéi",
                    [],
                    []
                ],
                [
                    "tu.aayí",
                    [],
                    []
                ],
                [
                    "yéx̲",
                    [
                        {
                            "tlingit": "gaaw yéx̲",
                            "url": "gaaw yáx̲",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "on time; in time",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is the way we sat"
        },
        "2": {
            "startTime": 10.376,
            "endTime": 11.506,
            "tli": [
                [
                    "ch’áagun.",
                    [],
                    []
                ]
            ],
            "eng": "long ago."
        },
        "3": {
            "startTime": 11.506,
            "endTime": 13.272,
            "tli": [
                [
                    "Adátx’i",
                    [],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Children also"
        },
        "4": {
            "startTime": 13.272,
            "endTime": 15.267,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲oot",
                    [
                        {
                            "tlingit": "a x̲oot",
                            "url": "a x̲oo",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "among it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Woosh x̲oot yida.á!",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Pl___"
                            ],
                            "english": "You all come together!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot wutudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Pl___"
                            ],
                            "english": "we came together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot tuda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "1Pl___"
                            ],
                            "english": "we come together (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot tuda.átni",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "1Pl___"
                            ],
                            "english": "if/when we come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot g̲atuda.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Pl___"
                            ],
                            "english": "let us come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has wudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they came together",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "g̲anúkjin",
                    [],
                    []
                ]
            ],
            "eng": "used to sit with us"
        },
        "5": {
            "startTime": 15.267,
            "endTime": 17.289,
            "tli": [
                [
                    "gax̲dusakoowú",
                    [],
                    []
                ]
            ],
            "eng": "so they will know"
        },
        "6": {
            "startTime": 17.289,
            "endTime": 19.989,
            "tli": [
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naneiní.",
                    [
                        {
                            "tlingit": "yéi naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg__"
                            ],
                            "english": "if/when that happens to him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneiní",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg"
                            ],
                            "english": "if/when that happens",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_1Sg__"
                            ],
                            "english": "if/when that happens to me",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "how things go."
        },
        "7": {
            "startTime": 19.989,
            "endTime": 22.748,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "koogéiyi",
                    [
                        {
                            "tlingit": "ch'a koogéiyi",
                            "url": "ch'a koogéiyi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "however, any which way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "át",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It wasn’t any old way,"
        },
        "8": {
            "startTime": 22.748,
            "endTime": 26.72,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kadujes’",
                    [],
                    []
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "when they instructed us."
        },
        "9": {
            "startTime": 26.72,
            "endTime": 30.825,
            "tli": [
                [
                    "Tlék’",
                    [],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yagax̲duk̲aayích",
                    [],
                    []
                ],
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲oot",
                    [
                        {
                            "tlingit": "a x̲oot",
                            "url": "a x̲oo",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "among it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Woosh x̲oot yida.á!",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Pl___"
                            ],
                            "english": "You all come together!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot wutudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Pl___"
                            ],
                            "english": "we came together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot tuda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "1Pl___"
                            ],
                            "english": "we come together (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot tuda.átni",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "1Pl___"
                            ],
                            "english": "if/when we come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot g̲atuda.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Pl___"
                            ],
                            "english": "let us come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has wudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they came together",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "duwúk̲",
                    [],
                    []
                ]
            ],
            "eng": "What they will say is all rig̲t when they went among the people,"
        },
        "10": {
            "startTime": 30.825,
            "endTime": 34.561,
            "tli": [
                [
                    "toonúkji",
                    [],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "uháan",
                    [
                        {
                            "tlingit": "uháan",
                            "url": "uháan",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "we [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsú.",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "as we also sat."
        },
        "11": {
            "startTime": 34.561,
            "endTime": 36.592,
            "tli": [
                [
                    "“G̲asakoowút,”",
                    [],
                    []
                ]
            ],
            "eng": "“So you will know,”"
        },
        "12": {
            "startTime": 36.592,
            "endTime": 41.589,
            "tli": [
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daayaduk̲áa",
                    [],
                    []
                ],
                [
                    "noojéen",
                    [],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "they used to tell us, indeed."
        },
        "13": {
            "startTime": 41.589,
            "endTime": 43.589,
            "tli": [
                [
                    "Adátx’i",
                    [],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Children, also,"
        },
        "14": {
            "startTime": 43.589,
            "endTime": 46.417,
            "tli": [
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "jiyataaní,",
                    [],
                    []
                ]
            ],
            "eng": "were given to people,"
        },
        "15": {
            "startTime": 46.417,
            "endTime": 47.487,
            "tli": [
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲án",
                    [
                        {
                            "tlingit": "du x̲án",
                            "url": "du x̲án",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "near him/her, by him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲án aa",
                            "url": "du x̲án aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her mate, his \"old lady\"; her \"old man\"",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "next to you,"
        },
        "16": {
            "startTime": 47.487,
            "endTime": 50.012,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "káx’",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "g̲wanook",
                    [],
                    []
                ]
            ],
            "eng": "they would sit on us,"
        },
        "17": {
            "startTime": 50.012,
            "endTime": 52.03,
            "tli": [
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "akg̲wa.aax̲í.",
                    [],
                    []
                ]
            ],
            "eng": "as they heard it."
        },
        "18": {
            "startTime": 52.03,
            "endTime": 55.035,
            "tli": [
                [
                    "Tlék’",
                    [],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naneiní.",
                    [
                        {
                            "tlingit": "yéi naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg__"
                            ],
                            "english": "if/when that happens to him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneiní",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg"
                            ],
                            "english": "if/when that happens",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_1Sg__"
                            ],
                            "english": "if/when that happens to me",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was all rig̲t how it happened."
        },
        "19": {
            "startTime": 55.035,
            "endTime": 57.121,
            "tli": [
                [
                    "Yeedádi",
                    [],
                    []
                ],
                [
                    "k̲áawu",
                    [
                        {
                            "tlingit": "du k̲áawu",
                            "url": "du k̲áawu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her husband's clan brother; his/her man, boyfriend, husband",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲u.aa",
                    [
                        {
                            "tlingit": "k̲u.aa",
                            "url": "k̲u.aa",
                            "tags": [
                                "Particle"
                            ],
                            "english": "however",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "People now, thoug̲,"
        },
        "20": {
            "startTime": 57.121,
            "endTime": 58.202,
            "tli": [
                [
                    "ldakát",
                    [
                        {
                            "tlingit": "ldakát",
                            "url": "ldakát",
                            "tags": [
                                "Quantifier"
                            ],
                            "english": "all; every",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "run around"
        },
        "21": {
            "startTime": 58.202,
            "endTime": 61.193,
            "tli": [
                [
                    "adátx’i",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "nashíxch.",
                    [
                        {
                            "tlingit": "nashíxch",
                            "url": "aadé wjixeex",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg___3"
                            ],
                            "english": "he/she/it runs (every time)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "everywhere."
        },
        "22": {
            "startTime": 61.193,
            "endTime": 62.773,
            "tli": [
                [
                    "Ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is like that."
        },
        "23": {
            "startTime": 62.773,
            "endTime": 65.251,
            "tli": [
                [
                    "Lidzée",
                    [
                        {
                            "tlingit": "lidzée",
                            "url": "wulidzée",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3__"
                            ],
                            "english": "it's difficult",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is difficult"
        },
        "24": {
            "startTime": 65.251,
            "endTime": 69.356,
            "tli": [
                [
                    "iya.aax̲í",
                    [],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naneiní",
                    [
                        {
                            "tlingit": "yéi naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg__"
                            ],
                            "english": "if/when that happens to him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneiní",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg"
                            ],
                            "english": "if/when that happens",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_1Sg__"
                            ],
                            "english": "if/when that happens to me",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "for you to hear what happens."
        },
        "25": {
            "startTime": 71.946,
            "endTime": 74.375,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They always"
        },
        "26": {
            "startTime": 74.375,
            "endTime": 79.049,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een sh kadulneek",
                    [
                        {
                            "tlingit": "sh kadulneek",
                            "url": "sh kawdlineek",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "4H___"
                            ],
                            "english": "people are telling stories",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du een sh kalxútsni",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg__3Sg_"
                            ],
                            "english": "if/when s/he tries to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kawdlixúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he tried to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du een sh keelxúts!",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg__3Sg_"
                            ],
                            "english": "Try to dominate him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kalxútsx̲",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he tries to dominate him/her (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kax̲wdlixúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg__3Sg_"
                            ],
                            "english": "I tried to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kag̲alxúts",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3Sg_"
                            ],
                            "english": "let him/her try to dominate him/her",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "k̲oon sh kalneegí",
                            "url": "k̲oon sh kalneegí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "storyteller; preacher",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kalneegí",
                            "url": "sh kalneegí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "preacher",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan sh k̲asnei",
                            "url": "yan sh wudzinéi",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "let me get dressed up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yoo sh kadlishéik",
                            "url": "sh kawdlishoo",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he goes crazy (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh k̲'awdudliyél",
                            "url": "sh k̲'awdliyél",
                            "tags": [
                                "Verb",
                                "perfective",
                                "4H___"
                            ],
                            "english": "someone lied",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi sh tudinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he feels that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh toowú kdanéek",
                            "url": "sh toowú kdanéek",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg"
                            ],
                            "english": "s/he is telling his/her true feelings",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "used to tell us stories."
        },
        "27": {
            "startTime": 79.049,
            "endTime": 81.471,
            "tli": [
                [
                    "Schoolt",
                    [],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haat",
                    [
                        {
                            "tlingit": "haat",
                            "url": "haat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "current, tide",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat",
                            "url": "haat~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat~",
                            "url": "haat~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has na.átch",
                    [
                        {
                            "tlingit": "has na.átch",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk (every time)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "át has na.átch",
                            "url": "át has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk around (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aag̲áa has na.átch",
                            "url": "aag̲áa has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they go get it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé (ha)s na.átch",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___3"
                            ],
                            "english": "they go there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gánde (ha)s na.átch",
                            "url": "gánde (ha)s woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go to the bathroom (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "They also went to school,"
        },
        "28": {
            "startTime": 81.471,
            "endTime": 85.341,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "our grandparents, indeed."
        },
        "29": {
            "startTime": 86.711,
            "endTime": 89.642,
            "tli": [
                [
                    "“Has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "agux̲sakoowút",
                    [],
                    []
                ]
            ],
            "eng": "“So they will know"
        },
        "30": {
            "startTime": 89.642,
            "endTime": 97.189,
            "tli": [
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "agux̲sateenéet",
                    [],
                    []
                ],
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yaa",
                    [
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naneiní",
                    [
                        {
                            "tlingit": "yéi naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg__"
                            ],
                            "english": "if/when that happens to him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi at naneiní",
                            "url": "yéi at woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg"
                            ],
                            "english": "if/when that happens",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at naneiní",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_1Sg__"
                            ],
                            "english": "if/when that happens to me",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "schoolx’",
                    [],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "and so they will see what happens at school."
        },
        "31": {
            "startTime": 97.189,
            "endTime": 101.592,
            "tli": [
                [
                    "Tlék’",
                    [],
                    []
                ],
                [
                    "ayáx̲",
                    [
                        {
                            "tlingit": "ayáx̲",
                            "url": "ayáx̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "thus, that's how",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "wooteeyí",
                    [],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has akakg̲waneek.”",
                    [
                        {
                            "tlingit": "tlél has akakg̲waneek",
                            "url": "akaawaneek",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Pl_3__"
                            ],
                            "english": "they won't tell about it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "tlél akakg̲waneek",
                            "url": "akaawaneek",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg_3__"
                            ],
                            "english": "s/he won't tell about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél kei akakg̲waneek",
                            "url": "kei akaawaník",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he won't tell on him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél du een k̲unáax̲ daak̲ akakg̲waneek",
                            "url": "du een k̲unáax̲ daak̲ akaawaník",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "3Sg_3_3Sg_"
                            ],
                            "english": "s/he won't explain it to him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "They will tell us when it’s not rig̲t.”"
        },
        "32": {
            "startTime": 101.592,
            "endTime": 104.733,
            "tli": [
                [
                    "?",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "?"
        },
        "33": {
            "startTime": 104.733,
            "endTime": 108.266,
            "tli": [
                [
                    "Waang̲aneens",
                    [],
                    []
                ],
                [
                    "meeting",
                    [],
                    []
                ],
                [
                    "yéi has adaanéi",
                    [
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he works on it; s/he is working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has gug̲atée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_3Pl__"
                            ],
                            "english": "they will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Sometimes they would have meetings."
        },
        "34": {
            "startTime": 108.266,
            "endTime": 109.645,
            "tli": [
                [
                    "“Ha",
                    [],
                    []
                ],
                [
                    "wáa",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sáwé?”",
                    [],
                    []
                ]
            ],
            "eng": "“What is it?”"
        },
        "35": {
            "startTime": 109.645,
            "endTime": 111.606,
            "tli": [
                [
                    "yéi haa",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we were that way; we became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa ng̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Pl__"
                            ],
                            "english": "let us be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Pl__"
                            ],
                            "english": "we're that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa kg̲watée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_1Pl__"
                            ],
                            "english": "we will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa utí",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we aren't that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa wutee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we weren't that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "daayadu",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they said –"
        },
        "36": {
            "startTime": 111.606,
            "endTime": 112.614,
            "tli": [
                [
                    "“Ha",
                    [],
                    []
                ],
                [
                    "wáa",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sáwé?",
                    [],
                    []
                ]
            ],
            "eng": "“What is it?"
        },
        "37": {
            "startTime": 112.614,
            "endTime": 117.911,
            "tli": [
                [
                    "At",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "woonee",
                    [],
                    []
                ],
                [
                    "wáa",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "yidzigeet?”",
                    [],
                    []
                ]
            ],
            "eng": "What are you doing about what happened?”"
        },
        "38": {
            "startTime": 117.911,
            "endTime": 121.145,
            "tli": [
                [
                    "K̲únáx̲",
                    [
                        {
                            "tlingit": "k̲únáx̲",
                            "url": "k̲únáx̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has sh",
                    [
                        {
                            "tlingit": "has sh il.át",
                            "url": "has sh il.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are lying down",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has sh kalneek",
                            "url": "sh kawdlineek",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are telling a story",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yax̲ has sh il.aat",
                            "url": "yan has sh wudli.át",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they lie down (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has sh k̲'awdliyél",
                            "url": "sh k̲'awdliyél",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they lied",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tudinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they feel that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yínde has sh kawdli.aat",
                            "url": "yínde has sh kawdli.aat",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they bent over",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has sh kawdlineek",
                            "url": "sh kawdlineek",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they told a story",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "sh daxash washéen",
                            "url": "sh daxash washéen",
                            "tags": [
                                "Noun"
                            ],
                            "english": "chainsaw",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan sh usnéich",
                            "url": "yan sh wudzinéi",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg___"
                            ],
                            "english": "s/he gets dressed up (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan sh ustáaych",
                            "url": "yan sh wudzitáa",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg___"
                            ],
                            "english": "s/he lies down (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh kawdlishoo",
                            "url": "sh kawdlishoo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went crazy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh ulg̲ás'ch",
                            "url": "sh wudlig̲ás'",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg___"
                            ],
                            "english": "he/she/it scratches him/her/itself (every time)",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "kalník",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They really would tell us stories."
        },
        "39": {
            "startTime": 121.145,
            "endTime": 122.623,
            "tli": [
                [
                    "Aadéi",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The way –"
        },
        "40": {
            "startTime": 122.623,
            "endTime": 128.772,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "“tradition”",
                    [],
                    []
                ],
                [
                    "tlék’",
                    [],
                    []
                ],
                [
                    "ax̲ tuwáa ushgú",
                    [
                        {
                            "tlingit": "tlél ax̲ tuwáa ushgú",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "3__1Sg_"
                            ],
                            "english": "I don't want it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "ax̲ tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__1Sg_"
                            ],
                            "english": "I want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tuwáa kasyéiyi",
                            "url": "sh tuwáa kasyéiyi",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tourist",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲ tuwáa wsigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3__1Sg_"
                            ],
                            "english": "I wanted it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "haa tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__1Pl_"
                            ],
                            "english": "we want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ tuwáa gasgóoch",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3__1Sg_"
                            ],
                            "english": "I want it (every time)",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "yak̲aayí",
                    [],
                    []
                ],
                [
                    "yé",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why I don’t like the way they say “tradition,” indeed."
        },
        "41": {
            "startTime": 128.772,
            "endTime": 132.581,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyéech",
                    [],
                    []
                ],
                [
                    "siteeyí.",
                    [],
                    []
                ]
            ],
            "eng": "It is our way of life."
        },
        "42": {
            "startTime": 132.581,
            "endTime": 133.775,
            "tli": [
                [
                    "“G̲isakóo",
                    [],
                    []
                ]
            ],
            "eng": "“You will know"
        },
        "43": {
            "startTime": 133.775,
            "endTime": 136.045,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí",
                    [],
                    []
                ],
                [
                    "áyá,”",
                    [
                        {
                            "tlingit": "áyá",
                            "url": "áyá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "this (right here) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "our way of life,”"
        },
        "44": {
            "startTime": 136.045,
            "endTime": 138.57,
            "tli": [
                [
                    "yéi haa",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we were that way; we became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa ng̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Pl__"
                            ],
                            "english": "let us be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Pl__"
                            ],
                            "english": "we're that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa kg̲watée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_1Pl__"
                            ],
                            "english": "we will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa utí",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we aren't that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa wutee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we weren't that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "daayaduk̲áa",
                    [],
                    []
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "they used to say to us."
        },
        "45": {
            "startTime": 138.57,
            "endTime": 142.239,
            "tli": [
                [
                    "“K̲únáx̲",
                    [
                        {
                            "tlingit": "k̲únáx̲",
                            "url": "k̲únáx̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "g̲isakóo",
                    [],
                    []
                ],
                [
                    "wa.éich",
                    [],
                    []
                ],
                [
                    "tsú.",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“You, also, will really know it."
        },
        "46": {
            "startTime": 142.239,
            "endTime": 146.411,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲ukg̲ahaa",
                    [],
                    []
                ],
                [
                    "wa.é",
                    [
                        {
                            "tlingit": "wa.é",
                            "url": "wa.é",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "you (singular) [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áx’",
                    [],
                    []
                ],
                [
                    "g̲aynook,”",
                    [],
                    []
                ]
            ],
            "eng": "The moment will come when you also act like it,”"
        },
        "47": {
            "startTime": 146.411,
            "endTime": 151.039,
            "tli": [
                [
                    "yéi haa",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we were that way; we became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa ng̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Pl__"
                            ],
                            "english": "let us be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Pl__"
                            ],
                            "english": "we're that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa kg̲watée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_1Pl__"
                            ],
                            "english": "we will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa utí",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we aren't that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa wutee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we weren't that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "daayaduk̲áa",
                    [],
                    []
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "they used to tell us."
        },
        "48": {
            "startTime": 151.039,
            "endTime": 153.52,
            "tli": [
                [
                    "“Sakú.”",
                    [],
                    []
                ]
            ],
            "eng": "“Know it.”"
        },
        "49": {
            "startTime": 158.272,
            "endTime": 166.114,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "got",
                    [],
                    []
                ],
                [
                    "nervous.",
                    [],
                    []
                ],
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "got",
                    [],
                    []
                ],
                [
                    "scared.",
                    [],
                    []
                ]
            ],
            "eng": "I never got nervous. I never got scared."
        },
        "50": {
            "startTime": 166.114,
            "endTime": 169.489,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kaduník",
                    [],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They always told it to us."
        },
        "51": {
            "startTime": 169.489,
            "endTime": 171.613,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyéech",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is our way of life."
        },
        "52": {
            "startTime": 171.613,
            "endTime": 172.637,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is"
        },
        "53": {
            "startTime": 172.637,
            "endTime": 174.864,
            "tli": [
                [
                    "has adaanéi",
                    [
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he works on it; s/he is working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi adaanéi nooch",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective_habitual",
                                "3Sg_3__"
                            ],
                            "english": "s/he always works on it",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsú.",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "what they also worked on."
        },
        "54": {
            "startTime": 174.864,
            "endTime": 178.422,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí.",
                    [],
                    []
                ]
            ],
            "eng": "Our way of life."
        },
        "55": {
            "startTime": 178.422,
            "endTime": 180.203,
            "tli": [
                [
                    "Yak’éi",
                    [],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "Very good."
        },
        "56": {
            "startTime": 180.203,
            "endTime": 185.038,
            "tli": [
                [
                    "Tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tradition,",
                    [],
                    []
                ],
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tradition.",
                    [],
                    []
                ]
            ],
            "eng": "Not tradition, white people have tradition."
        },
        "57": {
            "startTime": 185.038,
            "endTime": 188.128,
            "tli": [
                [
                    "Tlék’",
                    [],
                    []
                ],
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ustí",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ ustí",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he isn't a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "We are not white people, indeed."
        },
        "58": {
            "startTime": 188.128,
            "endTime": 190.603,
            "tli": [
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sateeyéech",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "For we who are Tlingit,"
        },
        "59": {
            "startTime": 190.603,
            "endTime": 194.571,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲usteeyí",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it is our way of life."
        },
        "60": {
            "startTime": 194.571,
            "endTime": 196.155,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is it."
        },
        "61": {
            "startTime": 198.887,
            "endTime": 204.114,
            "tli": [
                [
                    "Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yátx’",
                    [],
                    []
                ],
                [
                    "tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yoo",
                    [
                        {
                            "tlingit": "yoo",
                            "url": "yoo",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "back and forth; to and fro; up and down",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’atángi",
                    [],
                    []
                ],
                [
                    "has du een",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du een aa",
                            "url": "du een aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her kinsman, moiety mate",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een dak̲áan",
                            "url": "du een wudik̲án",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is quarreling with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(du een) k̲ulagaaw",
                            "url": "(du een) k̲uwligaaw",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is fighting (him/her)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kalxútsni",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg__3Sg_"
                            ],
                            "english": "if/when s/he tries to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) du een woosh x̲'anax̲daxéet",
                            "url": "du een woosh x̲'awdixéet",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3Sg_"
                            ],
                            "english": "(just) let him/her argue with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du een k̲unáax̲ daak̲ kaneek!",
                            "url": "du een k̲unáax̲ daak̲ akaawaník",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Explain it to him/her!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x̲’ax̲atángi",
                    [],
                    []
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "I never spoke the Tlingit language with my children."
        },
        "62": {
            "startTime": 204.114,
            "endTime": 207.524,
            "tli": [
                [
                    "Dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "k̲u.aa",
                    [
                        {
                            "tlingit": "k̲u.aa",
                            "url": "k̲u.aa",
                            "tags": [
                                "Particle"
                            ],
                            "english": "however",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has du een",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du een aa",
                            "url": "du een aa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her kinsman, moiety mate",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een dak̲áan",
                            "url": "du een wudik̲án",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is quarreling with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(du een) k̲ulagaaw",
                            "url": "(du een) k̲uwligaaw",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he is fighting (him/her)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du een sh kalxútsni",
                            "url": "du een sh kawdlixúts",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg__3Sg_"
                            ],
                            "english": "if/when s/he tries to dominate him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "(ch'a) du een woosh x̲'anax̲daxéet",
                            "url": "du een woosh x̲'awdixéet",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg__3Sg_"
                            ],
                            "english": "(just) let him/her argue with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du een k̲unáax̲ daak̲ kaneek!",
                            "url": "du een k̲unáax̲ daak̲ akaawaník",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Explain it to him/her!",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "kax̲aneek",
                    [],
                    []
                ],
                [
                    "nuch,",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "In English, thoug̲ I told them,"
        },
        "63": {
            "startTime": 207.524,
            "endTime": 209.537,
            "tli": [
                [
                    "“This",
                    [],
                    []
                ],
                [
                    "is",
                    [],
                    []
                ],
                [
                    "our",
                    [],
                    []
                ],
                [
                    "way",
                    [],
                    []
                ],
                [
                    "of",
                    [],
                    []
                ],
                [
                    "life.”",
                    [],
                    []
                ]
            ],
            "eng": "“This is our way of life.”"
        },
        "64": {
            "startTime": 209.537,
            "endTime": 214.164,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daayaduk̲áa",
                    [],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’éináx̲",
                    [],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what we were told in Tlingit, indeed."
        },
        "65": {
            "startTime": 218.3,
            "endTime": 223.591,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi haa",
                    [
                        {
                            "tlingit": "yéi haa yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Pl__"
                            ],
                            "english": "we're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Pl__"
                            ],
                            "english": "we were that way; we became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa ng̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Pl__"
                            ],
                            "english": "let us be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Pl__"
                            ],
                            "english": "we're that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi haa kg̲watée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_1Pl__"
                            ],
                            "english": "we will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa utí",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we aren't that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi haa wutee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "_1Pl__"
                            ],
                            "english": "we weren't that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "daayaduk̲áa",
                    [],
                    []
                ],
                [
                    "nuch,",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "“Gu.aax̲",
                    [],
                    []
                ],
                [
                    "x’wán.”",
                    [],
                    []
                ]
            ],
            "eng": "That is why they told us, “Have courage.”"
        },
        "66": {
            "startTime": 223.591,
            "endTime": 225.324,
            "tli": [
                [
                    "Aaá.",
                    [
                        {
                            "tlingit": "aaá",
                            "url": "aaá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "yes",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "67": {
            "startTime": 228.33,
            "endTime": 234.626,
            "tli": [
                [
                    "Tlék’",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "koogéiyi",
                    [
                        {
                            "tlingit": "ch'a koogéiyi",
                            "url": "ch'a koogéiyi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "however, any which way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "át",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kaduník",
                    [],
                    []
                ],
                [
                    "noojéen",
                    [],
                    []
                ]
            ],
            "eng": "They never told it to us any old way,"
        },
        "68": {
            "startTime": 234.626,
            "endTime": 237.808,
            "tli": [
                [
                    "wáa sá",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "g̲wateeyéech",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "what will happen."
        },
        "69": {
            "startTime": 237.808,
            "endTime": 241.324,
            "tli": [
                [
                    "Meeting",
                    [],
                    []
                ],
                [
                    "yéi has adaanéi",
                    [
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi has jeewanei",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they worked",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he works on it; s/he is working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has gug̲atée",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future",
                                "_3Pl__"
                            ],
                            "english": "they will be that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They would hold meetings, indeed."
        },
        "70": {
            "startTime": 245.272,
            "endTime": 249.389,
            "tli": [
                [
                    "K̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "schoolt",
                    [],
                    []
                ],
                [
                    "tsú",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haat",
                    [
                        {
                            "tlingit": "haat",
                            "url": "haat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "current, tide",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat",
                            "url": "haat~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haat~",
                            "url": "haat~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "hither, toward speaker",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has na.átch.",
                    [
                        {
                            "tlingit": "has na.átch",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk (every time)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "át has na.átch",
                            "url": "át has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk around (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aag̲áa has na.átch",
                            "url": "aag̲áa has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they go get it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé (ha)s na.átch",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___3"
                            ],
                            "english": "they go there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gánde (ha)s na.átch",
                            "url": "gánde (ha)s woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go to the bathroom (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "And they went to school."
        },
        "71": {
            "startTime": 249.389,
            "endTime": 252.774,
            "tli": [
                [
                    "ANB",
                    [],
                    []
                ],
                [
                    "and",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "ANS",
                    [],
                    []
                ],
                [
                    "tsú,",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "ANB and ANS also,"
        },
        "72": {
            "startTime": 252.774,
            "endTime": 257.466,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲oot has na.átch",
                    [
                        {
                            "tlingit": "has na.átch",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk (every time)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "woosh x̲oot has uda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they come together (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has da.átni",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___"
                            ],
                            "english": "if/when they come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has wudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they came together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has g̲ada.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl___"
                            ],
                            "english": "let them come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oot has uda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "3Pl___"
                            ],
                            "english": "they haven't come together yet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has ux̲da.aadín",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Pl___"
                            ],
                            "english": "they would have come together",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "át has na.átch",
                            "url": "át has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk around (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aag̲áa has na.átch",
                            "url": "aag̲áa has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they go get it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé (ha)s na.átch",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___3"
                            ],
                            "english": "they go there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gánde (ha)s na.átch",
                            "url": "gánde (ha)s woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go to the bathroom (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲oot",
                            "url": "a x̲oo",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "among it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsú.",
                    [
                        {
                            "tlingit": "tsú",
                            "url": "tsú",
                            "tags": [
                                "Particle"
                            ],
                            "english": "also, too, as well",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they would go among us."
        },
        "73": {
            "startTime": 258.475,
            "endTime": 262.458,
            "tli": [
                [
                    "Tléik",
                    [],
                    []
                ],
                [
                    "ch’as",
                    [],
                    []
                ],
                [
                    "teacher",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It wasn’t only teachers."
        },
        "74": {
            "startTime": 262.458,
            "endTime": 265.439,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hás.",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Our grandparents."
        },
        "75": {
            "startTime": 265.439,
            "endTime": 272.069,
            "tli": [
                [
                    "Tléik’",
                    [],
                    []
                ],
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "dlaak’,",
                    [],
                    []
                ],
                [
                    "has du éesh.",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "It wasn’t their sister, their father."
        },
        "76": {
            "startTime": 272.069,
            "endTime": 275.448,
            "tli": [
                [
                    "Hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ldakát",
                    [
                        {
                            "tlingit": "ldakát",
                            "url": "ldakát",
                            "tags": [
                                "Quantifier"
                            ],
                            "english": "all; every",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "All of them"
        },
        "77": {
            "startTime": 275.448,
            "endTime": 277.645,
            "tli": [
                [
                    "atx̲á",
                    [
                        {
                            "tlingit": "atx̲á",
                            "url": "atx̲á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "food, a meal",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "atx̲a át",
                            "url": "atx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "moth",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yéi s adaanéi",
                    [
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he works on it; s/he is working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s yanak̲éich",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they say that (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa s shayandahéin",
                            "url": "shayawdihaa",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "_3__"
                            ],
                            "english": "there are getting to be a lot",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s nadanák̲",
                            "url": "has wudinaak̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are standing up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "prepared food."
        },
        "78": {
            "startTime": 277.645,
            "endTime": 283.165,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik’",
                    [],
                    []
                ],
                [
                    "áx’",
                    [],
                    []
                ],
                [
                    "yéi s",
                    [
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s x̲'ayak̲á",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they say that; they're saying that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tudinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they feel that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél yéi (ha)s gug̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Pl__"
                            ],
                            "english": "they won't be that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yei (ha)s nak̲éen",
                            "url": "has wook̲ee",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are sitting down",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yei (ha)s na.át",
                            "url": "áx̲ has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yei (ha)s akg̲wa.éex'",
                            "url": "aawa.éex'",
                            "tags": [
                                "Verb",
                                "future",
                                "3Pl_3Sg__"
                            ],
                            "english": "they will invite him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yei (ha)s gux̲latéesh",
                            "url": "wuliteesh",
                            "tags": [
                                "Verb",
                                "future",
                                "_3Pl__"
                            ],
                            "english": "they will be lonely",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "utée",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why they never went there."
        },
        "79": {
            "startTime": 283.165,
            "endTime": 285.165,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Our grandparents"
        },
        "80": {
            "startTime": 285.165,
            "endTime": 287.563,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "latíneech",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "watched us."
        },
        "81": {
            "startTime": 287.563,
            "endTime": 288.864,
            "tli": [
                [
                    "Hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They"
        },
        "82": {
            "startTime": 288.864,
            "endTime": 292.064,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲oot has na.átch.",
                    [
                        {
                            "tlingit": "woosh x̲oot has uda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they come together (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has na.átch",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk (every time)",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "woosh x̲oot has da.átni",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___"
                            ],
                            "english": "if/when they come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has wudi.át",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they came together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has g̲ada.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl___"
                            ],
                            "english": "let them come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oot has uda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "3Pl___"
                            ],
                            "english": "they haven't come together yet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "woosh x̲oot has ux̲da.aadín",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Pl___"
                            ],
                            "english": "they would have come together",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "át has na.átch",
                            "url": "át has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they walk around (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aag̲áa has na.átch",
                            "url": "aag̲áa has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "they go get it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé (ha)s na.átch",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___3"
                            ],
                            "english": "they go there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gánde (ha)s na.átch",
                            "url": "gánde (ha)s woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they go to the bathroom (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a x̲oot",
                            "url": "a x̲oo",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "among it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "would go among us."
        },
        "83": {
            "startTime": 292.064,
            "endTime": 295.736,
            "tli": [
                [
                    "Haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has at",
                    [
                        {
                            "tlingit": "has at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they eat; they are eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they sing; they are singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they drink; they are drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has at shook̲",
                            "url": "at uwashúk̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they laugh; they are laughing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has at kawlishee",
                            "url": "at kawlishee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they composed a song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "sh tóo has at iltóow",
                            "url": "sh tóo at wudlitóow",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they study; they are studying",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has at wooshee",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they sang",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gatú",
                            "url": "at gutú",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at la.át",
                            "url": "at la.át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "baggage, luggage; things, stuff packed up for carrying",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at kanútst",
                            "url": "at kaawanúts",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3"
                            ],
                            "english": "s/he is trying to grin",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "kaníkji",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They would tell us things."
        },
        "84": {
            "startTime": 297.494,
            "endTime": 299.53,
            "tli": [
                [
                    "Tléik’",
                    [],
                    []
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "shuk̲déin",
                    [],
                    []
                ]
            ],
            "eng": "It wasn’t a laug̲ing matter,"
        },
        "85": {
            "startTime": 299.53,
            "endTime": 305.828,
            "tli": [
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’atángi",
                    [],
                    []
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "what they used to say to us."
        },
        "86": {
            "startTime": 305.828,
            "endTime": 308.061,
            "tli": [
                [
                    "Áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "haa",
                    [
                        {
                            "tlingit": "haa",
                            "url": "haa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "our [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "haa",
                            "url": "haa2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "us [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’aduwóos’",
                    [],
                    []
                ],
                [
                    "nuch,",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They would tell us,"
        },
        "87": {
            "startTime": 308.061,
            "endTime": 311.101,
            "tli": [
                [
                    "“Yisikóo",
                    [
                        {
                            "tlingit": "yisikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg_3__"
                            ],
                            "english": "you know it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gé?",
                    [
                        {
                            "tlingit": "gé",
                            "url": "gé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative marks yes-no questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Do you know?"
        },
        "88": {
            "startTime": 311.101,
            "endTime": 312.976,
            "tli": [
                [
                    "Tléik’",
                    [],
                    []
                ],
                [
                    "yisakoowú,",
                    [],
                    []
                ]
            ],
            "eng": "If you don’t know,"
        },
        "89": {
            "startTime": 312.976,
            "endTime": 315.837,
            "tli": [
                [
                    "“A daa",
                    [
                        {
                            "tlingit": "a daa",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "around it; about it; concerning it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan daa",
                            "url": "gandaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "around the fire",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ daa",
                            "url": "át uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it flows to it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa tuwatee",
                            "url": "a daa tuwatee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "s/he cares about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa yas.éix̲",
                            "url": "a daa yawdzi.aa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he is examining it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daa aawadaak̲",
                            "url": "du daa aawadaak̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he sobered up",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "tlék’",
                    [],
                    []
                ],
                [
                    "yisakú?”",
                    [
                        {
                            "tlingit": "tlél yisakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg_3__"
                            ],
                            "english": "you don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "“What is it that you don’t know?”"
        },
        "90": {
            "startTime": 320.06,
            "endTime": 322.223,
            "tli": [
                [
                    "Wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "school",
                    [],
                    []
                ]
            ],
            "eng": "In school,"
        },
        "91": {
            "startTime": 322.223,
            "endTime": 327.003,
            "tli": [
                [
                    "dleit k̲áa",
                    [
                        {
                            "tlingit": "dleit k̲áa",
                            "url": "dleit k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "White, European, Caucasian (man or person)",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "dleit",
                            "url": "dleit",
                            "tags": [
                                "Noun"
                            ],
                            "english": "snow",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "dleit",
                            "url": "dleit2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "white",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x̲’éináx̲",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’a.áx̲ji",
                    [],
                    []
                ],
                [
                    "nuch,",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they would hear it in English"
        },
        "92": {
            "startTime": 327.003,
            "endTime": 329.32,
            "tli": [
                [
                    "“Do",
                    [],
                    []
                ],
                [
                    "you",
                    [],
                    []
                ],
                [
                    "understand?”",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé –",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Do you understand?” they would –"
        },
        "93": {
            "startTime": 330.552,
            "endTime": 333.613,
            "tli": [
                [
                    "“Do",
                    [],
                    []
                ],
                [
                    "you",
                    [],
                    []
                ],
                [
                    "understand?”",
                    [],
                    []
                ],
                [
                    "they",
                    [],
                    []
                ],
                [
                    "would",
                    [
                        {
                            "tlingit": "[does not occur; would use kei nanéek dei \"she's starting to have (labor) pains\"]",
                            "url": "atk'átsk'u aawa.oo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "say.",
                    [],
                    []
                ]
            ],
            "eng": "“Do you understand?” they would say."
        },
        "94": {
            "startTime": 335.494,
            "endTime": 338.31,
            "tli": [
                [
                    "“Yisikóo",
                    [
                        {
                            "tlingit": "yisikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg_3__"
                            ],
                            "english": "you know it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gé?”",
                    [
                        {
                            "tlingit": "gé",
                            "url": "gé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative marks yes-no questions]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "they",
                    [],
                    []
                ],
                [
                    "would",
                    [
                        {
                            "tlingit": "[does not occur; would use kei nanéek dei \"she's starting to have (labor) pains\"]",
                            "url": "atk'átsk'u aawa.oo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tell",
                    [],
                    []
                ],
                [
                    "us.",
                    [],
                    []
                ]
            ],
            "eng": "“Do you know?” they would tell us."
        },
        "95": {
            "startTime": 341.937,
            "endTime": 345.835,
            "tli": [
                [
                    "Tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yisakoowú,",
                    [],
                    []
                ],
                [
                    "they",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "got",
                    [],
                    []
                ],
                [
                    "impatient.",
                    [],
                    []
                ]
            ],
            "eng": "If you didn’t know, they never got impatient."
        },
        "96": {
            "startTime": 345.835,
            "endTime": 349.263,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "would",
                    [
                        {
                            "tlingit": "[does not occur; would use kei nanéek dei \"she's starting to have (labor) pains\"]",
                            "url": "atk'átsk'u aawa.oo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "say,",
                    [],
                    []
                ],
                [
                    "“Wáa",
                    [
                        {
                            "tlingit": "wáa sá",
                            "url": "wáa sá",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "how",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wáa yateeyi yéix'",
                            "url": "wáa yateeyi yéix'",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "sometimes",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "tléik’",
                    [],
                    []
                ],
                [
                    "yisakú?”",
                    [
                        {
                            "tlingit": "tlél yisakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg_3__"
                            ],
                            "english": "you don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They never would say, “Why don’t you know?”"
        },
        "97": {
            "startTime": 349.263,
            "endTime": 351.913,
            "tli": [
                [
                    "“A daa",
                    [
                        {
                            "tlingit": "a daa",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun"
                            ],
                            "english": "around it; about it; concerning it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "gaan daa",
                            "url": "gandaa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "around the fire",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ daa",
                            "url": "át uwadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it flows to it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a daa sá",
                            "url": "ch'a daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anything; whatever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa tuwatee",
                            "url": "a daa tuwatee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "s/he cares about it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "hél daa sá",
                            "url": "tlél daa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nothing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a daa yas.éix̲",
                            "url": "a daa yawdzi.aa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he is examining it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daa aawadaak̲",
                            "url": "du daa aawadaak̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he sobered up",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "tléik’",
                    [],
                    []
                ],
                [
                    "yisakú?”",
                    [
                        {
                            "tlingit": "tlél yisakú",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "2Sg_3__"
                            ],
                            "english": "you don't know",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "“What is it that you don’t know?"
        },
        "98": {
            "startTime": 354.372,
            "endTime": 357.252,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kagax̲tunéek.”",
                    [],
                    []
                ]
            ],
            "eng": "We will tell you.”"
        },
        "99": {
            "startTime": 362.153,
            "endTime": 367.096,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "excused",
                    [],
                    []
                ],
                [
                    "us",
                    [],
                    []
                ],
                [
                    "or",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "had",
                    [],
                    []
                ],
                [
                    "said",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They never excused us or never had said –"
        },
        "100": {
            "startTime": 367.096,
            "endTime": 370.447,
            "tli": [
                [
                    "made",
                    [],
                    []
                ],
                [
                    "fun",
                    [],
                    []
                ],
                [
                    "or",
                    [],
                    []
                ],
                [
                    "anything.",
                    [],
                    []
                ]
            ],
            "eng": "made fun or anything."
        },
        "101": {
            "startTime": 373.38,
            "endTime": 375.721,
            "tli": [
                [
                    "“Gisakóo",
                    [],
                    []
                ],
                [
                    "déi.”",
                    [
                        {
                            "tlingit": "déi",
                            "url": "déi",
                            "tags": [
                                "Particle"
                            ],
                            "english": "now, this time",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Know it already.”"
        },
        "102": {
            "startTime": 375.721,
            "endTime": 379.13,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "never,",
                    [],
                    []
                ],
                [
                    "ever",
                    [],
                    []
                ],
                [
                    "degraded",
                    [],
                    []
                ],
                [
                    "each",
                    [],
                    []
                ],
                [
                    "other",
                    [
                        {
                            "tlingit": "[does not occur - semantically awkward for subjects other than 3rd person]",
                            "url": "aawayeek̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "1Sg_3Sg__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They never, ever degraded each other"
        },
        "103": {
            "startTime": 379.13,
            "endTime": 381.515,
            "tli": [
                [
                    "because",
                    [],
                    []
                ],
                [
                    "you",
                    [],
                    []
                ],
                [
                    "couldn’t",
                    [],
                    []
                ],
                [
                    "speak.",
                    [],
                    []
                ]
            ],
            "eng": "because you couldn’t speak."
        },
        "104": {
            "startTime": 383.136,
            "endTime": 386.54,
            "tli": [
                [
                    "Tléik’",
                    [],
                    []
                ],
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲udaadunéiyin",
                    [],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They never treated people that way, indeed."
        },
        "105": {
            "startTime": 388.113,
            "endTime": 393.271,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "k’át",
                    [],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "saayí",
                    [
                        {
                            "tlingit": "du saayí",
                            "url": "du saayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her name; his/her namesake",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du saayí",
                            "url": "saa",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its name",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "isakoowú",
                    [],
                    []
                ]
            ],
            "eng": "If you know your name,"
        },
        "106": {
            "startTime": 393.271,
            "endTime": 398.741,
            "tli": [
                [
                    "k̲únáx̲",
                    [
                        {
                            "tlingit": "k̲únáx̲",
                            "url": "k̲únáx̲",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has du tuwáa",
                    [
                        {
                            "tlingit": "has du tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__3Pl_"
                            ],
                            "english": "they want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has du tuwáa wsigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3__3Pl_"
                            ],
                            "english": "they wanted it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has du tuwáa gasgóoch",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3__3Pl_"
                            ],
                            "english": "they want it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél has du tuwáa ushgú",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective_negative",
                                "3__3Pl_"
                            ],
                            "english": "they don't want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has du tuwáa kei nasgwéin",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3__3Pl_"
                            ],
                            "english": "they are beginning to want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél has du tuwáa wushgóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "3__3Pl_"
                            ],
                            "english": "they didn't want it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has du tuwáa kei gux̲sagóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "future",
                                "3__3Pl_"
                            ],
                            "english": "they will want it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "sh tuwáa kasyéiyi",
                            "url": "sh tuwáa kasyéiyi",
                            "tags": [
                                "Noun"
                            ],
                            "english": "tourist",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du tuwáa sigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3__3Sg_"
                            ],
                            "english": "s/he wants it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tuwáa wsigóo",
                            "url": "du tuwáa wsigóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3__3Sg_"
                            ],
                            "english": "s/he wanted it",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "k̲’asigóo,",
                    [],
                    []
                ]
            ],
            "eng": "they really enjoyed that,"
        },
        "107": {
            "startTime": 398.741,
            "endTime": 401.38,
            "tli": [
                [
                    "isakoowú",
                    [],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "saayí.",
                    [
                        {
                            "tlingit": "du saayí",
                            "url": "du saayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her name; his/her namesake",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du saayí",
                            "url": "saa",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its name",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "you knowing your name."
        },
        "108": {
            "startTime": 402.122,
            "endTime": 404.849,
            "tli": [
                [
                    "“Aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w?”",
                    [],
                    []
                ]
            ],
            "eng": "“Who is your grandparent?”"
        },
        "109": {
            "startTime": 404.849,
            "endTime": 406.823,
            "tli": [
                [
                    "Tléik’",
                    [],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tláa",
                    [
                        {
                            "tlingit": "du tláa",
                            "url": "du tláa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her mother",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh.",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "Not your mother and your father."
        },
        "110": {
            "startTime": 406.823,
            "endTime": 408.134,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w.",
                    [],
                    []
                ]
            ],
            "eng": "Your grandparent."
        },
        "111": {
            "startTime": 408.134,
            "endTime": 412.634,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ix̲’aduwóos’",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what they would ask you."
        },
        "112": {
            "startTime": 412.634,
            "endTime": 419.234,
            "tli": [
                [
                    "Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "tléik’",
                    [],
                    []
                ],
                [
                    "English",
                    [],
                    []
                ],
                [
                    "awsukoowúch",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "My grandmother didn’t know English."
        },
        "113": {
            "startTime": 419.234,
            "endTime": 421.918,
            "tli": [
                [
                    "“Aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "wa.és?”",
                    [],
                    []
                ],
                [
                    "she’d",
                    [],
                    []
                ],
                [
                    "ask.",
                    [],
                    []
                ]
            ],
            "eng": "“Who are you?” she’d ask."
        },
        "114": {
            "startTime": 421.918,
            "endTime": 425.841,
            "tli": [
                [
                    "“Who",
                    [],
                    []
                ],
                [
                    "is",
                    [],
                    []
                ],
                [
                    "it?”",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "“Who is it?”"
        },
        "115": {
            "startTime": 425.841,
            "endTime": 432.325,
            "tli": [
                [
                    "Ldakát",
                    [
                        {
                            "tlingit": "ldakát",
                            "url": "ldakát",
                            "tags": [
                                "Quantifier"
                            ],
                            "english": "all; every",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awsikóo",
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "Lingít",
                    [
                        {
                            "tlingit": "lingít",
                            "url": "lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "person",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Lingít",
                            "url": "Lingít",
                            "tags": [
                                "Noun"
                            ],
                            "english": "Tlingit",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "saayí",
                    [
                        {
                            "tlingit": "du saayí",
                            "url": "du saayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her name; his/her namesake",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du saayí",
                            "url": "saa",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its name",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aa sá",
                    [
                        {
                            "tlingit": "ch'a aa sá",
                            "url": "ch'a aa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a aa sá",
                            "url": "ch'a aadóo sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "sá",
                            "url": "sá",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[interrogative - marks WH-questions]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hásx̲",
                    [],
                    []
                ],
                [
                    "siteeyí.",
                    [],
                    []
                ]
            ],
            "eng": "They know all their Tlingit names and who their grandparents were."
        },
        "116": {
            "startTime": 432.325,
            "endTime": 434.159,
            "tli": [
                [
                    "“Aaa!”",
                    [],
                    []
                ]
            ],
            "eng": "“Yes!”"
        },
        "117": {
            "startTime": 434.159,
            "endTime": 436.578,
            "tli": [
                [
                    "Neil",
                    [
                        {
                            "tlingit": "neil",
                            "url": "neil",
                            "tags": [
                                "Noun"
                            ],
                            "english": "home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil",
                            "url": "neil~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil~",
                            "url": "neil~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲waagút",
                    [
                        {
                            "tlingit": "át x̲waagút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg___3"
                            ],
                            "english": "I arrived there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei x̲waagút",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg___"
                            ],
                            "english": "I went up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gági x̲waagút",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg___"
                            ],
                            "english": "I came out",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "een,",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "whenever",
                    [],
                    []
                ],
                [
                    "she’d",
                    [],
                    []
                ],
                [
                    "tell",
                    [],
                    []
                ],
                [
                    "me,",
                    [],
                    []
                ]
            ],
            "eng": "When I went into the house, whenever she’d tell me,"
        },
        "118": {
            "startTime": 436.578,
            "endTime": 439.503,
            "tli": [
                [
                    "“Héit",
                    [
                        {
                            "tlingit": "héit",
                            "url": "hé",
                            "tags": [
                                "Demonstrative",
                                "punctual"
                            ],
                            "english": "this/that (over here) (place)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲ánt",
                    [
                        {
                            "tlingit": "du x̲ánt",
                            "url": "du x̲án",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "next to him/her",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "uwagút.”",
                    [
                        {
                            "tlingit": "át uwagút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he arrived there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei uwagút",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak uwagút",
                            "url": "daak uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it walked into the open",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gági uwagút",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he came out",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "“They went to you over there.”"
        },
        "119": {
            "startTime": 441.77,
            "endTime": 444.365,
            "tli": [
                [
                    "“Wow,”",
                    [],
                    []
                ],
                [
                    "she’d",
                    [],
                    []
                ],
                [
                    "tell",
                    [],
                    []
                ],
                [
                    "me.",
                    [],
                    []
                ]
            ],
            "eng": "“Wow,” she’d tell me."
        },
        "120": {
            "startTime": 444.365,
            "endTime": 450.392,
            "tli": [
                [
                    "And",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "she’d",
                    [],
                    []
                ],
                [
                    "know,",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "by",
                    [],
                    []
                ],
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "léelk’w",
                    [],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á.",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "And she’d know, just by their grandparents, indeed."
        },
        "121": {
            "startTime": 450.392,
            "endTime": 452.249,
            "tli": [
                [
                    "Has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awóos’",
                    [],
                    []
                ],
                [
                    "noojéen,",
                    [],
                    []
                ]
            ],
            "eng": "They used to ask,"
        },
        "122": {
            "startTime": 452.249,
            "endTime": 454.356,
            "tli": [
                [
                    "“Aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "i",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "léelk’w?”",
                    [],
                    []
                ]
            ],
            "eng": "“Who is your grandparent?”"
        },
        "123": {
            "startTime": 454.356,
            "endTime": 458.351,
            "tli": [
                [
                    "“Who",
                    [],
                    []
                ],
                [
                    "are",
                    [],
                    []
                ],
                [
                    "your",
                    [],
                    []
                ],
                [
                    "grandparents?”",
                    [],
                    []
                ]
            ],
            "eng": "“Who are your grandparents?”"
        },
        "124": {
            "startTime": 458.351,
            "endTime": 460.243,
            "tli": [
                [
                    "Has awsikóo",
                    [
                        {
                            "tlingit": "has awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they know it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "They knew"
        },
        "125": {
            "startTime": 460.243,
            "endTime": 462.142,
            "tli": [
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tláa",
                    [
                        {
                            "tlingit": "du tláa",
                            "url": "du tláa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her mother",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "k̲a",
                    [
                        {
                            "tlingit": "k̲a",
                            "url": "k̲a",
                            "tags": [
                                "Particle"
                            ],
                            "english": "and",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "éesh.",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "people’s mothers and people’s fathers."
        },
        "126": {
            "startTime": 462.142,
            "endTime": 465.142,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yéi has",
                    [
                        {
                            "tlingit": "yéi has jiné",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they work; they are working",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Pl__"
                            ],
                            "english": "they're that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaanéi",
                            "url": "yéi adaanéi",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3__"
                            ],
                            "english": "they work on it; they are working on it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s adaayak̲á",
                            "url": "yéi adaayak̲á",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl_3Sg__"
                            ],
                            "english": "they tell him/her that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "jinéi",
                    [
                        {
                            "tlingit": "yéi jinéi nooch",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "imperfective_habitual",
                                "3Sg___"
                            ],
                            "english": "s/he always works",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲á",
                    [
                        {
                            "tlingit": "x̲á",
                            "url": "x̲á",
                            "tags": [
                                "Particle"
                            ],
                            "english": "you see",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "X̲á!",
                            "url": "aawax̲áa2",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Eat it!",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "wé at x̲a (k̲áa)",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective_attributive",
                                "3Sg___"
                            ],
                            "english": "the one who eats; the one who is eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They always worked on"
        },
        "127": {
            "startTime": 465.142,
            "endTime": 470.705,
            "tli": [
                [
                    "atx̲á",
                    [
                        {
                            "tlingit": "atx̲á",
                            "url": "atx̲á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "food, a meal",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "atx̲a át",
                            "url": "atx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "moth",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "káx̲,",
                    [
                        {
                            "tlingit": "a káx̲",
                            "url": "a ká",
                            "tags": [
                                "RelationalNoun",
                                "pertingent"
                            ],
                            "english": "along the surface of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "káx̲ yiditee",
                            "url": "káx̲ awditee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg_3__"
                            ],
                            "english": "you put it on",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ woodaa",
                            "url": "a kát yaawadáa",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg__3_"
                            ],
                            "english": "s/he keeps an eye on him/her/it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at káx̲ adéli",
                            "url": "at káx̲ adéli",
                            "tags": [
                                "Noun"
                            ],
                            "english": "guard, watchman",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ kadagaan",
                            "url": "a kát kawdigán",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3"
                            ],
                            "english": "it shines on it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ishx̲een",
                            "url": "a kát wujix̲ín",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "__3_"
                            ],
                            "english": "it falls on it (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du káx̲ ashutee",
                            "url": "du kát ashuwatée",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he blames it on him/her (regularly)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "because",
                    [],
                    []
                ],
                [
                    "we",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "had",
                    [],
                    []
                ],
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "store",
                    [],
                    []
                ],
                [
                    "yeedádi",
                    [],
                    []
                ],
                [
                    "yáx̲.",
                    [
                        {
                            "tlingit": "a yáx̲",
                            "url": "a yá",
                            "tags": [
                                "RelationalNoun",
                                "pertingent"
                            ],
                            "english": "along the face of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲",
                            "url": "a yáx̲",
                            "tags": [
                                "RelationalPostposition"
                            ],
                            "english": "like it, in accordance with it, as much as it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gaaw yáx̲",
                            "url": "gaaw yáx̲",
                            "tags": [
                                "Noun"
                            ],
                            "english": "on time; in time",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ yatee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it is like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ kaaxát",
                            "url": "a yáx̲ kaaxát",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__3_"
                            ],
                            "english": "it looks like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du yáx̲ taawa.ás",
                            "url": "du yáx̲ taawa.ás",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he misses him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Wooch yáx̲ nasné!",
                            "url": "wooch yáx̲ awsinei",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3__"
                            ],
                            "english": "Straighten it out!",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": ""
        }
    },
    "4": {
        "1": {
            "startTime": 1.04,
            "endTime": 3.273,
            "tli": [
                [
                    "Tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tlax̲",
                    [
                        {
                            "tlingit": "tlax̲",
                            "url": "tlax̲",
                            "tags": [
                                "Particle"
                            ],
                            "english": "very",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "a daat",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲wasikóo",
                    [
                        {
                            "tlingit": "x̲wasikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I know it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I don’t know much about"
        },
        "2": {
            "startTime": 3.273,
            "endTime": 5.074,
            "tli": [
                [
                    "yáat’át.",
                    [],
                    []
                ]
            ],
            "eng": "this."
        },
        "3": {
            "startTime": 5.074,
            "endTime": 8.93,
            "tli": [
                [
                    "Aaa.",
                    [],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "4": {
            "startTime": 8.93,
            "endTime": 13.403,
            "tli": [
                [
                    "Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "jeedáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲a.áx̲jin.",
                    [],
                    []
                ]
            ],
            "eng": "I used to hear it from my father."
        },
        "5": {
            "startTime": 13.403,
            "endTime": 15.798,
            "tli": [
                [
                    "Ách",
                    [
                        {
                            "tlingit": "ách at dusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách ax̲ jeet awateeyi aa",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "the one who gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ách at yadusx̲a át",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "fork",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du ách at dusx̲a ádi",
                            "url": "ách at dusx̲a át",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its fork",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is why"
        },
        "6": {
            "startTime": 15.798,
            "endTime": 19.14,
            "tli": [
                [
                    "a daat",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲wasikóo",
                    [
                        {
                            "tlingit": "x̲wasikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3__"
                            ],
                            "english": "I know it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I know about"
        },
        "7": {
            "startTime": 19.14,
            "endTime": 22.39,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "naxíxjin",
                    [],
                    []
                ],
                [
                    "ch’áakw",
                    [],
                    []
                ]
            ],
            "eng": "the way things used to happen long ago"
        },
        "8": {
            "startTime": 22.39,
            "endTime": 23.526,
            "tli": [
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "at the k̲u.éex’."
        },
        "9": {
            "startTime": 23.526,
            "endTime": 28.763,
            "tli": [
                [
                    "Aaa.",
                    [],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "10": {
            "startTime": 28.763,
            "endTime": 35.19,
            "tli": [
                [
                    "Shux’wáanáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naa káani",
                    [
                        {
                            "tlingit": "naa káani",
                            "url": "naa káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "master of ceremonies, elder of the opposite clan consulted conducting a ceremony",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du káani",
                            "url": "du káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her brother-in-law, sister-in-law",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "naa",
                            "url": "naa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nation; moiety; clan; band of people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "In the beginning the naa káani"
        },
        "11": {
            "startTime": 35.19,
            "endTime": 37.097,
            "tli": [
                [
                    "x̲’awoolt",
                    [],
                    []
                ],
                [
                    "nagoot,",
                    [],
                    []
                ]
            ],
            "eng": "would go to the door,"
        },
        "12": {
            "startTime": 37.097,
            "endTime": 41.289,
            "tli": [
                [
                    "nagoodín.",
                    [],
                    []
                ]
            ],
            "eng": "used to go to the door."
        },
        "13": {
            "startTime": 41.289,
            "endTime": 47.446,
            "tli": [
                [
                    "“Iwduwa.éex’,”",
                    [],
                    []
                ]
            ],
            "eng": "“You are invited,”"
        },
        "14": {
            "startTime": 47.45,
            "endTime": 49.231,
            "tli": [
                [
                    "yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yanask̲éich",
                    [],
                    []
                ],
                [
                    "wéi,",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they said"
        },
        "15": {
            "startTime": 49.231,
            "endTime": 51.939,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲áa.",
                    [
                        {
                            "tlingit": "k̲áa",
                            "url": "k̲áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "man; male; person, people",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "to the people."
        },
        "16": {
            "startTime": 51.939,
            "endTime": 53.651,
            "tli": [
                [
                    "“Iwduwa.éex’.”",
                    [],
                    []
                ]
            ],
            "eng": "“You are invited."
        },
        "17": {
            "startTime": 53.651,
            "endTime": 55.662,
            "tli": [
                [
                    "Okay.",
                    [],
                    []
                ]
            ],
            "eng": "Okay."
        },
        "18": {
            "startTime": 55.662,
            "endTime": 59.837,
            "tli": [
                [
                    "Aadáx̲",
                    [
                        {
                            "tlingit": "aadáx̲ woogoot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it left there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ kawdiyaa",
                            "url": "aadáx̲ kawdiyaa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it disappeared from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ awsixáat'",
                            "url": "aadáx̲ awsixáat'",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he dragged it away",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ nagútch",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "he/she/it leaves there (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Aadáx̲ nagú!",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Leave there!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ yaa nagút",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "he/she/it is leaving there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadáx̲ gug̲agóot",
                            "url": "aadáx̲ woogoot",
                            "tags": [
                                "Verb",
                                "future",
                                "3"
                            ],
                            "english": "he/she/it is going to leave there",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "g̲oot",
                    [],
                    []
                ],
                [
                    "yéide",
                    [],
                    []
                ],
                [
                    "hítyee",
                    [],
                    []
                ],
                [
                    "tóot",
                    [
                        {
                            "tlingit": "a tóot",
                            "url": "a tú",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "in it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot wooxeex",
                            "url": "du tóot wooxeex",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "s/he is worried about him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot wooxeex",
                            "url": "du tóot wooxeex2",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he's worried about him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tóot akawlidútl",
                            "url": "tóot akawlidútl",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he called him/her/it over to her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot yawdixún",
                            "url": "du tóot yawdixún",
                            "tags": [
                                "Verb",
                                "perfective",
                                "__3Sg_"
                            ],
                            "english": "s/he is possessed",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot naxíxch",
                            "url": "du tóot wooxeex",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3"
                            ],
                            "english": "s/he worries about him/her/it (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du tóot naxíxch",
                            "url": "du tóot wooxeex2",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "__3Sg_"
                            ],
                            "english": "s/he worries about him/her/it (every time)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there he would go"
        },
        "19": {
            "startTime": 59.837,
            "endTime": 64.342,
            "tli": [
                [
                    "nagoodín.",
                    [],
                    []
                ]
            ],
            "eng": "to another house."
        },
        "20": {
            "startTime": 64.342,
            "endTime": 66.609,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ]
            ],
            "eng": "That is how it was"
        },
        "21": {
            "startTime": 66.609,
            "endTime": 68.453,
            "tli": [
                [
                    "shux’waa",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "in the beginning"
        },
        "22": {
            "startTime": 68.453,
            "endTime": 70.819,
            "tli": [
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "with the k̲u.éex’."
        },
        "23": {
            "startTime": 70.819,
            "endTime": 73.534,
            "tli": [
                [
                    "“Iwduwa.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "“You are invited."
        },
        "24": {
            "startTime": 73.534,
            "endTime": 81.212,
            "tli": [
                [
                    "Iwduwa.éex’.”",
                    [],
                    []
                ]
            ],
            "eng": "You are invited.”"
        },
        "25": {
            "startTime": 81.212,
            "endTime": 83.229,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aadéi,",
                    [],
                    []
                ]
            ],
            "eng": "From there,"
        },
        "26": {
            "startTime": 83.229,
            "endTime": 85.439,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "dugoot",
                    [],
                    []
                ],
                [
                    "nuch,",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they would go to it,"
        },
        "27": {
            "startTime": 85.439,
            "endTime": 89.686,
            "tli": [
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "nagoodín",
                    [],
                    []
                ],
                [
                    "x̲áwé.",
                    [],
                    []
                ]
            ],
            "eng": "they really used to go."
        },
        "28": {
            "startTime": 89.686,
            "endTime": 94.905,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "g̲oot",
                    [],
                    []
                ],
                [
                    "yéide",
                    [],
                    []
                ],
                [
                    "naxíxjin,",
                    [],
                    []
                ]
            ],
            "eng": "It would happen differently,"
        },
        "29": {
            "startTime": 94.905,
            "endTime": 100.403,
            "tli": [
                [
                    "neil has woo.aadí.",
                    [
                        {
                            "tlingit": "neil has oox̲sa.aadín",
                            "url": "neil has awsi.át",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he would have let them in",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neil has yawdixún",
                            "url": "neil has yawdixún",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they entered dancing and showing their faces",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "wé áx̲ yaa (ha)s woo.aadi aa (has)",
                            "url": "áx̲ has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Pl___3"
                            ],
                            "english": "the ones who walked down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neil has oos.aatch",
                            "url": "neil has awsi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he lets them in (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neil has awsi.át",
                            "url": "neil has awsi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he let them in",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neil has x̲wasi.át",
                            "url": "neil has awsi.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "1Sg_3Pl__"
                            ],
                            "english": "I let them in",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neil has woox̲daxoonín",
                            "url": "neil has yawdixún",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Pl___"
                            ],
                            "english": "they would have entered dancing and showing their faces",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "neil",
                            "url": "neil",
                            "tags": [
                                "Noun"
                            ],
                            "english": "home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil~",
                            "url": "neil~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil",
                            "url": "neil~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "as they went to the house."
        },
        "30": {
            "startTime": 100.403,
            "endTime": 102.513,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’as",
                    [],
                    []
                ],
                [
                    "koogéiyi",
                    [
                        {
                            "tlingit": "ch'a koogéiyi",
                            "url": "ch'a koogéiyi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "however, any which way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It isn’t any old way,"
        },
        "31": {
            "startTime": 102.513,
            "endTime": 104.436,
            "tli": [
                [
                    "át has",
                    [
                        {
                            "tlingit": "át has .átni",
                            "url": "át has uwa.át",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___3"
                            ],
                            "english": "if/when they go there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has woo.aat",
                            "url": "át has woo.aat",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "they are walking around; they walked around",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has yaawagoo",
                            "url": "át has yaawagoo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "they are traveling around; they traveled around",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has jiwdihoo",
                            "url": "át jiwdihoo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___3"
                            ],
                            "english": "they are wading around; they waded around",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has lugúk̲ni",
                            "url": "át has luwagúk̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Pl__3"
                            ],
                            "english": "if/when they run to it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has wusikwaan",
                            "url": "át has wusikwaan",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "they are swimming around there; they swam around there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "át has yawdiháa",
                            "url": "át has yawdiháa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Pl__3"
                            ],
                            "english": "they crowded the place; they are crowded there",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "núkjin.",
                    [],
                    []
                ]
            ],
            "eng": "how they used to be seated."
        },
        "32": {
            "startTime": 104.436,
            "endTime": 107.111,
            "tli": [
                [
                    "Tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "Now."
        },
        "33": {
            "startTime": 107.111,
            "endTime": 108.64,
            "tli": [
                [
                    "K̲udzitee",
                    [
                        {
                            "tlingit": "k̲udzitee",
                            "url": "k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3"
                            ],
                            "english": "it exists; s/he is alive",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "k̲udzitee",
                            "url": "k̲uwdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3___"
                            ],
                            "english": "it exists; he/she/it is alive",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "There is"
        },
        "34": {
            "startTime": 108.64,
            "endTime": 114.955,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gug̲wak̲eiyi",
                    [],
                    []
                ],
                [
                    "yé.",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "a way they were going to sit."
        },
        "35": {
            "startTime": 114.955,
            "endTime": 116.502,
            "tli": [
                [
                    "Wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naa káani",
                    [
                        {
                            "tlingit": "naa káani",
                            "url": "naa káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "master of ceremonies, elder of the opposite clan consulted conducting a ceremony",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du káani",
                            "url": "du káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her brother-in-law, sister-in-law",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "naa",
                            "url": "naa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nation; moiety; clan; band of people",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The naa káani,"
        },
        "36": {
            "startTime": 116.502,
            "endTime": 117.602,
            "tli": [
                [
                    "neil",
                    [
                        {
                            "tlingit": "neil",
                            "url": "neil",
                            "tags": [
                                "Noun"
                            ],
                            "english": "home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil",
                            "url": "neil~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil~",
                            "url": "neil~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "woogoodí",
                    [
                        {
                            "tlingit": "wé áx̲ yaa woogoodi aa",
                            "url": "áx̲ woogoot",
                            "tags": [
                                "Verb",
                                "perfective_attributive",
                                "3Sg___3"
                            ],
                            "english": "the one who walked down along it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "as they went into the house,"
        },
        "37": {
            "startTime": 117.602,
            "endTime": 125.549,
            "tli": [
                [
                    "du saayí",
                    [
                        {
                            "tlingit": "du saayí",
                            "url": "du saayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her name; his/her namesake",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du saayí",
                            "url": "saa",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its name",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "a.éex’",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "would call their name."
        },
        "38": {
            "startTime": 125.549,
            "endTime": 128.288,
            "tli": [
                [
                    "“K̲’a.óosh",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "neil",
                    [
                        {
                            "tlingit": "neil",
                            "url": "neil",
                            "tags": [
                                "Noun"
                            ],
                            "english": "home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil",
                            "url": "neil~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "neil~",
                            "url": "neil~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "uwagút",
                    [
                        {
                            "tlingit": "át uwagút",
                            "url": "át uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he arrived there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "kei uwagút",
                            "url": "kei uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he went up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "daak uwagút",
                            "url": "daak uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3"
                            ],
                            "english": "he/she/it walked into the open",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "gági uwagút",
                            "url": "gági uwagút",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___"
                            ],
                            "english": "s/he came out",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "“K̲’a.óosh arrived at the house"
        },
        "39": {
            "startTime": 128.288,
            "endTime": 132.413,
            "tli": [
                [
                    "shát",
                    [
                        {
                            "tlingit": "du shát",
                            "url": "du shát",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his wife",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "een.”",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "with his wife.”"
        },
        "40": {
            "startTime": 132.413,
            "endTime": 134.637,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there"
        },
        "41": {
            "startTime": 134.637,
            "endTime": 139.601,
            "tli": [
                [
                    "awsikóo",
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naa káani.",
                    [
                        {
                            "tlingit": "naa káani",
                            "url": "naa káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "master of ceremonies, elder of the opposite clan consulted conducting a ceremony",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du káani",
                            "url": "du káani",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her brother-in-law, sister-in-law",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "naa",
                            "url": "naa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "nation; moiety; clan; band of people",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "the naa káani knew."
        },
        "42": {
            "startTime": 139.601,
            "endTime": 141.312,
            "tli": [
                [
                    "Wooshdáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "The would be sat"
        },
        "43": {
            "startTime": 141.312,
            "endTime": 148.02,
            "tli": [
                [
                    "g̲wanook.",
                    [],
                    []
                ]
            ],
            "eng": "separately."
        },
        "44": {
            "startTime": 148.02,
            "endTime": 150.936,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "hú",
                    [
                        {
                            "tlingit": "hú",
                            "url": "hú",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "he, she [independent]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Hú!",
                            "url": "Hú!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "Ouch!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Only he"
        },
        "45": {
            "startTime": 150.936,
            "endTime": 155.112,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "ajinatánch",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "would lead them to it."
        },
        "46": {
            "startTime": 155.112,
            "endTime": 158.905,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "g̲oot",
                    [],
                    []
                ],
                [
                    "yéit",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "His wife"
        },
        "47": {
            "startTime": 158.905,
            "endTime": 161.898,
            "tli": [
                [
                    "núkjin",
                    [],
                    []
                ],
                [
                    "has du shát.",
                    [
                        {
                            "tlingit": "du shát",
                            "url": "du shát",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his wife",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "would sit in a different place."
        },
        "48": {
            "startTime": 161.898,
            "endTime": 163.981,
            "tli": [
                [
                    "Tlél woosh",
                    [
                        {
                            "tlingit": "tlél woosh x̲oot wutuda.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Pl___"
                            ],
                            "english": "we didn't come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh kaanáx̲ wutuda.aat",
                            "url": "woosh kaanáx̲ has wudi.aat",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "1Pl___"
                            ],
                            "english": "we didn't gather together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oot tuda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "1Pl___"
                            ],
                            "english": "we haven't come together yet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oot has wuda.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "3Pl___"
                            ],
                            "english": "they didn't come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oot has uda.aatch",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual_negative",
                                "3Pl___"
                            ],
                            "english": "they haven't come together yet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh x̲oodé gax̲tuda.aat",
                            "url": "woosh x̲oot has wudi.át",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "1Pl___"
                            ],
                            "english": "we won't come together",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tlél woosh kaanáx̲ has wuda.aat",
                            "url": "woosh kaanáx̲ has wudi.aat",
                            "tags": [
                                "Verb",
                                "perfective_negative",
                                "3Pl___"
                            ],
                            "english": "they didn't gather together",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "woosh",
                            "url": "wooch",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "together [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "woosh",
                            "url": "woosh",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "together [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "át",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They never used to sit"
        },
        "49": {
            "startTime": 163.981,
            "endTime": 165.845,
            "tli": [
                [
                    "dusnoogún.",
                    [],
                    []
                ]
            ],
            "eng": "together."
        },
        "50": {
            "startTime": 165.845,
            "endTime": 171.921,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ],
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "That it how it used to be long ago."
        },
        "51": {
            "startTime": 171.921,
            "endTime": 174.373,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is"
        },
        "52": {
            "startTime": 174.373,
            "endTime": 176.554,
            "tli": [
                [
                    "atéeyin",
                    [],
                    []
                ]
            ],
            "eng": "how it used to be"
        },
        "53": {
            "startTime": 176.554,
            "endTime": 180.453,
            "tli": [
                [
                    "du.éex’",
                    [],
                    []
                ],
                [
                    "nuch",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dudzik̲aa",
                    [],
                    []
                ]
            ],
            "eng": "when they called"
        },
        "54": {
            "startTime": 180.453,
            "endTime": 185.316,
            "tli": [
                [
                    "has du saayí.",
                    [
                        {
                            "tlingit": "du saayí",
                            "url": "du saayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her name; his/her namesake",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du saayí",
                            "url": "saa",
                            "tags": [
                                "Noun",
                                "possessed"
                            ],
                            "english": "his/her/its name",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ]
            ],
            "eng": "their name."
        },
        "55": {
            "startTime": 185.316,
            "endTime": 187.284,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is what"
        },
        "56": {
            "startTime": 187.284,
            "endTime": 190.864,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲’éide",
                    [],
                    []
                ],
                [
                    "x̲a.áx̲jin",
                    [],
                    []
                ]
            ],
            "eng": "I used to hear from my father,"
        },
        "57": {
            "startTime": 190.864,
            "endTime": 196.744,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "k̲udutéewun",
                    [],
                    []
                ],
                [
                    "yé.",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "how people were taug̲t."
        },
        "58": {
            "startTime": 196.744,
            "endTime": 203.736,
            "tli": [
                [
                    "G̲unéi yaa",
                    [
                        {
                            "tlingit": "g̲unéi yaa nak̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he's starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa neek̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "2Sg___"
                            ],
                            "english": "you're starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa nayk̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "2Pl___"
                            ],
                            "english": "you all are starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa nduk̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "4H___"
                            ],
                            "english": "someone is starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa nx̲ak̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Sg___"
                            ],
                            "english": "I'm starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa ntook̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "1Pl___"
                            ],
                            "english": "we're starting to go",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "g̲unéi yaa (ha)s nak̲úx̲",
                            "url": "g̲unéi uwak̲úx̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are starting to go",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unayéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "beginning",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "start, begin",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "along; down",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yaa",
                            "url": "yaa2",
                            "tags": [
                                "Noun"
                            ],
                            "english": "trout (sea)",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "nasxíxi",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "As it began,"
        },
        "59": {
            "startTime": 203.736,
            "endTime": 206.681,
            "tli": [
                [
                    "hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "koogéiyi",
                    [
                        {
                            "tlingit": "ch'a koogéiyi",
                            "url": "ch'a koogéiyi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "however, any which way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it wasn’t any old way,"
        },
        "60": {
            "startTime": 206.681,
            "endTime": 212.534,
            "tli": [
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "usxíxjin",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "how it happened – no."
        },
        "61": {
            "startTime": 212.534,
            "endTime": 216.257,
            "tli": [
                [
                    "Has awsikóo",
                    [
                        {
                            "tlingit": "has awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they know it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "shux’wáanáx̲",
                    [],
                    []
                ]
            ],
            "eng": "They knew who would be"
        },
        "62": {
            "startTime": 216.257,
            "endTime": 220.489,
            "tli": [
                [
                    "ax̲’ux̲datáani",
                    [],
                    []
                ],
                [
                    "aa.",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the first to speak."
        },
        "63": {
            "startTime": 220.489,
            "endTime": 228.079,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ],
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "That is how it used to be long ago."
        },
        "64": {
            "startTime": 228.079,
            "endTime": 237.09,
            "tli": [
                [
                    "Yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’awataaní",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When he finished talking,"
        },
        "65": {
            "startTime": 237.09,
            "endTime": 239.934,
            "tli": [
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "g̲oot",
                    [],
                    []
                ],
                [
                    "aa",
                    [
                        {
                            "tlingit": "aa",
                            "url": "aa",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "one, one of [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "they would give it"
        },
        "66": {
            "startTime": 239.934,
            "endTime": 245.73,
            "tli": [
                [
                    "jeedéi",
                    [
                        {
                            "tlingit": "du jee",
                            "url": "du jee",
                            "tags": [
                                "Noun"
                            ],
                            "english": "in his/her possession",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "-dé(i) ~ -de(i)",
                            "url": "-dé(i) ~ -de(i)",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "to, toward; until; in the manner of",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "ndutée",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "to another one."
        },
        "67": {
            "startTime": 245.73,
            "endTime": 254.001,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áa",
                    [
                        {
                            "tlingit": "áa",
                            "url": ".áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sits; s/he is sitting",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "áa",
                            "url": "áa",
                            "tags": [
                                "Noun"
                            ],
                            "english": "lake",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daxéexin",
                    [],
                    []
                ],
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "That is how it used to happen long ago."
        },
        "68": {
            "startTime": 254.001,
            "endTime": 256.107,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’as",
                    [],
                    []
                ]
            ],
            "eng": "It didn’t occur"
        },
        "69": {
            "startTime": 256.107,
            "endTime": 257.863,
            "tli": [
                [
                    "tléix’",
                    [],
                    []
                ],
                [
                    "yagee",
                    [
                        {
                            "tlingit": "yagee",
                            "url": "yagee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagee",
                            "url": "yagiyee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagee",
                            "url": "yakyee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "over just"
        },
        "70": {
            "startTime": 257.863,
            "endTime": 264.005,
            "tli": [
                [
                    "yaxíxjin",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "one day – no."
        },
        "71": {
            "startTime": 264.005,
            "endTime": 266.634,
            "tli": [
                [
                    "Nas’k,",
                    [],
                    []
                ],
                [
                    "tsu",
                    [
                        {
                            "tlingit": "tsu",
                            "url": "tsu",
                            "tags": [
                                "Particle"
                            ],
                            "english": "again; still; some more",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "daax’oon",
                    [],
                    []
                ]
            ],
            "eng": "Three, also four"
        },
        "72": {
            "startTime": 266.634,
            "endTime": 271.029,
            "tli": [
                [
                    "yagee",
                    [
                        {
                            "tlingit": "yagee",
                            "url": "yagee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagee",
                            "url": "yagiyee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yagee",
                            "url": "yakyee",
                            "tags": [
                                "Noun",
                                "T"
                            ],
                            "english": "day, afternoon",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "days."
        },
        "73": {
            "startTime": 271.029,
            "endTime": 272.697,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dux̲éx’wjin",
                    [],
                    []
                ]
            ],
            "eng": "They never slept"
        },
        "74": {
            "startTime": 272.697,
            "endTime": 275.207,
            "tli": [
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "long ago."
        },
        "75": {
            "startTime": 275.207,
            "endTime": 276.28,
            "tli": [
                [
                    "Hél",
                    [
                        {
                            "tlingit": "hél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dux̲éx’wjin.",
                    [],
                    []
                ]
            ],
            "eng": "They never slept."
        },
        "76": {
            "startTime": 276.28,
            "endTime": 278.455,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "never",
                    [],
                    []
                ],
                [
                    "slept.",
                    [],
                    []
                ]
            ],
            "eng": "They never slept."
        },
        "77": {
            "startTime": 278.455,
            "endTime": 281.122,
            "tli": [
                [
                    "Aaa.",
                    [],
                    []
                ]
            ],
            "eng": "Yes."
        },
        "78": {
            "startTime": 281.122,
            "endTime": 285.908,
            "tli": [
                [
                    "And",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "And"
        },
        "79": {
            "startTime": 285.908,
            "endTime": 289.076,
            "tli": [
                [
                    "Ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲’éide",
                    [],
                    []
                ],
                [
                    "x̲a.áx̲ji",
                    [],
                    []
                ]
            ],
            "eng": "Hearing it from my father"
        },
        "80": {
            "startTime": 289.076,
            "endTime": 292.951,
            "tli": [
                [
                    "tées’shán",
                    [],
                    []
                ],
                [
                    "ax̲ jeet,",
                    [
                        {
                            "tlingit": "Ax̲ jeet tí!",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_1Sg_"
                            ],
                            "english": "Give it to me!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet shuxíxni",
                            "url": "du jeet shuwaxíx",
                            "tags": [
                                "Verb",
                                "conditional",
                                "__1Sg_"
                            ],
                            "english": "if/when I run out of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet iyatée",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Sg_3_1Sg_"
                            ],
                            "english": "you gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet ag̲atee",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "let him/her give it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet atéeni",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "if/when s/he gives it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet aawatée",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3_1Sg_"
                            ],
                            "english": "s/he gave it to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ jeet yeeytée",
                            "url": "du jeet aawatée",
                            "tags": [
                                "Verb",
                                "perfective",
                                "2Pl_3_1Sg_"
                            ],
                            "english": "you all gave it to me",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "Du jeet tán!",
                            "url": "du jeet aawatán",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "Give it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du jeet .áx̲!",
                            "url": "du jeet aawa.áx̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Give it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du jeet katí!",
                            "url": "du jeet akaawatée",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Give it to him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Yát du jeet tí!",
                            "url": "yát du jeet aawatée",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Get her pregnant!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "Du jeet la.át!",
                            "url": "du jeet awli.át",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg_3_3Sg_"
                            ],
                            "english": "Give them to him/her",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "was like watching it to me,"
        },
        "81": {
            "startTime": 292.951,
            "endTime": 300.178,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "yaag̲ak̲éijin",
                    [],
                    []
                ],
                [
                    "yé",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh.",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "the way my father used to speak."
        },
        "82": {
            "startTime": 300.178,
            "endTime": 305.593,
            "tli": [
                [
                    "And",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "And"
        },
        "83": {
            "startTime": 305.593,
            "endTime": 311.3,
            "tli": [
                [
                    "tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’as",
                    [],
                    []
                ],
                [
                    "koogéiyi",
                    [
                        {
                            "tlingit": "ch'a koogéiyi",
                            "url": "ch'a koogéiyi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "however, any which way",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "x̲’éit",
                    [],
                    []
                ],
                [
                    "dusx̲aayín",
                    [],
                    []
                ]
            ],
            "eng": "they didn’t feel them food"
        },
        "84": {
            "startTime": 311.3,
            "endTime": 312.405,
            "tli": [
                [
                    "atx̲á.",
                    [
                        {
                            "tlingit": "atx̲á",
                            "url": "atx̲á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "food, a meal",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "atx̲a át",
                            "url": "atx̲a át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "moth",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "any old way."
        },
        "85": {
            "startTime": 312.405,
            "endTime": 314.382,
            "tli": [
                [
                    "Tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "No."
        },
        "86": {
            "startTime": 314.382,
            "endTime": 318.973,
            "tli": [
                [
                    "Tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "No."
        },
        "87": {
            "startTime": 318.973,
            "endTime": 325.613,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "ate",
                    [],
                    []
                ],
                [
                    "special",
                    [],
                    []
                ],
                [
                    "things",
                    [],
                    []
                ],
                [
                    "at",
                    [
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at x̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he eats; s/he is eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at gutú",
                            "url": "at gutú",
                            "tags": [
                                "Noun"
                            ],
                            "english": "woods; bush; brush, underbrush",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at katé",
                            "url": "at katé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "bullet",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daná",
                            "url": "at wudináa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he drinks; s/he is drinking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at daayí",
                            "url": "at daayí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "birch",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "special",
                    [],
                    []
                ],
                [
                    "timing.",
                    [],
                    []
                ]
            ],
            "eng": "They ate special things at special timing."
        },
        "88": {
            "startTime": 325.613,
            "endTime": 329.902,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "naxíxjin.",
                    [],
                    []
                ]
            ],
            "eng": "That is how it used to happen."
        },
        "89": {
            "startTime": 329.902,
            "endTime": 332.4,
            "tli": [
                [
                    "Aadéi",
                    [],
                    []
                ],
                [
                    "k̲uwahaayi",
                    [],
                    []
                ],
                [
                    "yé",
                    [
                        {
                            "tlingit": "yé",
                            "url": "yé",
                            "tags": [
                                "Noun"
                            ],
                            "english": "place; way",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "When the moment arrived,"
        },
        "90": {
            "startTime": 332.4,
            "endTime": 343.552,
            "tli": [
                [
                    "á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dux̲áa",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the would eat."
        },
        "91": {
            "startTime": 343.552,
            "endTime": 349.126,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there"
        },
        "92": {
            "startTime": 349.126,
            "endTime": 355.7,
            "tli": [
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shunaxéex",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "when it was ending,"
        },
        "93": {
            "startTime": 355.7,
            "endTime": 361.085,
            "tli": [
                [
                    "hóoch’i",
                    [],
                    []
                ],
                [
                    "aayí",
                    [
                        {
                            "tlingit": "taat aayí adéli",
                            "url": "taat aayí adéli",
                            "tags": [
                                "Noun"
                            ],
                            "english": "night watchman",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gug̲wax̲aayi",
                    [],
                    []
                ],
                [
                    "át",
                    [
                        {
                            "tlingit": "át",
                            "url": "át",
                            "tags": [
                                "Noun"
                            ],
                            "english": "thing",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "the last thing they were going to eat"
        },
        "94": {
            "startTime": 361.085,
            "endTime": 363.961,
            "tli": [
                [
                    "tléik̲w.",
                    [
                        {
                            "tlingit": "tléik̲w",
                            "url": "tléik̲w",
                            "tags": [
                                "Noun"
                            ],
                            "english": "berry, berries",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "were berries."
        },
        "95": {
            "startTime": 363.961,
            "endTime": 371.135,
            "tli": [
                [
                    "Du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’éit",
                    [],
                    []
                ],
                [
                    "dusx̲aayín",
                    [],
                    []
                ],
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "They would feed them that long ago."
        },
        "96": {
            "startTime": 371.135,
            "endTime": 375.908,
            "tli": [
                [
                    "Yéi has awsikóo",
                    [
                        {
                            "tlingit": "yéi (ha)s awsinei",
                            "url": "yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they fixed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Pl__"
                            ],
                            "english": "they were that way; they became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "has awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl_3__"
                            ],
                            "english": "they know it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi has yaawak̲aa",
                            "url": "yéi yaawak̲aa",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they said that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi has jiné",
                            "url": "yéi jeewanei",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they work; they are working",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s k̲uwanóok",
                            "url": "yéi k̲oowanook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they are doing it; they do it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi (ha)s sh tudinook",
                            "url": "yéi sh tuwdinook",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "they feel that way",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wax̲’ahéeni",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They knew that it was their tears"
        },
        "97": {
            "startTime": 375.908,
            "endTime": 379.081,
            "tli": [
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "waak̲dáx̲.",
                    [],
                    []
                ]
            ],
            "eng": "from their eyes."
        },
        "98": {
            "startTime": 379.081,
            "endTime": 382.431,
            "tli": [
                [
                    "Has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "wax̲’ahéeni",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gax̲dux̲aa.",
                    [
                        {
                            "tlingit": "tlél at gax̲dux̲aa",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "4H___"
                            ],
                            "english": "there will be no eating",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They were going to eat their tears."
        },
        "99": {
            "startTime": 382.431,
            "endTime": 386.281,
            "tli": [
                [
                    "Yáadáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hóoch’x̲",
                    [],
                    []
                ],
                [
                    "gux̲satee.",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "From here it will end."
        },
        "100": {
            "startTime": 386.281,
            "endTime": 395.155,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wootee",
                    [
                        {
                            "tlingit": "yéi wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it was that way; he/she/it became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a yáx̲ wootee",
                            "url": "a yáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it was like it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a eetéenáx̲ wootee",
                            "url": "a eetéenáx̲ wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3_"
                            ],
                            "english": "he/she/it needed it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "tleiyéi yéi wootee",
                            "url": "tleiyéi yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "he/she/it became still",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲'éix̲ at wootee",
                            "url": "du x̲'éix̲ at wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg__3Sg_"
                            ],
                            "english": "s/he fed him/her/it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du x̲ánx' yéi wootee",
                            "url": "du x̲ánx' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he stayed with him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du wak̲shiyeex' yéi wootee",
                            "url": "du wak̲shiyeex' yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "he/she/it appeared before him/her",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "has du",
                    [
                        {
                            "tlingit": "has du",
                            "url": "has du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "their [possessive]",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "tutaaní.",
                    [],
                    []
                ]
            ],
            "eng": "That is the how they thoug̲t."
        },
        "101": {
            "startTime": 395.155,
            "endTime": 399.488,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yan has",
                    [
                        {
                            "tlingit": "yan has nák̲ni",
                            "url": "yan has uwanák̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3Pl___"
                            ],
                            "english": "if/when they stand",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has uwahóo",
                            "url": "yan uwahóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they waded ashore",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has sh ul.aatch",
                            "url": "yan has sh wudli.át",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they lie down (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has x̲'awli.át",
                            "url": "yan has x̲'awli.át",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they stopped talking",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has uwanák̲",
                            "url": "yan has uwanák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Pl___"
                            ],
                            "english": "they kept standing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has g̲anaak̲",
                            "url": "yan has uwanák̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Pl___"
                            ],
                            "english": "let them stay standing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yan has unaak̲ch",
                            "url": "yan has uwanák̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3Pl___"
                            ],
                            "english": "they always stay standing",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "woox̲aayi",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there when they finished eating,"
        },
        "102": {
            "startTime": 399.488,
            "endTime": 403.248,
            "tli": [
                [
                    "hóoch’",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "it was done."
        },
        "103": {
            "startTime": 403.248,
            "endTime": 408.598,
            "tli": [
                [
                    "Yáa",
                    [
                        {
                            "tlingit": "yáa",
                            "url": "yá",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "this (right here)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yeedáx̲",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From now,"
        },
        "104": {
            "startTime": 408.598,
            "endTime": 413.066,
            "tli": [
                [
                    "k̲’asgóo",
                    [],
                    []
                ]
            ],
            "eng": "joy"
        },
        "105": {
            "startTime": 413.066,
            "endTime": 416.488,
            "tli": [
                [
                    "g̲unéi",
                    [
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unayéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "beginning",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "g̲unéi",
                            "url": "g̲unéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "start, begin",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "uxíxjin.",
                    [],
                    []
                ]
            ],
            "eng": "used to begin."
        },
        "106": {
            "startTime": 416.488,
            "endTime": 423.182,
            "tli": [
                [
                    "At shook̲.",
                    [
                        {
                            "tlingit": "at shook̲",
                            "url": "at shook̲",
                            "tags": [
                                "Noun"
                            ],
                            "english": "laughter",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "at shook̲",
                            "url": "at wooshook̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he laughs",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "at shook̲",
                            "url": "at uwashúk̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he laughs; s/he is laughing",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "at uchoox̲",
                            "url": "at woochoox̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he is freeloading; s/he freeloads",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at toox̲á",
                            "url": "at uwax̲áa",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "1Pl___"
                            ],
                            "english": "we eat; we are eating",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí k̲óok",
                            "url": "at shí k̲óok",
                            "tags": [
                                "Noun"
                            ],
                            "english": "radio, phonograph, stereo, music box, ipod; any device that plays music",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at k̲asa.ee",
                            "url": "at wusi.ée",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "let me cook",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at shí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "music, singing, song",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at shí",
                            "url": "at wooshee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "s/he sings; s/he is singing",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "at sax̲án",
                            "url": "at sax̲án",
                            "tags": [
                                "Noun"
                            ],
                            "english": "love (of things, of everything)",
                            "exactMatch": false
                        }
                    ]
                ]
            ],
            "eng": "Laug̲ter."
        },
        "107": {
            "startTime": 423.182,
            "endTime": 426.533,
            "tli": [
                [
                    "Ldakát",
                    [
                        {
                            "tlingit": "ldakát",
                            "url": "ldakát",
                            "tags": [
                                "Quantifier"
                            ],
                            "english": "all; every",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "hás",
                    [
                        {
                            "tlingit": "hás",
                            "url": "hás",
                            "tags": [
                                "Adjective"
                            ],
                            "english": "[plural marker for kinship terms]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "hás",
                            "url": "hás2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [independent]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "All of them"
        },
        "108": {
            "startTime": 426.533,
            "endTime": 432.382,
            "tli": [
                [
                    "k’idéin",
                    [],
                    []
                ],
                [
                    "has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ashook̲",
                    [
                        {
                            "tlingit": "ashook̲",
                            "url": "aawashúk̲",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "s/he's laughing at him/her/it",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "would laug̲ heartily."
        },
        "109": {
            "startTime": 432.382,
            "endTime": 435.692,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ]
            ],
            "eng": "That is how it used to be"
        },
        "110": {
            "startTime": 435.692,
            "endTime": 438.293,
            "tli": [
                [
                    "wéi",
                    [
                        {
                            "tlingit": "wéi",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik̲w",
                    [
                        {
                            "tlingit": "tléik̲w",
                            "url": "tléik̲w",
                            "tags": [
                                "Noun"
                            ],
                            "english": "berry, berries",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "when they finished eating"
        },
        "111": {
            "startTime": 438.293,
            "endTime": 447.811,
            "tli": [
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dux̲áayi",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "berries."
        },
        "112": {
            "startTime": 447.811,
            "endTime": 455.187,
            "tli": [
                [
                    "And",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "And"
        },
        "113": {
            "startTime": 455.187,
            "endTime": 458.199,
            "tli": [
                [
                    "it",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "was",
                    [],
                    []
                ],
                [
                    "very",
                    [],
                    []
                ],
                [
                    "interesting,",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "way,",
                    [],
                    []
                ]
            ],
            "eng": "it was very interesting, the way,"
        },
        "114": {
            "startTime": 458.199,
            "endTime": 462.336,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "know",
                    [],
                    []
                ],
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "lot",
                    [],
                    []
                ],
                [
                    "of",
                    [],
                    []
                ],
                [
                    "people",
                    [],
                    []
                ],
                [
                    "don’t",
                    [],
                    []
                ],
                [
                    "know",
                    [],
                    []
                ],
                [
                    "that,",
                    [],
                    []
                ],
                [
                    "what",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "berries",
                    [],
                    []
                ],
                [
                    "meant.",
                    [],
                    []
                ]
            ],
            "eng": "I know a lot of people don’t know that, what the berries meant."
        },
        "115": {
            "startTime": 462.336,
            "endTime": 466.553,
            "tli": [
                [
                    "It",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "wasn’t",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "to",
                    [
                        {
                            "tlingit": "[does not occur; Natá dé! \"Go to sleep!\" preferred]",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "3_2Sg__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[does not occur; Nayx̲éix'w! \"You all go to sleep!\" preferred]",
                            "url": "táach yax̲ has yawliják̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "3_2Sg__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[does not occur; would use kei nanéek dei \"she's starting to have (labor) pains\"]",
                            "url": "atk'átsk'u aawa.oo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "eat",
                    [],
                    []
                ],
                [
                    "berries.",
                    [],
                    []
                ]
            ],
            "eng": "It wasn’t just to eat berries."
        },
        "116": {
            "startTime": 466.553,
            "endTime": 473.3,
            "tli": [
                [
                    "No,",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "berries",
                    [],
                    []
                ],
                [
                    "was",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "tears",
                    [],
                    []
                ],
                [
                    "of",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "people",
                    [],
                    []
                ],
                [
                    "that",
                    [],
                    []
                ],
                [
                    "were",
                    [],
                    []
                ],
                [
                    "mourning.",
                    [],
                    []
                ]
            ],
            "eng": "No, the berries was the tears of the people that were mourning."
        },
        "117": {
            "startTime": 473.3,
            "endTime": 477.197,
            "tli": [
                [
                    "Hóoch’",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gux̲satee",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "yáa",
                    [
                        {
                            "tlingit": "yáa",
                            "url": "yá",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "this (right here)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "dux̲aayí",
                    [],
                    []
                ],
                [
                    "wé",
                    [
                        {
                            "tlingit": "wé",
                            "url": "wé",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "that (at hand)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik̲w.",
                    [
                        {
                            "tlingit": "tléik̲w",
                            "url": "tléik̲w",
                            "tags": [
                                "Noun"
                            ],
                            "english": "berry, berries",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It was done when they finished eating berries."
        },
        "118": {
            "startTime": 477.197,
            "endTime": 481.322,
            "tli": [
                [
                    "When",
                    [],
                    []
                ],
                [
                    "we’re",
                    [],
                    []
                ],
                [
                    "done",
                    [],
                    []
                ],
                [
                    "eating",
                    [],
                    []
                ],
                [
                    "these",
                    [],
                    []
                ],
                [
                    "berries,",
                    [],
                    []
                ]
            ],
            "eng": "When we’re done eating these berries,"
        },
        "119": {
            "startTime": 481.322,
            "endTime": 484.198,
            "tli": [
                [
                    "it’s",
                    [],
                    []
                ],
                [
                    "buried.",
                    [],
                    []
                ]
            ],
            "eng": "it’s buried."
        },
        "120": {
            "startTime": 484.198,
            "endTime": 487.399,
            "tli": [
                [
                    "Has",
                    [
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "aawaják̲.",
                    [
                        {
                            "tlingit": "aawaják̲",
                            "url": "aawaják̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3Sg__"
                            ],
                            "english": "he/she/it killed him/her/it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "They killed it."
        },
        "121": {
            "startTime": 487.399,
            "endTime": 489.297,
            "tli": [
                [
                    "They",
                    [],
                    []
                ],
                [
                    "kill",
                    [],
                    []
                ],
                [
                    "it",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "and",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "They kill it and"
        },
        "122": {
            "startTime": 489.297,
            "endTime": 492.814,
            "tli": [
                [
                    "from",
                    [],
                    []
                ],
                [
                    "that",
                    [],
                    []
                ],
                [
                    "day",
                    [],
                    []
                ],
                [
                    "on,",
                    [],
                    []
                ]
            ],
            "eng": "from that day on,"
        },
        "123": {
            "startTime": 492.814,
            "endTime": 497.096,
            "tli": [
                [
                    "it’s",
                    [],
                    []
                ],
                [
                    "nothing",
                    [],
                    []
                ],
                [
                    "but",
                    [],
                    []
                ],
                [
                    "fun",
                    [],
                    []
                ],
                [
                    "that",
                    [],
                    []
                ],
                [
                    "goes",
                    [],
                    []
                ],
                [
                    "on.",
                    [],
                    []
                ]
            ],
            "eng": "it’s nothing but fun that goes on."
        },
        "124": {
            "startTime": 497.096,
            "endTime": 501.77,
            "tli": [
                [
                    "And",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "there’s",
                    [],
                    []
                ],
                [
                    "nothing",
                    [],
                    []
                ],
                [
                    "more,",
                    [],
                    []
                ]
            ],
            "eng": "And there’s nothing more,"
        },
        "125": {
            "startTime": 501.77,
            "endTime": 509.858,
            "tli": [
                [
                    "there’s",
                    [],
                    []
                ],
                [
                    "nothing",
                    [],
                    []
                ],
                [
                    "more",
                    [],
                    []
                ],
                [
                    "funnier",
                    [],
                    []
                ],
                [
                    "when",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "Tlingit",
                    [],
                    []
                ],
                [
                    "people",
                    [],
                    []
                ],
                [
                    "told",
                    [],
                    []
                ],
                [
                    "their",
                    [],
                    []
                ],
                [
                    "stuff,",
                    [],
                    []
                ],
                [
                    "in",
                    [],
                    []
                ],
                [
                    "Tlingit.",
                    [],
                    []
                ]
            ],
            "eng": "there’s nothing more funnier when the Tlingit people told their stuff, in Tlingit."
        },
        "126": {
            "startTime": 509.858,
            "endTime": 516.143,
            "tli": [
                [
                    "That’s",
                    [],
                    []
                ],
                [
                    "when",
                    [],
                    []
                ],
                [
                    "everybody",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "laug̲",
                    [],
                    []
                ],
                [
                    "so",
                    [],
                    []
                ],
                [
                    "hard,",
                    [],
                    []
                ]
            ],
            "eng": "That’s when everybody just laug̲ so hard,"
        },
        "127": {
            "startTime": 516.143,
            "endTime": 524.387,
            "tli": [
                [
                    "because",
                    [],
                    []
                ],
                [
                    "it",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "makes",
                    [],
                    []
                ],
                [
                    "it",
                    [
                        {
                            "tlingit": "it started (engine); it ran (engine); it spun (wheel)",
                            "url": "kaawajoox",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "more",
                    [],
                    []
                ],
                [
                    "funny",
                    [],
                    []
                ],
                [
                    "to",
                    [
                        {
                            "tlingit": "[does not occur; Natá dé! \"Go to sleep!\" preferred]",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "3_2Sg__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[does not occur; Nayx̲éix'w! \"You all go to sleep!\" preferred]",
                            "url": "táach yax̲ has yawliják̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "3_2Sg__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[does not occur; would use kei nanéek dei \"she's starting to have (labor) pains\"]",
                            "url": "atk'átsk'u aawa.oo",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "hear",
                    [],
                    []
                ],
                [
                    "in",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "Tlingit",
                    [],
                    []
                ],
                [
                    "language,",
                    [],
                    []
                ]
            ],
            "eng": "because it just makes it more funny to hear in the Tlingit language,"
        },
        "128": {
            "startTime": 524.387,
            "endTime": 527.912,
            "tli": [
                [
                    "when",
                    [],
                    []
                ],
                [
                    "they’re",
                    [],
                    []
                ],
                [
                    "getting",
                    [],
                    []
                ],
                [
                    "the",
                    [
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo (ha)s tuwli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "a daa yoo toowatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg__3_"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "awsi.át'",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo (ha)s x̲'awli.át",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Pl___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "[see repetitive imperfective; it provides both the basic imperfective and repetitive meanings]",
                            "url": "yoo x̲'eiwatán",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg___"
                            ],
                            "english": "",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a káx̲ ag̲aag̲wayeeshín Note: GD: awoog̲aayeeshín has the ya- thematic prefix. straightening out. both OK",
                            "url": "a káx̲ aawayeesh",
                            "tags": [
                                "Verb",
                                "potential_decessive",
                                "3Sg_3_3_"
                            ],
                            "english": "s/he would have pulled it over it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "people",
                    [],
                    []
                ],
                [
                    "that",
                    [],
                    []
                ],
                [
                    "were",
                    [],
                    []
                ],
                [
                    "mourning,",
                    [],
                    []
                ]
            ],
            "eng": "when they’re getting the people that were mourning,"
        },
        "129": {
            "startTime": 527.912,
            "endTime": 536.389,
            "tli": [
                [
                    "back",
                    [],
                    []
                ],
                [
                    "into",
                    [],
                    []
                ],
                [
                    "laug̲ing,",
                    [],
                    []
                ],
                [
                    "being",
                    [],
                    []
                ],
                [
                    "happy,",
                    [],
                    []
                ]
            ],
            "eng": "back into laug̲ing, being happy,"
        },
        "130": {
            "startTime": 536.389,
            "endTime": 542.212,
            "tli": [
                [
                    "society.",
                    [],
                    []
                ]
            ],
            "eng": "society."
        },
        "131": {
            "startTime": 542.212,
            "endTime": 548.679,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ],
                [
                    "ch’áakw.",
                    [],
                    []
                ]
            ],
            "eng": "That is how it used to be long ago."
        },
        "132": {
            "startTime": 548.679,
            "endTime": 553.918,
            "tli": [
                [
                    "Aax̲",
                    [
                        {
                            "tlingit": "aax̲ aawatee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked it up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ axáash",
                            "url": "aax̲ aawaxásh",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he's sawing it off",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ x̲'awdinúk",
                            "url": "aax̲ x̲'awdinúk",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg___3"
                            ],
                            "english": "s/he is hungry for it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei nayísh",
                            "url": "aax̲ kei aawayísh",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he is pulling it out of there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ kei wsidák̲",
                            "url": "kei wusidák̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg__"
                            ],
                            "english": "s/he moved from there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ yéi awsinei",
                            "url": "aax̲ yéi awsinei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__3"
                            ],
                            "english": "s/he picked them up off of it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aax̲ akg̲atee",
                            "url": "aax̲ aawatee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3Sg_3__3"
                            ],
                            "english": "let him/her pick it up off of it",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "yan",
                    [
                        {
                            "tlingit": "yan",
                            "url": "yan~",
                            "tags": [
                                "Adverb",
                                "punctual"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yan~",
                            "url": "yan~",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "ashore, onto ground; to rest",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "shuwaxeexí",
                    [],
                    []
                ],
                [
                    "áwé,",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "From there, when it finished,"
        },
        "133": {
            "startTime": 553.918,
            "endTime": 557.718,
            "tli": [
                [
                    "aag̲áa",
                    [
                        {
                            "tlingit": "aag̲áa",
                            "url": "aag̲áa",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "then, around, after, for",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "then"
        },
        "134": {
            "startTime": 557.718,
            "endTime": 562.282,
            "tli": [
                [
                    "neildé has na.át",
                    [
                        {
                            "tlingit": "kei (ha)s na.át",
                            "url": "áa kei (ha)s uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are going up",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "neildé has agux̲sa.áat",
                            "url": "neil has awsi.át",
                            "tags": [
                                "Verb",
                                "future",
                                "3Sg_3Pl__"
                            ],
                            "english": "s/he will let them in",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa (ha)s na.át",
                            "url": "aadé has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "aadé yaa (ha)s na.át",
                            "url": "át has uwa.át",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are going there",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "áx̲ yei (ha)s na.át",
                            "url": "áx̲ has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___3"
                            ],
                            "english": "they are walking down along it",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲ut kei (ha)s na.át",
                            "url": "k̲ut has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3Pl___"
                            ],
                            "english": "they are getting lost",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yaa (ha)s na.át",
                            "url": "has woo.aat",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3"
                            ],
                            "english": "they are walking",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "neildé",
                            "url": "neil~",
                            "tags": [
                                "Adverb",
                                "allative"
                            ],
                            "english": "inside, into the house, home",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "them [object]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "has",
                            "url": "has2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "they [subject]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "noojéen.",
                    [],
                    []
                ]
            ],
            "eng": "they used to go to the house."
        },
        "135": {
            "startTime": 562.282,
            "endTime": 564.545,
            "tli": [
                [
                    "Yéi",
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "That is how"
        },
        "136": {
            "startTime": 564.545,
            "endTime": 567.028,
            "tli": [
                [
                    "x̲a.áx̲ji",
                    [],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "I heard my father"
        },
        "137": {
            "startTime": 567.028,
            "endTime": 568.863,
            "tli": [
                [
                    "k̲aa",
                    [
                        {
                            "tlingit": "k̲aa x̲'oos",
                            "url": "k̲aa x̲'oos",
                            "tags": [
                                "Noun"
                            ],
                            "english": "foot (measurement)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa s'aatí",
                            "url": "k̲aa s'aatí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "boss",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at óowu",
                            "url": "k̲aa at óowu",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession(s); that which is owned (by them)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa ji.eetí",
                            "url": "k̲aa ji.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "handiwork, handmade crafts",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa daakeidí",
                            "url": "k̲aa daakeidí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "coffin; casket",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa x̲'a.eetí",
                            "url": "k̲aa x̲'a.eetí",
                            "tags": [
                                "Noun"
                            ],
                            "english": "leftovers, food scraps",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "k̲aa at oohéini",
                            "url": "k̲aa at oohéini",
                            "tags": [
                                "Noun"
                            ],
                            "english": "possession; that which is claimed",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kaneegí",
                    [],
                    []
                ]
            ],
            "eng": "tell people"
        },
        "138": {
            "startTime": 568.863,
            "endTime": 570.353,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ]
            ],
            "eng": "the way it was"
        },
        "139": {
            "startTime": 570.353,
            "endTime": 573.48,
            "tli": [
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "with the k̲u.éex’."
        },
        "140": {
            "startTime": 573.48,
            "endTime": 579.679,
            "tli": [
                [
                    "Á",
                    [
                        {
                            "tlingit": "á",
                            "url": "á",
                            "tags": [
                                "Noun"
                            ],
                            "english": "it; that place, time, reason, fact",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "á",
                            "url": "á2",
                            "tags": [
                                "Particle"
                            ],
                            "english": "[puts focus on preceding phrase]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "k̲wá",
                    [],
                    []
                ],
                [
                    "tlél",
                    [
                        {
                            "tlingit": "tlél",
                            "url": "tléil",
                            "tags": [
                                "Particle"
                            ],
                            "english": "no, none, not",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲wasateenín",
                    [],
                    []
                ],
                [
                    "–",
                    [
                        {
                            "tlingit": "(ch'a sh daa ak̲adalóox' (dé)",
                            "url": "sh daa awdilúx'",
                            "tags": [
                                "Verb",
                                "hortative",
                                "1Sg___"
                            ],
                            "english": "(just) let me pee myself (now)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "tléik’.",
                    [],
                    []
                ]
            ],
            "eng": "But I never saw it – no."
        },
        "141": {
            "startTime": 579.679,
            "endTime": 583.202,
            "tli": [
                [
                    "Ch’as",
                    [],
                    []
                ],
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "jeedáx̲",
                    [],
                    []
                ],
                [
                    "áwé.",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "It is only from him."
        },
        "142": {
            "startTime": 583.202,
            "endTime": 586.561,
            "tli": [
                [
                    "Ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "du",
                    [
                        {
                            "tlingit": "du",
                            "url": "du",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "his/her [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’usx̲án",
                    [],
                    []
                ],
                [
                    "g̲anoogún",
                    [],
                    []
                ]
            ],
            "eng": "I always sat at"
        },
        "143": {
            "startTime": 586.561,
            "endTime": 589.64,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éesh.",
                    [
                        {
                            "tlingit": "du éesh",
                            "url": "du éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "his/her father",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "náaw éesh",
                            "url": "náaw éesh",
                            "tags": [
                                "Noun"
                            ],
                            "english": "alcoholic",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "my father’s feet."
        },
        "144": {
            "startTime": 589.64,
            "endTime": 593.331,
            "tli": [
                [
                    "Hóoch",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ch’a",
                    [],
                    []
                ],
                [
                    "tlákw",
                    [
                        {
                            "tlingit": "tlákw",
                            "url": "tlákw",
                            "tags": [
                                "Particle"
                            ],
                            "english": "always, all the time, constantly",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "He always"
        },
        "145": {
            "startTime": 593.331,
            "endTime": 595.588,
            "tli": [
                [
                    "yéi x̲at",
                    [
                        {
                            "tlingit": "yéi x̲at yatee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Sg__"
                            ],
                            "english": "I'm that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at woonei",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Sg__"
                            ],
                            "english": "that happened to me",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at tuwatee",
                            "url": "yéi tuwatee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "_1Sg__"
                            ],
                            "english": "I feel like doing that",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at wootee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_1Sg__"
                            ],
                            "english": "I was that way; I became that way",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at nateech",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Sg__"
                            ],
                            "english": "I'm that way (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at naneich",
                            "url": "yéi woonei",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "_1Sg__"
                            ],
                            "english": "that happens to me (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "yéi x̲at nag̲atee",
                            "url": "yéi wootee",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_1Sg__"
                            ],
                            "english": "let me be that way, leave me be",
                            "exactMatch": false
                        }
                    ],
                    [
                        {
                            "tlingit": "yéi",
                            "url": "yei",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "down; out of boat, vehicle",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yéi",
                            "url": "yéi",
                            "tags": [
                                "Adverb"
                            ],
                            "english": "thus, specifically",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "x̲at",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ]
                ],
                [
                    "k̲aayín,",
                    [],
                    []
                ]
            ],
            "eng": "said to me,"
        },
        "146": {
            "startTime": 595.588,
            "endTime": 597.368,
            "tli": [
                [
                    "“K̲udax̲gahaa,",
                    [],
                    []
                ]
            ],
            "eng": "“K̲udax̲gahaa,"
        },
        "147": {
            "startTime": 597.368,
            "endTime": 600.366,
            "tli": [
                [
                    "haagú.",
                    [],
                    []
                ]
            ],
            "eng": "come here."
        },
        "148": {
            "startTime": 600.366,
            "endTime": 607.286,
            "tli": [
                [
                    "Yáa",
                    [
                        {
                            "tlingit": "yáa",
                            "url": "yá",
                            "tags": [
                                "Demonstrative"
                            ],
                            "english": "this (right here)",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "x̲’usx̲ánx’",
                    [],
                    []
                ],
                [
                    "g̲anú.”",
                    [
                        {
                            "tlingit": "G̲anú!",
                            "url": "woonook",
                            "tags": [
                                "Verb",
                                "imperative",
                                "2Sg___"
                            ],
                            "english": "Sit down!",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "Sit at my feet.”"
        },
        "149": {
            "startTime": 607.286,
            "endTime": 609.797,
            "tli": [
                [
                    "Ax’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "I would"
        },
        "150": {
            "startTime": 609.797,
            "endTime": 612.873,
            "tli": [
                [
                    "táach",
                    [
                        {
                            "tlingit": "táach ják̲ni",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "3_3Sg__"
                            ],
                            "english": "if/when s/he falls asleep",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach yax̲ has yawliják̲",
                            "url": "táach yax̲ has yawliják̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3_3Sg__"
                            ],
                            "english": "they fell asleep",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach ják̲x̲",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "repetitive_imperfective",
                                "3_3Sg__"
                            ],
                            "english": "s/he falls asleep (regularly)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach uwaják̲",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3_3Sg__"
                            ],
                            "english": "s/he fell asleep",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach g̲ajaak̲",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "3_3Sg__"
                            ],
                            "english": "let him/her fall asleep",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach oojaak̲ch",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "perfective_habitual",
                                "3_3Sg__"
                            ],
                            "english": "s/he falls asleep (every time)",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "táach yaa naják̲",
                            "url": "táach uwaják̲",
                            "tags": [
                                "Verb",
                                "progressive_imperfective",
                                "3_3Sg__"
                            ],
                            "english": "s/he is starting to fall asleep",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "x̲aják̲",
                    [],
                    []
                ],
                [
                    "nuch.",
                    [
                        {
                            "tlingit": "nuch",
                            "url": "nooch",
                            "tags": [
                                "Other"
                            ],
                            "english": "always; [auxiliary]",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "fall asleep there."
        },
        "151": {
            "startTime": 612.873,
            "endTime": 617.343,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "always",
                    [],
                    []
                ],
                [
                    "fell",
                    [],
                    []
                ],
                [
                    "asleep",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "sitting",
                    [],
                    []
                ],
                [
                    "by",
                    [],
                    []
                ],
                [
                    "his",
                    [],
                    []
                ],
                [
                    "feet.",
                    [],
                    []
                ]
            ],
            "eng": "I always fell asleep just sitting by his feet."
        },
        "152": {
            "startTime": 617.343,
            "endTime": 622.302,
            "tli": [
                [
                    "I",
                    [
                        {
                            "tlingit": "i",
                            "url": "i",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (singular) [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "fall",
                    [],
                    []
                ],
                [
                    "asleep",
                    [],
                    []
                ],
                [
                    "leaning",
                    [],
                    []
                ],
                [
                    "by",
                    [],
                    []
                ],
                [
                    "his",
                    [],
                    []
                ],
                [
                    "feet.",
                    [],
                    []
                ]
            ],
            "eng": "I fall asleep leaning by his feet."
        },
        "153": {
            "startTime": 622.302,
            "endTime": 627.563,
            "tli": [
                [
                    "I’m",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "little",
                    [],
                    []
                ],
                [
                    "boy,",
                    [],
                    []
                ],
                [
                    "three,",
                    [],
                    []
                ],
                [
                    "two,",
                    [],
                    []
                ],
                [
                    "three",
                    [],
                    []
                ],
                [
                    "years",
                    [],
                    []
                ],
                [
                    "old.",
                    [],
                    []
                ]
            ],
            "eng": "I’m just a little boy, three, two, three years old."
        },
        "154": {
            "startTime": 627.563,
            "endTime": 633.353,
            "tli": [
                [
                    "I’m",
                    [],
                    []
                ],
                [
                    "just",
                    [],
                    []
                ],
                [
                    "like",
                    [],
                    []
                ],
                [
                    "a",
                    [
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "baby",
                    [],
                    []
                ],
                [
                    "yet.",
                    [],
                    []
                ]
            ],
            "eng": "I’m just like a baby yet."
        },
        "155": {
            "startTime": 633.353,
            "endTime": 639.749,
            "tli": [
                [
                    "Hóoch",
                    [
                        {
                            "tlingit": "Hóoch!",
                            "url": "Hóoch!",
                            "tags": [
                                "Interjection"
                            ],
                            "english": "That's all!; All gone!; No more!; All done!",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awsikóo",
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "He knew"
        },
        "156": {
            "startTime": 639.749,
            "endTime": 643.322,
            "tli": [
                [
                    "aadóo",
                    [
                        {
                            "tlingit": "ch'a aadóo sá",
                            "url": "ch'a aa sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ch'a aadóo sá",
                            "url": "ch'a aadóo sá",
                            "tags": [
                                "Noun"
                            ],
                            "english": "anyone, anybody; whoever",
                            "exactMatch": false
                        }
                    ],
                    []
                ],
                [
                    "sáwé",
                    [],
                    []
                ],
                [
                    "x̲at",
                    [
                        {
                            "tlingit": "x̲at",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "gux̲satee",
                    [
                        {
                            "tlingit": "tlél (noun)-x̲ gux̲satee",
                            "url": "(noun)-x̲ wusitee",
                            "tags": [
                                "Verb",
                                "future_negative",
                                "_3Sg__3"
                            ],
                            "english": "s/he won't be a (noun)",
                            "exactMatch": false
                        }
                    ],
                    []
                ]
            ],
            "eng": "who I would become"
        },
        "157": {
            "startTime": 643.322,
            "endTime": 647.782,
            "tli": [
                [
                    "x̲at",
                    [
                        {
                            "tlingit": "x̲at",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "wuwáadi.",
                    [],
                    []
                ]
            ],
            "eng": "when I grew up."
        },
        "158": {
            "startTime": 647.782,
            "endTime": 654.126,
            "tli": [
                [
                    "Áx’",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "a daat",
                    [
                        {
                            "tlingit": "a daat",
                            "url": "a daa",
                            "tags": [
                                "RelationalNoun",
                                "punctual"
                            ],
                            "english": "about it; around it",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "a daat",
                            "url": "a daat",
                            "tags": [
                                "Noun"
                            ],
                            "english": "(telling) about it",
                            "exactMatch": true
                        }
                    ],
                    [
                        {
                            "tlingit": "du daat yawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_3Sg_3Sg_"
                            ],
                            "english": "s/he is taking care of him/her; s/he took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "ax̲ daat át k̲udzitee",
                            "url": "du daat át k̲oowdzitee",
                            "tags": [
                                "Verb",
                                "imperfective",
                                "__1Sg_"
                            ],
                            "english": "I'm busy",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "a",
                            "url": "a",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "its [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "du daat yasták̲ni",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "conditional",
                                "_3Sg_3Sg_"
                            ],
                            "english": "if/when s/he takes care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "Du daat iyasaták̲!",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "imperative",
                                "_2Sg_3Sg_"
                            ],
                            "english": "Take care of him/her!",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat iyawsiták̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "perfective",
                                "_2Sg_3Sg_"
                            ],
                            "english": "you are taking care of him/her; you took care of him/her",
                            "exactMatch": false
                        },
                        {
                            "tlingit": "du daat yax̲sataak̲",
                            "url": "du daat yawsiták̲",
                            "tags": [
                                "Verb",
                                "hortative",
                                "_3Sg_3Sg_"
                            ],
                            "english": "let him/her take care of him/her",
                            "exactMatch": false
                        }
                    ]
                ],
                [
                    "x̲’ax̲aataan",
                    [],
                    []
                ]
            ],
            "eng": "That is what I am talking about,"
        },
        "159": {
            "startTime": 654.126,
            "endTime": 659.449,
            "tli": [
                [
                    "ax̲",
                    [
                        {
                            "tlingit": "ax̲",
                            "url": "ax̲",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "my [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "ax̲",
                            "url": "x̲at",
                            "tags": [
                                "Pronoun",
                                "An"
                            ],
                            "english": "me [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "éeshch",
                    [],
                    []
                ],
                [
                    "áwé",
                    [
                        {
                            "tlingit": "áwé",
                            "url": "áwé",
                            "tags": [
                                "Particle"
                            ],
                            "english": "that (at hand) [focus]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "awsikóo",
                    [
                        {
                            "tlingit": "awsikóo",
                            "url": "awsikóo",
                            "tags": [
                                "Verb",
                                "perfective",
                                "3Sg_3__"
                            ],
                            "english": "s/he knows it",
                            "exactMatch": true
                        }
                    ],
                    []
                ]
            ],
            "eng": "what my father knew,"
        },
        "160": {
            "startTime": 659.449,
            "endTime": 662.547,
            "tli": [
                [
                    "yee",
                    [
                        {
                            "tlingit": "yee",
                            "url": "yee",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "your (plural) [possessive]",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "yee",
                            "url": "yee2",
                            "tags": [
                                "Pronoun"
                            ],
                            "english": "you (plural) [object]",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "een",
                    [
                        {
                            "tlingit": "een",
                            "url": "een",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "teen",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        },
                        {
                            "tlingit": "een",
                            "url": "tin",
                            "tags": [
                                "Postposition"
                            ],
                            "english": "(along) with, by means of; as soon as",
                            "exactMatch": true
                        }
                    ],
                    []
                ],
                [
                    "kakk̲waneegí",
                    [],
                    []
                ]
            ],
            "eng": "what I will tell you,"
        },
        "161": {
            "startTime": 662.547,
            "endTime": 664.946,
            "tli": [
                [
                    "aadéi",
                    [],
                    []
                ],
                [
                    "atéeyin",
                    [],
                    []
                ]
            ],
            "eng": "the way the k̲u.éex’"
        },
        "162": {
            "startTime": 664.946,
            "endTime": 667.744,
            "tli": [
                [
                    "k̲u.éex’.",
                    [],
                    []
                ]
            ],
            "eng": "used to be."
        }
    }
};